<div class="overlay" *ngIf="ShowConfirmationQuestion || ShowOrderCancelation || ShowOrderCopy || ShowEditContainer || ShowConvertToOfferConfirmation || ShowGeneratePOConfirmation || ShowChangePartnerConfirmation;"></div>

<!-- ✅ Bulk Best Price Progress Overlay (SignalR real-time updates) -->
<div class="BulkBestPriceProgressOverlay" *ngIf="showBulkBestPriceProgress">
  <div class="BulkBestPriceProgressCard">
    <div class="BulkBestPriceProgressHeader">
      <i class="material-icons BulkBestPriceProgressIcon">sell</i>
      <span class="BulkBestPriceProgressTitle">{{ 'BulkBestPriceProcessing' | translate }}</span>
    </div>
    <div class="BulkBestPriceProgressBody">
      <div class="BulkBestPriceProgressBarContainer">
        <div class="BulkBestPriceProgressBar" [style.width.%]="bulkBestPriceProgressPercent"></div>
        <div class="BulkBestPriceProgressBarText">
          <span>{{ bulkBestPriceProgressPercent }}%</span>
          <span>{{ bulkBestPriceProgressCompleted }} / {{ bulkBestPriceProgressTotal }}</span>
        </div>
      </div>
      <div class="BulkBestPriceProgressPercent">{{ bulkBestPriceProgressPercent }}%</div>
      <div class="BulkBestPriceProgressDetail">{{ bulkBestPriceProgressMessage }}</div>
    </div>
  </div>
</div>

<!-- ✅ Bulk Best Price Config Popup -->
<div class="ConvertToOrderConfirmationOverlay" *ngIf="ShowBulkBestPricePopup" (click)="closeBulkBestPricePopup()"></div>
<div class="ConvertToOrderConfirmationPopup animated fadeInDown faster" *ngIf="ShowBulkBestPricePopup" (click)="$event.stopPropagation()">
  <div class="ConvertPopupHeader">
    <div class="ConvertPopupIconWrapper" style="background: linear-gradient(135deg, #ff7a1a 0%, #f60 100%);">
      <i class="material-icons">sell</i>
    </div>
    <div class="ConvertPopupHeaderText">
      <span class="ConvertPopupTitle">{{ 'BulkBestPriceTitle' | translate }}</span>
    </div>
    <i class="material-icons ConvertPopupClose" (click)="closeBulkBestPricePopup()">close</i>
  </div>
  <div class="ConvertPopupBody" style="text-align: left; padding: 16px 20px;">
    <p class="ConvertPopupMessage" style="margin-bottom: 14px;">{{ 'BulkBestPriceDescription' | translate }}</p>

    <!-- Config Status Dropdown -->
    <div style="margin-bottom: 12px;">
      <label style="font-size: 11px; font-weight: 600; color: #1a3a5c; display: block; margin-bottom: 4px;">{{ 'ConfigStatus' | translate }}</label>
      <select style="width: 100%; height: 34px; border: 1px solid #d0e0f5; border-radius: 8px; padding: 0 10px; font-size: 12px; color: #333; background: #fff; outline: none;"
              (change)="selectedBulkConfigStatus = bulkBestPriceConfigStatuses[$event.target.selectedIndex]">
        <option *ngFor="let cs of bulkBestPriceConfigStatuses" [selected]="cs.ID === selectedBulkConfigStatus?.ID">{{ cs.Name }}</option>
      </select>
    </div>

    <!-- Stock Status Dropdown -->
    <div style="margin-bottom: 12px;">
      <label style="font-size: 11px; font-weight: 600; color: #1a3a5c; display: block; margin-bottom: 4px;">{{ 'StockStatus' | translate }}</label>
      <select style="width: 100%; height: 34px; border: 1px solid #d0e0f5; border-radius: 8px; padding: 0 10px; font-size: 12px; color: #333; background: #fff; outline: none;"
              (change)="selectedBulkStockStatus = bulkBestPriceStockStatuses[$event.target.selectedIndex]">
        <option *ngFor="let ss of bulkBestPriceStockStatuses" [selected]="ss.ID === selectedBulkStockStatus?.ID">{{ ss.Name }}</option>
      </select>
    </div>

    <!-- Overwrite Final Sell-Price Toggle -->
    <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 12px; padding: 10px 12px; background: #fff8f0; border: 1px solid #ffe0b2; border-radius: 8px;">
      <label class="MiniToggle" style="flex-shrink: 0;">
        <input type="checkbox" [(ngModel)]="bulkBestPriceOverwriteSellPrice">
        <span class="MiniToggleSlider"></span>
      </label>
      <div style="display: flex; flex-direction: column;">
        <span style="font-size: 11px; font-weight: 600; color: #e65100;">{{ 'OverwriteFinalSellPrice' | translate }}</span>
        <span style="font-size: 10px; color: #888;">{{ 'OverwriteFinalSellPriceDesc' | translate }}</span>
      </div>
    </div>

    <p style="font-size: 11px; color: #888; margin: 0;" *ngIf="!bulkBestPriceOverwriteSellPrice">{{ 'StockInclusionSellPriceNote' | translate }}</p>
  </div>
  <div class="ConvertPopupFooter">
    <button class="ConvertPopupNoBtn" (click)="closeBulkBestPricePopup()">{{ 'Cancel' | translate }}</button>
    <button class="ConvertPopupYesBtn" style="background: linear-gradient(135deg, #ff9500 0%, #f60 100%) !important;" [disabled]="bulkBestPriceLoading" (click)="applyBulkBestPrice()">
      <i class="material-icons" *ngIf="!bulkBestPriceLoading" style="font-size: 16px;">sell</i>
      <mat-spinner *ngIf="bulkBestPriceLoading" diameter="16"></mat-spinner>
      {{ 'BulkBestPrice' | translate }}
    </button>
  </div>
</div>

<!-- ✅ Processing Progress Overlay (SignalR real-time updates) -->
<div class="ProcessingProgressOverlay" *ngIf="ShowProcessingProgress">
  <div class="ProcessingProgressCard">
    <div class="ProcessingProgressHeader">
      <i class="material-icons ProcessingProgressIcon">sync</i>
      <span class="ProcessingProgressTitle">{{ 'ProcessingOrders' | translate }}</span>
    </div>
    <div class="ProcessingProgressBody">
      <!-- Per-batch progress -->
      <div class="ProcessingProgressSectionLabel" *ngIf="ProcessingProgressBatchIndex > 0">
        {{ 'Batch' | translate }} {{ ProcessingProgressBatchIndex }} / {{ ProcessingProgressTotalBatches }}
      </div>
      <div class="ProcessingProgressBarContainer">
        <div class="ProcessingProgressBar" [style.width.%]="ProcessingProgressPercent"></div>
      </div>
      <div class="ProcessingProgressPercent">{{ ProcessingProgressPercent }}%</div>
      <div class="ProcessingProgressStep" *ngIf="ProcessingProgressStepName">
        <span class="ProcessingProgressStepLabel">{{ 'ProcessingStep_' + ProcessingProgressStepName | translate }}</span>
      </div>

      <!-- Overall progress (all batches) -->
      <div class="ProcessingOverallSection" *ngIf="ProcessingProgressTotalBatches > 1">
        <div class="ProcessingProgressSectionLabel ProcessingOverallLabel">{{ 'OverallProgress' | translate }}</div>
        <div class="ProcessingProgressBarContainer ProcessingOverallBarContainer">
          <div class="ProcessingProgressBar ProcessingOverallBar" [style.width.%]="ProcessingOverallPercent"></div>
        </div>
        <div class="ProcessingOverallPercent">{{ ProcessingOverallPercent }}%</div>
      </div>
    </div>
  </div>
</div>

<!-- ✅ Process Orders Batch Review Popup -->
<div class="ProcessOrdersBatchOverlay" *ngIf="ShowProcessOrdersBatchReview" (click)="closeBatchReview()"></div>
<div class="ProcessOrdersBatchPopup animated fadeInDown faster" *ngIf="ShowProcessOrdersBatchReview">
  <div class="BatchPopupHeader">
    <div class="BatchPopupIconWrapper">
      <i class="material-icons">local_shipping</i>
    </div>
    <div class="BatchPopupHeaderText">
      <span class="BatchPopupTitle">{{ 'ReviewProcessBatches' | translate }}</span>
      <span class="BatchPopupSubtitle">{{ ProcessOrdersBatches.length }} {{ 'batches' | translate }}</span>
    </div>
    <i class="material-icons BatchPopupClose" (click)="closeBatchReview()">close</i>
  </div>

  <div class="BatchPopupBody">
    <div class="BatchPopupHint">
      <i class="material-icons">info</i>
      <span>{{ 'DragDropBatchHint' | translate }}</span>
    </div>

    <mat-accordion class="BatchAccordion" multi>
      <mat-expansion-panel *ngFor="let batch of ProcessOrdersBatches; let i = index"
                           [expanded]="batch._expanded"
                           (opened)="batch._expanded = true"
                           (closed)="batch._expanded = false"
                           class="BatchPanel">
        <mat-expansion-panel-header class="BatchPanelHeader">
          <mat-panel-title class="BatchPanelTitle">
            <span class="BatchPartnerName">{{ batch._partnerName || 'Partner #' + batch._partnerID }}</span>
            <span class="BatchBadge">{{ batch.CartItems?.length || 0 }} {{ 'items' | translate }}</span>
            <i class="material-icons BatchSettingsIcon"
               matTooltip="{{ 'GroupingSettings' | translate }}"
               matTooltipClass='neutral-tool-tip-management'
               (click)="openBatchGroupingSettings(batch); $event.stopPropagation();">settings</i>
          </mat-panel-title>
          <mat-panel-description class="BatchPanelDesc">
            <span class="BatchZipCode">{{ 'BatchAddress' | translate }}: {{ batch._city }} {{ batch._zipCode }}</span>
            <span class="BatchServiceType">{{ batch.ShippingDetails?.ShippingServiceType?.Name || 'Standard' }}</span>
            <i class="material-icons BatchRemoveIcon" (click)="removeBatchFromProcessing(batch); $event.stopPropagation();">close</i>
          </mat-panel-description>
        </mat-expansion-panel-header>

        <!-- Grouping Settings Row - Always Visible -->
        <div class="BatchGroupingSettings">
          <div class="BatchGroupingTitle">
            <i class="material-icons">layers</i>
            <span>{{ 'GroupingCriteria' | translate }}</span>
          </div>
          <div class="BatchGroupingToggles">
            <div class="BatchToggleItem" [class.active]="batch.GroupingSettings?.GroupByShippingServiceType">
              <label class="MiniToggle">
                <input type="checkbox" [(ngModel)]="batch.GroupingSettings.GroupByShippingServiceType">
                <span class="MiniToggleSlider"></span>
              </label>
              <span>{{ 'ServiceType' | translate }}</span>
            </div>
            <div class="BatchToggleItem" [class.active]="batch.GroupingSettings?.GroupByShippingAddress">
              <label class="MiniToggle">
                <input type="checkbox" [(ngModel)]="batch.GroupingSettings.GroupByShippingAddress">
                <span class="MiniToggleSlider"></span>
              </label>
              <span>{{ 'Address' | translate }}</span>
            </div>
            <div class="BatchToggleItem" [class.active]="batch.GroupingSettings?.GroupByShippingCompany">
              <label class="MiniToggle">
                <input type="checkbox" [(ngModel)]="batch.GroupingSettings.GroupByShippingCompany">
                <span class="MiniToggleSlider"></span>
              </label>
              <span>{{ 'ShippingCompany' | translate }}</span>
            </div>
            <div class="BatchToggleItem" [class.active]="batch.GroupingSettings?.GroupByCurrency">
              <label class="MiniToggle">
                <input type="checkbox" [(ngModel)]="batch.GroupingSettings.GroupByCurrency">
                <span class="MiniToggleSlider"></span>
              </label>
              <span>{{ 'Currency' | translate }}</span>
            </div>
            <div class="BatchToggleItem" [class.active]="batch.GroupingSettings?.GroupByInvoicingCompany">
              <label class="MiniToggle">
                <input type="checkbox" [(ngModel)]="batch.GroupingSettings.GroupByInvoicingCompany">
                <span class="MiniToggleSlider"></span>
              </label>
              <span>{{ 'InvoicingCompany' | translate }}</span>
            </div>
          </div>
          <div class="BatchRegroupButton"
               [class.disabled]="batch._regrouping"
               (click)="regroupSingleBatch(batch); $event.stopPropagation();">
            <i class="material-icons" *ngIf="!batch._regrouping">refresh</i>
            <mat-spinner *ngIf="batch._regrouping" diameter="14"></mat-spinner>
            <span>{{ 'Regroup' | translate }}</span>
          </div>
        </div>

        <!-- Address Info Row -->
        <div class="BatchAddressRow">
          <div class="BatchAddressBlock BatchAddressBlockFull">
            <span class="BatchAddressLabel">
              {{ 'Receiver' | translate }}
              <i class="material-icons BatchAddressEditBtn" (click)="batch._showAddressSelector = !batch._showAddressSelector; $event.stopPropagation();"
                 matTooltip="{{ 'ChangeAddress' | translate }}" matTooltipClass="neutral-tool-tip-management">arrow_drop_down</i>
            </span>
            <span class="BatchAddressValue">{{ batch.ShippingDetails?.Receiver?.ContactCompany || batch.ShippingDetails?.Receiver?.ContactPerson || '-' }}</span>
            <span class="BatchAddressDetail" *ngIf="batch.ShippingDetails?.Receiver?.Country?.Name">
              {{ batch.ShippingDetails?.Receiver?.Country?.Name }}<ng-container *ngIf="batch.ShippingDetails?.Receiver?.State">, {{ batch.ShippingDetails.Receiver.State }}</ng-container>
            </span>
            <span class="BatchAddressDetail" *ngIf="batch.ShippingDetails?.Receiver?.City || batch.ShippingDetails?.Receiver?.ZipCode">
              {{ batch.ShippingDetails?.Receiver?.City || '' }} {{ batch.ShippingDetails?.Receiver?.ZipCode || '' }}
            </span>
            <span class="BatchAddressDetail" *ngIf="batch.ShippingDetails?.Receiver?.AddressLine">{{ batch.ShippingDetails.Receiver.AddressLine }}</span>
            <span class="BatchAddressDetail BatchAddressPhone" *ngIf="batch.ShippingDetails?.Receiver?.Phone">
              <i class="material-icons">phone</i> {{ batch.ShippingDetails.Receiver.Phone }}
            </span>
            <div class="BatchAddressActions">
              <button class="BatchAddrEditBtn" (click)="openBatchAddressEditor(batch); $event.stopPropagation();">
                <i class="material-icons">edit</i>
                <span>{{ 'Edit' | translate }}</span>
              </button>
            </div>
          </div>
          <i class="material-icons BatchShippingIcon"
             [class.express]="batch.ShippingDetails?.ShippingServiceType?.ID === 1"
             [class.combo]="batch.ShippingDetails?.ShippingServiceType?.ID === 2">
            {{ batch.ShippingDetails?.ShippingServiceType?.ID === 1 ? 'flight' : 'local_shipping' }}
          </i>

          <!-- Address Selector Overlay -->
          <div class="BatchAddressSelectorOverlay" *ngIf="batch._showAddressSelector">
            <div class="SendEmailOverlayTransparent" (click)="batch._showAddressSelector = false"></div>
            <div class="BatchAddressSelectorPanel">
              <div class="BatchAddressSelectorHeader">
                <i class="material-icons">location_on</i>
                <span>{{ 'SelectShippingAddress' | translate }}</span>
                <i class="material-icons BatchAddressSelectorClose" (click)="batch._showAddressSelector = false">close</i>
              </div>
              <div class="BatchAddressSelectorList">
                <div class="BatchAddressSelectorItem"
                     *ngFor="let addr of batch.AvailableShippingAddresses"
                     [class.selected]="batch.ShippingDetails?.Receiver?.ID === addr.ID"
                     (click)="selectBatchAddress(batch, addr)">
                  <i class="material-icons" [style.color]="batch.ShippingDetails?.Receiver?.ID === addr.ID ? '#4caf50' : '#9ca3af'">
                    {{ batch.ShippingDetails?.Receiver?.ID === addr.ID ? 'check_circle' : 'radio_button_unchecked' }}
                  </i>
                  <div class="BatchAddressSelectorItemInfo">
                    <span class="BatchAddrName">{{ addr.ContactCompany || addr.ContactPerson || '-' }}</span>
                    <span class="BatchAddrLine">{{ addr.AddressLine || '' }}</span>
                    <span class="BatchAddrLine">{{ addr.City || '' }} {{ addr.ZipCode || '' }}<ng-container *ngIf="addr.Country?.Name">, {{ addr.Country.Name }}</ng-container></span>
                    <span class="BatchAddrLine" *ngIf="addr.Phone"><i class="material-icons" style="font-size:12px;vertical-align:middle;">phone</i> {{ addr.Phone }}</span>
                  </div>
                </div>
                <div class="BatchAddressSelectorEmpty" *ngIf="!batch.AvailableShippingAddresses || batch.AvailableShippingAddresses.length === 0">
                  {{ 'NoAddressesAvailable' | translate }}
                </div>
              </div>
            </div>
          </div>


        </div>

        <!-- Processing Settings -->
        <div class="BatchProcessingSettings" *ngIf="batch.ProcessingSettings">
          <div class="BatchProcessingHeader">
            <i class="material-icons">tune</i>
            <span>{{ 'ProcessingSettings' | translate }}</span>
            <div class="BatchProcessingSaveBtn"
                 [class.disabled]="batch._savingSettings"
                 (click)="saveBatchProcessingSettings(batch); $event.stopPropagation();">
              <i class="material-icons" *ngIf="!batch._savingSettings">save</i>
              <mat-spinner *ngIf="batch._savingSettings" diameter="14"></mat-spinner>
            </div>
          </div>
          <div class="BatchProcessingToggles">
            <div class="BatchProcessingToggle" matTooltip="{{ 'NotifiesWithAttachmentsDesc' | translate }}" matTooltipClass='neutral-tool-tip-management'>
              <label class="MiniToggle"><input type="checkbox" [(ngModel)]="batch.ProcessingSettings.NotifiesWithAttachments" (change)="refreshBatchNotificationRecipients(batch)"><span class="MiniToggleSlider"></span></label>
              <span>{{ 'NotifiesWithAttachments' | translate }}</span>
            </div>
            <div class="BatchProcessingToggle" matTooltip="{{ 'AutoPrintingDesc' | translate }}" matTooltipClass='neutral-tool-tip-management'>
              <label class="MiniToggle"><input type="checkbox" [(ngModel)]="batch.ProcessingSettings.AutoPrinting"><span class="MiniToggleSlider"></span></label>
              <span>{{ 'AutoPrinting' | translate }}</span>
            </div>
            <div class="BatchProcessingToggle" matTooltip="{{ 'GenerateInvoiceDesc' | translate }}" matTooltipClass='neutral-tool-tip-management'>
              <label class="MiniToggle"><input type="checkbox" [(ngModel)]="batch.ProcessingSettings.GenerateInvoice"><span class="MiniToggleSlider"></span></label>
              <span>{{ 'GenerateInvoice' | translate }}</span>
            </div>
            <div class="BatchProcessingToggle" matTooltip="{{ 'GenerateTrackingLabelDesc' | translate }}" matTooltipClass='neutral-tool-tip-management'>
              <label class="MiniToggle"><input type="checkbox" [(ngModel)]="batch.ProcessingSettings.GenerateTrackingLabel"><span class="MiniToggleSlider"></span></label>
              <span>{{ 'GenerateTrackingLabel' | translate }}</span>
            </div>
            <div class="BatchProcessingToggle" matTooltip="{{ 'SeparateOrderInvoicesDesc' | translate }}" matTooltipClass='neutral-tool-tip-management'>
              <label class="MiniToggle"><input type="checkbox" [(ngModel)]="batch.ProcessingSettings.SeparateOrderInvoices"><span class="MiniToggleSlider"></span></label>
              <span>{{ 'SeparateOrderInvoices' | translate }}</span>
            </div>
            <div class="BatchProcessingToggle" matTooltip="{{ 'GenerateQWCertificateDesc' | translate }}" matTooltipClass='neutral-tool-tip-management'>
              <label class="MiniToggle"><input type="checkbox" [(ngModel)]="batch.ProcessingSettings.GenerateQWCertificate"><span class="MiniToggleSlider"></span></label>
              <span>{{ 'GenerateQWCertificate' | translate }}</span>
            </div>
            <div class="BatchProcessingToggle" matTooltip="{{ 'PrintOnlyDeliveryNoteDesc' | translate }}" matTooltipClass='neutral-tool-tip-management'>
              <label class="MiniToggle"><input type="checkbox" [(ngModel)]="batch.ProcessingSettings.PrintOnlyDeliveryNote"><span class="MiniToggleSlider"></span></label>
              <span>{{ 'PrintOnlyDeliveryNote' | translate }}</span>
            </div>
            <div class="BatchProcessingToggle" matTooltip="{{ 'SendInvoiceOnlyToAccountingDepartmentDesc' | translate }}" matTooltipClass='neutral-tool-tip-management'>
              <label class="MiniToggle"><input type="checkbox" [(ngModel)]="batch.ProcessingSettings.SendInvoiceOnlyToAccountingDepartment"><span class="MiniToggleSlider"></span></label>
              <span>{{ 'SendInvoiceOnlyToAccountingDepartment' | translate }}</span>
            </div>
            <div class="BatchProcessingToggle">
              <label class="MiniToggle"><input type="checkbox" [(ngModel)]="batch.ProcessingSettings.SellThroughPartnerCompany"><span class="MiniToggleSlider"></span></label>
              <span>{{ 'SellThroughPartnerCompany' | translate }}</span>
            </div>
            <div class="BatchProcessingToggle" matTooltip="{{ 'SendEachFileToTheAppropriateDepartmentDesc' | translate }}" matTooltipClass='neutral-tool-tip-management'>
              <label class="MiniToggle"><input type="checkbox" [(ngModel)]="batch.ProcessingSettings.SendEachFileToTheAppropriateDepartment" (change)="refreshBatchNotificationRecipients(batch)"><span class="MiniToggleSlider"></span></label>
              <span>{{ 'SendEachFileToTheAppropriateDepartment' | translate }}</span>
            </div>
          </div>

          <!-- Currency, DecimalPrecision, PartnerCompany, UnpaidTolleranceDays -->
          <div class="BatchProcessingDropdowns">
            <!-- Currency -->
            <div class="BatchProcessingDropdown">
              <div class="CustomDropdownContainer" [class.dropdown-open]="batch._showProcCurrencyDropdown">
                <div class="SendEmailOverlayTransparent" *ngIf="batch._showProcCurrencyDropdown" (click)="batch._showProcCurrencyDropdown = false"></div>
                <div class="CustomDropdownBar BatchDropdownBar" (click)="batch._showProcCurrencyDropdown = !batch._showProcCurrencyDropdown">
                  <i class="material-icons dropdown-icon-left">attach_money</i>
                  <span class="dropdown-label">{{ 'Currency' | translate }}</span>
                  <input type="text" class="CustomDropdownInput" readonly
                         [value]="batch.ProcessingSettings?.Currency?.Name || 'Select...'" />
                  <i class="material-icons dropdown-icon">arrow_drop_down</i>
                </div>
                <div class="CustomDropdownResults" *ngIf="batch._showProcCurrencyDropdown">
                  <div class="CustomDropdownResult" *ngFor="let cur of parent.masterData?.Currencies"
                       (click)="batch.ProcessingSettings.Currency = cur; batch._showProcCurrencyDropdown = false">
                    <div class="CustomDropdownResultMain">
                      <i class="material-icons" [style.color]="batch.ProcessingSettings?.Currency?.ID === cur.ID ? '#4caf50' : '#9ca3af'">
                        {{ batch.ProcessingSettings?.Currency?.ID === cur.ID ? 'check_circle' : 'radio_button_unchecked' }}
                      </i>
                      <span class="CustomDropdownResultText">{{ cur.Name }} ({{ cur.Symbol }})</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- DecimalPrecision -->
            <div class="BatchProcessingDropdown">
              <div class="CustomDropdownContainer" [class.dropdown-open]="batch._showProcPrecisionDropdown">
                <div class="SendEmailOverlayTransparent" *ngIf="batch._showProcPrecisionDropdown" (click)="batch._showProcPrecisionDropdown = false"></div>
                <div class="CustomDropdownBar BatchDropdownBar" (click)="batch._showProcPrecisionDropdown = !batch._showProcPrecisionDropdown">
                  <i class="material-icons dropdown-icon-left">straighten</i>
                  <span class="dropdown-label">{{ 'DecimalPrecision' | translate }}</span>
                  <input type="text" class="CustomDropdownInput" readonly
                         [value]="getDecimalPrecisionMeaning(batch.ProcessingSettings?.DecimalPrecision || batch.ProcessingSettings?.Currency?.DecimalPrecision)" />
                  <i class="material-icons dropdown-icon">arrow_drop_down</i>
                </div>
                <div class="CustomDropdownResults" *ngIf="batch._showProcPrecisionDropdown">
                  <div class="CustomDropdownResult" *ngFor="let dp of decimalPrecisionOptions"
                       (click)="selectBatchDecimalPrecision(batch, dp)">
                    <div class="CustomDropdownResultMain">
                      <i class="material-icons" [style.color]="(batch.ProcessingSettings?.DecimalPrecision?.ID || batch.ProcessingSettings?.Currency?.DecimalPrecision?.ID) === dp.ID ? '#4caf50' : '#9ca3af'">
                        {{ (batch.ProcessingSettings?.DecimalPrecision?.ID || batch.ProcessingSettings?.Currency?.DecimalPrecision?.ID) === dp.ID ? 'check_circle' : 'radio_button_unchecked' }}
                      </i>
                      <span class="CustomDropdownResultText">{{ dp.Meaning }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- PartnerCompany (only visible when SellThroughPartnerCompany is true) -->
            <div class="BatchProcessingDropdown" *ngIf="batch.ProcessingSettings?.SellThroughPartnerCompany">
              <div class="CustomDropdownContainer" [class.dropdown-open]="batch._showProcCompanyDropdown">
                <div class="SendEmailOverlayTransparent" *ngIf="batch._showProcCompanyDropdown" (click)="batch._showProcCompanyDropdown = false"></div>
                <div class="CustomDropdownBar BatchDropdownBar" (click)="batch._showProcCompanyDropdown = !batch._showProcCompanyDropdown">
                  <i class="material-icons dropdown-icon-left">business</i>
                  <span class="dropdown-label">{{ 'PartnerCompany' | translate }}</span>
                  <input type="text" class="CustomDropdownInput" readonly
                         [value]="batch.ProcessingSettings?.PartnerCompany?.Name || 'Select...'" />
                  <i class="material-icons dropdown-icon">arrow_drop_down</i>
                </div>
                <div class="CustomDropdownResults" *ngIf="batch._showProcCompanyDropdown">
                  <div class="CustomDropdownResult" *ngFor="let comp of getSlaveCompanies()"
                       (click)="batch.ProcessingSettings.PartnerCompany = comp; batch._showProcCompanyDropdown = false">
                    <div class="CustomDropdownResultMain">
                      <i class="material-icons" [style.color]="batch.ProcessingSettings?.PartnerCompany?.ID === comp.ID ? '#4caf50' : '#9ca3af'">
                        {{ batch.ProcessingSettings?.PartnerCompany?.ID === comp.ID ? 'check_circle' : 'radio_button_unchecked' }}
                      </i>
                      <span class="CustomDropdownResultText">{{ comp.Name }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- UnpaidTolleranceDays (read-only) -->
            <div class="BatchProcessingReadonly">
              <i class="material-icons">schedule</i>
              <span class="BatchReadonlyLabel">{{ 'UnpaidTolleranceDays' | translate }}:</span>
              <span class="BatchReadonlyValue">{{ batch.ProcessingSettings?.UnpaidTolleranceDays || 10 }} {{ 'Days' | translate }}</span>
            </div>
          </div>
        </div>

        <!-- Contractual Conditions (read-only info from partner) -->
        <div class="BatchContractualConditions" *ngIf="batch.ContractualConditions">
          <div class="BatchContractualHeader">
            <i class="material-icons">handshake</i>
            <span>{{ 'ContractualConditions' | translate }}</span>
          </div>
          <div class="BatchContractualChips">
            <span class="BatchContractualChip" *ngIf="batch.ContractualConditions?.SellPaymentTerms">
              <i class="material-icons">schedule</i> {{ 'SellPaymentTerms' | translate }}: {{ batch.ContractualConditions.SellPaymentTerms.Name }}
            </span>
            <span class="BatchContractualChip" *ngIf="batch.ContractualConditions?.PaymentType">
              <i class="material-icons">payment</i> {{ 'PaymentType' | translate }}: {{ batch.ContractualConditions.PaymentType.Name }}
            </span>
            <span class="BatchContractualChip" *ngIf="batch.ContractualConditions?.ShippingResponsability">
              <i class="material-icons">assignment_ind</i> {{ 'ShippingResponsability' | translate }}: {{ batch.ContractualConditions.ShippingResponsability.Name }}
            </span>
            <span class="BatchContractualChip" *ngIf="batch.ContractualConditions?.ShippingCompany">
              <i class="material-icons">local_shipping</i> {{ 'ShippingCompany' | translate }}: {{ batch.ContractualConditions.ShippingCompany.Name }}
            </span>
            <span class="BatchContractualChip" *ngIf="batch.ContractualConditions?.ShippingServiceType">
              <i class="material-icons">speed</i> {{ 'ShippingServiceType' | translate }}: {{ batch.ContractualConditions.ShippingServiceType.Name }}
            </span>
          </div>
        </div>

        <!-- Cart Items List with Drag-Drop -->
        <div class="BatchItemsList"
             cdkDropList
             [id]="batch._batchId"
             [cdkDropListData]="batch.CartItems"
             [cdkDropListConnectedTo]="getConnectedDropLists(batch)"
             (cdkDropListDropped)="onBatchItemDrop($event, batch)">
          <div class="BatchItem" *ngFor="let item of batch.CartItems" cdkDrag>
            <div class="BatchItemDragHandle" cdkDragHandle>
              <i class="material-icons">drag_indicator</i>
            </div>
            <div class="BatchItemInfoCompact">
              <div class="BatchItemRow">
                <span class="BatchItemBrand">{{ item.Product?.Brand?.Name || '' }}</span>
                <span class="BatchItemName">{{ item.Product?.Name || '' }}</span>
                <span class="BatchItemPartNumber">{{ item.Product?.PartNumber || '' }}</span>
                <span class="BatchItemPrice">{{ item.Quantity }} × {{ item.Price?.UIUnitPrice || '' }} = {{ item.Price?.UIQtyPrice || '' }} {{ item.SelectedOffer?.Currency?.Symbol || '' }}</span>
              </div>
              <div class="BatchItemRow">
                <span class="BatchItemRef">{{ item.CartItemOrderInfo?.ReferenceNumber || '-' }}</span>
                <span class="BatchItemDebatorPO" *ngIf="item.CartItemOrderInfo?.DebatorPO">{{ item.CartItemOrderInfo.DebatorPO }}</span>
                <span class="BatchItemDate" *ngIf="item.CartItemOrderInfo?.OrderEventRegister">{{ item.CartItemOrderInfo.OrderEventRegister | date:'dd MMM yy' }}</span>
              </div>
            </div>
            <div class="BatchItemRemove" (click)="removeItemFromBatch(batch, item); $event.stopPropagation()">
              <i class="material-icons">close</i>
            </div>
          </div>
          <!-- Shipping Settings (above Parcels) -->
          <div class="BatchShippingSettings">
            <div class="BatchSettingGroup">
              <div class="CustomDropdownContainer" [class.dropdown-open]="batch._showServiceTypeDropdown">
                <div class="SendEmailOverlayTransparent" *ngIf="batch._showServiceTypeDropdown" (click)="batch._showServiceTypeDropdown = false"></div>
                <div class="CustomDropdownBar" (click)="batch._showServiceTypeDropdown = !batch._showServiceTypeDropdown">
                  <span class="dropdown-label">{{ 'ShippingService' | translate }}</span>
                  <i class="material-icons dropdown-icon-left">speed</i>
                  <input type="text" class="CustomDropdownInput" readonly
                         [class.placeholder]="!batch.ShippingDetails?.ShippingServiceType"
                         [value]="batch.ShippingDetails?.ShippingServiceType?.Name || 'Select...'" />
                  <i class="material-icons dropdown-icon">arrow_drop_down</i>
                </div>
                <div class="CustomDropdownResults" *ngIf="batch._showServiceTypeDropdown">
                  <div class="CustomDropdownResult" *ngFor="let svc of getBatchAvailableServiceTypes(batch)" (click)="batch.ShippingDetails.ShippingServiceType = svc; batch._showServiceTypeDropdown = false">
                    <div class="CustomDropdownResultMain">
                      <i class="material-icons" [style.color]="batch.ShippingDetails?.ShippingServiceType?.ID === svc.ID ? '#4caf50' : '#9ca3af'">
                        {{ batch.ShippingDetails?.ShippingServiceType?.ID === svc.ID ? 'check_circle' : 'radio_button_unchecked' }}
                      </i>
                      <span class="CustomDropdownResultText">{{ svc.Name }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="BatchSettingGroup">
              <div class="CustomDropdownContainer" [class.dropdown-open]="batch._showCompanyDropdown">
                <div class="SendEmailOverlayTransparent" *ngIf="batch._showCompanyDropdown" (click)="batch._showCompanyDropdown = false"></div>
                <div class="CustomDropdownBar" (click)="batch._showCompanyDropdown = !batch._showCompanyDropdown">
                  <span class="dropdown-label">{{ 'ShippingCompany' | translate }}</span>
                  <i class="material-icons dropdown-icon-left">local_shipping</i>
                  <input type="text" class="CustomDropdownInput" readonly
                         [class.placeholder]="!batch.ShippingDetails?.ShippingCompany"
                         [value]="batch.ShippingDetails?.ShippingCompany?.Name || 'Select...'" />
                  <i class="material-icons dropdown-icon">arrow_drop_down</i>
                </div>
                <div class="CustomDropdownResults" *ngIf="batch._showCompanyDropdown">
                  <div class="CustomDropdownResult" *ngFor="let comp of (batch.AvailableShippingCompanies?.length > 0 ? batch.AvailableShippingCompanies : ShippingCompanies)" (click)="batch.ShippingDetails.ShippingCompany = comp; batch._showCompanyDropdown = false">
                    <div class="CustomDropdownResultMain">
                      <i class="material-icons" [style.color]="batch.ShippingDetails?.ShippingCompany?.ID === comp.ID ? '#4caf50' : '#9ca3af'">
                        {{ batch.ShippingDetails?.ShippingCompany?.ID === comp.ID ? 'check_circle' : 'radio_button_unchecked' }}
                      </i>
                      <span class="CustomDropdownResultText">{{ comp.Name }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="BatchSettingGroup">
              <div class="CustomDropdownContainer" [class.dropdown-open]="batch._showResponsabilityDropdown">
                <div class="SendEmailOverlayTransparent" *ngIf="batch._showResponsabilityDropdown" (click)="batch._showResponsabilityDropdown = false"></div>
                <div class="CustomDropdownBar" (click)="batch._showResponsabilityDropdown = !batch._showResponsabilityDropdown">
                  <span class="dropdown-label">{{ 'ShippingResponsability' | translate }}</span>
                  <i class="material-icons dropdown-icon-left">assignment_ind</i>
                  <input type="text" class="CustomDropdownInput" readonly
                         [class.placeholder]="!batch.ShippingDetails?.ShippingResponsability"
                         [value]="batch.ShippingDetails?.ShippingResponsability?.Name || 'Select...'" />
                  <i class="material-icons dropdown-icon">arrow_drop_down</i>
                </div>
                <div class="CustomDropdownResults" *ngIf="batch._showResponsabilityDropdown">
                  <div class="CustomDropdownResult" *ngFor="let resp of ShippingResponsabilities" (click)="batch.ShippingDetails.ShippingResponsability = resp; batch._showResponsabilityDropdown = false">
                    <div class="CustomDropdownResultMain">
                      <i class="material-icons" [style.color]="batch.ShippingDetails?.ShippingResponsability?.ID === resp.ID ? '#4caf50' : '#9ca3af'">
                        {{ batch.ShippingDetails?.ShippingResponsability?.ID === resp.ID ? 'check_circle' : 'radio_button_unchecked' }}
                      </i>
                      <span class="CustomDropdownResultText">{{ resp.Name }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Parcels Section (matching shipment design) -->
          <div class="BatchBoxesSection">
            <div class="BatchBoxesHeader">
              <span class="BatchBoxesTitle">
                <i class="material-icons" style="font-size:16px;vertical-align:middle;margin-right:4px;">inventory_2</i>
                {{ 'Parcels' | translate }} ({{ batch.ShippingDetails?.Boxes?.length || 0 }})
              </span>
              <div class="GridCommandButton" style="height:28px;line-height:28px;font-size:11px;padding:0 10px;" (click)="addBatchBox(batch); $event.stopPropagation();">
                <i class="material-icons" style="font-size:14px;">add</i>
                <span>{{ 'AddNewParcel' | translate }}</span>
              </div>
            </div>

            <div class="ParcelContainerHeadder" *ngIf="batch.ShippingDetails?.Boxes?.length > 0">
              <div class="ParcelIndexHeadder"><span>#</span></div>
              <div class="ParcelMultiplyHeadder"><span>{{ 'Multiply' | translate }}</span></div>
              <div class="ParcelDimentionHeadder"><span>{{ 'Length' | translate }}</span></div>
              <i class="material-icons BetweenDimentionsX">close</i>
              <div class="ParcelDimentionHeadder"><span>{{ 'Width' | translate }}</span></div>
              <i class="material-icons BetweenDimentionsX">close</i>
              <div class="ParcelDimentionHeadder"><span>{{ 'Height' | translate }}</span></div>
              <i class="material-icons BetweenDimentionsX" style="line-height: 35px;">minimize</i>
              <div class="ParcelDimentionHeadder"><span>{{ 'Weight' | translate }}</span></div>
            </div>

            <div class="ParcelContainer" *ngFor="let box of batch.ShippingDetails?.Boxes; let bIdx = index;" style="border-bottom: solid 1px #ddd;">
              <div class="ParcelIndex">
                <i class="material-icons" *ngIf="batch.ShippingDetails?.ShippingServiceType?.ID == -1;">local_shipping</i>
                <i class="material-icons" *ngIf="batch.ShippingDetails?.ShippingServiceType?.ID == 1;">flight_takeoff</i>
                <span style="float: left;">{{'Parcel' | translate}}</span>
                <span style="float: left;">#{{bIdx + 1}}</span>
              </div>

              <div class="ParcelMultiplyContainer">
                <input type="number" min="1" max="10" class="ParcelMultiplyInput" [(ngModel)]="box._multiplyFactor" placeholder="1" (click)="$event.target.select(); $event.stopPropagation();" (blur)="multiplyBatchBox(batch, box, bIdx)" (keydown.enter)="$event.target.blur();" (keydown.tab)="multiplyBatchBox(batch, box, bIdx)">
                <i class="material-icons ParcelMultiplyIcon" (click)="multiplyBatchBox(batch, box, bIdx)" title="{{'Multiply' | translate}}">close</i>
              </div>

              <mat-form-field appearance="outline" class="ParcelDimention">
                <mat-label>{{ 'Length' | translate }}*</mat-label>
                <input matInput placeholder="{{'Length' | translate}}" autocomplete="off" [(ngModel)]="box.Length" (click)="$event.target.select(); $event.stopPropagation();">
              </mat-form-field>

              <i class="material-icons BetweenDimentionsX">close</i>

              <mat-form-field appearance="outline" class="ParcelDimention">
                <mat-label>{{ 'Width' | translate }}*</mat-label>
                <input matInput placeholder="{{'Width' | translate}}" autocomplete="off" [(ngModel)]="box.Width" (click)="$event.target.select(); $event.stopPropagation();">
              </mat-form-field>

              <i class="material-icons BetweenDimentionsX">close</i>

              <mat-form-field appearance="outline" class="ParcelDimention">
                <mat-label>{{ 'Height' | translate }}*</mat-label>
                <input matInput placeholder="{{'Height' | translate}}" autocomplete="off" [(ngModel)]="box.Height" (click)="$event.target.select(); $event.stopPropagation();">
              </mat-form-field>

              <i class="material-icons BetweenDimentionsX" style="line-height: 35px;">minimize</i>

              <mat-form-field appearance="outline" class="ParcelDimention">
                <mat-label>{{ 'Weight' | translate }}*</mat-label>
                <input matInput placeholder="{{'Weight' | translate}}" autocomplete="off" [(ngModel)]="box.Weight" (click)="$event.target.select(); $event.stopPropagation();">
              </mat-form-field>

              <i class="material-icons ParcelDeleteIcon" (click)="removeBatchBox(batch, bIdx); $event.stopPropagation();">remove_circle_outline</i>
            </div>
          </div>

          <!-- Shipping Costs Section -->
          <div class="BatchShippingCostsSection">
            <div class="BatchBoxesHeader">
              <span class="BatchBoxesTitle">
                <i class="material-icons" style="font-size:16px;vertical-align:middle;margin-right:4px;">payments</i>
                {{ 'ShippingCost' | translate }} ({{ batch.ShippingCosts?.length || 0 }})
              </span>
              <div style="display:flex;align-items:center;gap:6px;">
                <div class="GridCommandButton BatchSimulateCostBtn" style="height:28px;line-height:28px;font-size:11px;padding:0 10px;"
                     [class.loading]="batch._simulatingCost"
                     (click)="simulateBatchShippingCost(batch); $event.stopPropagation();">
                  <i class="material-icons" style="font-size:14px;" *ngIf="!batch._simulatingCost">calculate</i>
                  <i class="material-icons BatchSimulateSpinner" style="font-size:14px;" *ngIf="batch._simulatingCost">sync</i>
                  <span>{{ 'SimulateCost' | translate }}</span>
                </div>
                <div class="GridCommandButton" style="height:28px;line-height:28px;font-size:11px;padding:0 10px;" (click)="addBatchShippingCost(batch); $event.stopPropagation();">
                  <i class="material-icons" style="font-size:14px;">add</i>
                  <span>{{ 'Add' | translate }}</span>
                </div>
              </div>
            </div>
            <!-- Simulation result row -->
            <div class="BatchSimulateCostResult" *ngIf="batch._simulatedCost != null">
              <div class="BatchSimulateCostResultInfo">
                <i class="material-icons" style="font-size:15px;color:#2e7d32;">speed</i>
                <span class="BatchSimulateCostResultLabel">{{ 'SimulatedCost' | translate }}:</span>
                <span class="BatchSimulateCostResultValue">{{ batch._simulatedCost | number:'1.2-2' }} {{ batch._simulatedCostCurrency || '' }}</span>
              </div>
              <div class="GridCommandButton BatchAllocateCostBtn" style="height:26px;line-height:26px;font-size:11px;padding:0 10px;"
                   (click)="allocateSimulatedCost(batch); $event.stopPropagation();">
                <i class="material-icons" style="font-size:14px;">input</i>
                <span>{{ 'Allocate' | translate }}</span>
              </div>
            </div>
            <div class="BatchShippingCostsList" *ngIf="batch.ShippingCosts?.length > 0">
              <div class="BatchShippingCostItem" *ngFor="let sc of batch.ShippingCosts; let scIdx = index">
                <div class="BatchShippingCostInfo">
                  <i class="material-icons" style="font-size:15px;" [style.color]="sc.IsTransferred ? '#1565c0' : '#b8860b'">
                    {{ sc.IsTransferred ? 'receipt' : 'add_circle_outline' }}
                  </i>
                  <span class="BatchShippingCostRef" *ngIf="sc.IsTransferred">{{ sc.ReferenceNumber || sc.OrderID || '-' }}</span>
                  <span class="BatchShippingCostRef" *ngIf="!sc.IsTransferred" style="color:#8b6914;">{{ 'Manual' | translate }}</span>
                  <span class="BatchShippingCostDischarge" *ngIf="sc.IsTransferred && sc.DischargeType">
                    <i class="material-icons" style="font-size:12px;">request_quote</i>{{ sc.DischargeType.Name }}
                  </span>
                </div>
                <!-- SplitType dropdown: shown on non-transferred costs when SeparateOrderInvoices is ON -->
                <div class="BatchShippingCostSplitType" *ngIf="!sc.IsTransferred && batch.ProcessingSettings?.SeparateOrderInvoices">
                  <div class="SendEmailOverlayTransparent" *ngIf="sc._showSplitTypeDropdown" (click)="sc._showSplitTypeDropdown = false"></div>
                  <div class="BatchShippingCostSplitBtn" (click)="sc._showSplitTypeDropdown = !sc._showSplitTypeDropdown; $event.stopPropagation();">
                    <i class="material-icons">call_split</i>
                    <span>{{ sc.SplitType?.Name || ('Select' | translate) }}</span>
                    <i class="material-icons" style="font-size:14px;">arrow_drop_down</i>
                  </div>
                  <div class="BatchShippingCostSplitDropdown" *ngIf="sc._showSplitTypeDropdown">
                    <div class="BatchShippingCostSplitOption" *ngFor="let st of MasterData?.ShippingCostSplitTypes"
                         (click)="sc.SplitType = st; sc._showSplitTypeDropdown = false; $event.stopPropagation();">
                      <i class="material-icons" [style.color]="sc.SplitType?.ID === st.ID ? '#8b6914' : '#ccc'">
                        {{ sc.SplitType?.ID === st.ID ? 'check_circle' : 'radio_button_unchecked' }}
                      </i>
                      <span>{{ st.Name }}</span>
                    </div>
                  </div>
                </div>
                <div class="BatchShippingCostValueInput">
                  <input type="number" class="BatchShippingCostInput" [(ngModel)]="sc.ShippingCost"
                         placeholder="0.00" step="0.01" min="0"
                         (click)="$event.target.select(); $event.stopPropagation();" />
                  <span class="BatchShippingCostCurrency">{{ sc.Currency?.Symbol || sc.Currency?.Name || '' }}</span>
                </div>
                <button class="BatchShippingCostRemoveBtn" *ngIf="batch.ShippingCosts.length > 1"
                        (click)="removeBatchShippingCost(batch, scIdx); $event.stopPropagation();"
                        matTooltip="{{ 'Remove' | translate }}" matTooltipClass="neutral-tool-tip-management">
                  <i class="material-icons">close</i>
                </button>
              </div>
            </div>
          </div>

          <!-- Notification Recipients Section -->
          <div class="BatchNotificationSection" *ngIf="batch.ProcessingSettings?.NotifiesWithAttachments">
            <div class="BatchBoxesHeader">
              <span class="BatchBoxesTitle">
                <i class="material-icons" style="font-size:16px;vertical-align:middle;margin-right:4px;">email</i>
                {{ 'NotificationRecipients' | translate }}
              </span>
            </div>

            <!-- Loading -->
            <div *ngIf="batch._loadingRecipients" style="display:flex;align-items:center;gap:6px;padding:10px 4px;font-size:11px;color:#86868b;">
              <mat-spinner diameter="14"></mat-spinner>
              <span>{{ 'Loading' | translate }}...</span>
            </div>

            <!-- General mode -->
            <div class="BatchNotificationChips" *ngIf="!batch._loadingRecipients && !batch.ProcessingSettings?.SendEachFileToTheAppropriateDepartment">
              <div class="NotifChip" *ngFor="let r of batch.NotificationRecipients" [class.NotifChipSelected]="r.IsSelected" (click)="r.IsSelected = !r.IsSelected">
                <i class="material-icons NotifChipIcon">{{ r.IsSelected ? 'check_circle' : 'cancel' }}</i>
                <span class="NotifChipEmail">{{ r.AgentEmail }}</span>
              </div>
              <div *ngIf="!batch.NotificationRecipients?.length" style="padding:6px 0;font-size:11px;color:#86868b;font-style:italic;">
                {{ 'NoNotificationRecipients' | translate }}
              </div>
            </div>

            <!-- Split mode -->
            <div *ngIf="!batch._loadingRecipients && batch.ProcessingSettings?.SendEachFileToTheAppropriateDepartment">
              <div class="BatchNotificationGroupHeader">
                <i class="material-icons" style="font-size:14px;color:#2d6a4f;">local_shipping</i>
                <span>{{ 'LogisticsRecipients' | translate }}</span>
              </div>
              <div class="BatchNotificationChips">
                <div class="NotifChip" *ngFor="let r of batch.LogisticsRecipients" [class.NotifChipSelected]="r.IsSelected" (click)="r.IsSelected = !r.IsSelected">
                  <i class="material-icons NotifChipIcon">{{ r.IsSelected ? 'check_circle' : 'cancel' }}</i>
                  <span class="NotifChipEmail">{{ r.AgentEmail }}</span>
                </div>
                <div *ngIf="!batch.LogisticsRecipients?.length" style="padding:6px 0;font-size:11px;color:#86868b;font-style:italic;">
                  {{ 'NoNotificationRecipients' | translate }}
                </div>
              </div>
              <div class="BatchNotificationGroupHeader" style="margin-top:8px;">
                <i class="material-icons" style="font-size:14px;color:#1a3a5c;">receipt_long</i>
                <span>{{ 'InvoiceRecipients' | translate }}</span>
              </div>
              <div class="BatchNotificationChips">
                <div class="NotifChip" *ngFor="let r of batch.InvoiceRecipients" [class.NotifChipSelected]="r.IsSelected" (click)="r.IsSelected = !r.IsSelected">
                  <i class="material-icons NotifChipIcon">{{ r.IsSelected ? 'check_circle' : 'cancel' }}</i>
                  <span class="NotifChipEmail">{{ r.AgentEmail }}</span>
                </div>
                <div *ngIf="!batch.InvoiceRecipients?.length" style="padding:6px 0;font-size:11px;color:#86868b;font-style:italic;">
                  {{ 'NoNotificationRecipients' | translate }}
                </div>
              </div>
            </div>
          </div>

          <!-- Batch Total Breakdown -->
          <div class="BatchTotalBreakdown" *ngIf="batch.CartItems?.length > 0">
            <div class="BatchTotalRow">
              <span class="BatchTotalRowLabel">{{ 'SubTotal' | translate }}</span>
              <span class="BatchTotalRowValue">{{ getBatchSubTotal(batch) | number:'1.2-2' }} {{ batch.CartItems[0]?.CartItemOrderInfo?.OrderCurrency?.Symbol || batch.CartItems[0]?.SelectedOffer?.Currency?.Symbol || '' }}</span>
            </div>
            <div class="BatchTotalRow BatchTotalRowShipping" *ngFor="let sc of batch.ShippingCosts">
              <span class="BatchTotalRowLabel">
                <i class="material-icons" style="font-size:12px;vertical-align:middle;margin-right:2px;" [style.color]="sc.IsTransferred ? '#1565c0' : '#b8860b'">{{ sc.IsTransferred ? 'receipt' : 'add_circle_outline' }}</i>
                {{ sc.IsTransferred ? (sc.ReferenceNumber || sc.OrderID || ('ShippingCost' | translate)) : ('Manual' | translate) }}
              </span>
              <span class="BatchTotalRowValue">{{ (sc.ShippingCost || 0) | number:'1.2-2' }} {{ sc.Currency?.Symbol || sc.Currency?.Name || '' }}</span>
            </div>
            <div class="BatchTotalRow BatchTotalRowGrand">
              <span class="BatchTotalRowLabel">TOTAL</span>
              <span class="BatchTotalRowValue">{{ getBatchGrandTotal(batch) | number:'1.2-2' }} {{ batch.CartItems[0]?.CartItemOrderInfo?.OrderCurrency?.Symbol || batch.CartItems[0]?.SelectedOffer?.Currency?.Symbol || '' }}</span>
            </div>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>

    <div class="BatchEmptyState" *ngIf="ProcessOrdersBatches.length === 0">
      <i class="material-icons">inbox</i>
      <span>{{ 'NoBatchesRemaining' | translate }}</span>
    </div>
  </div>

  <div class="BatchPopupFooter">
    <div class="GridCommandButton" (click)="closeBatchReview()">
      <i class="material-icons">close</i>
      <span>{{ 'Cancel' | translate }}</span>
    </div>
    <div class="GridCommandButton GridCommandButtonGreen"
         [class.disabled]="executingProcessOrders || ProcessOrdersBatches.length === 0"
         (click)="executeProcessAllBatches()">
      <i class="material-icons" *ngIf="!executingProcessOrders">check</i>
      <mat-spinner *ngIf="executingProcessOrders" diameter="18"></mat-spinner>
      <span>{{ 'ProcessAllBatches' | translate }}</span>
    </div>
  </div>
</div>

<!-- ✅ Processing Results Container -->
<div class="ProcessOrdersBatchOverlay" *ngIf="ShowProcessingResults" (click)="closeProcessingResults()"></div>
<div class="ProcessOrdersBatchPopup ProcessingResultsPopup animated fadeInDown faster" *ngIf="ShowProcessingResults">
  <div class="BatchPopupHeader">
    <div class="BatchPopupIconWrapper">
      <i class="material-icons">assignment_turned_in</i>
    </div>
    <div class="BatchPopupTitle">{{ 'ProcessingResults' | translate }}</div>
    <div class="BatchPopupSubtitle" *ngIf="ProcessingResultsResponse">{{ ProcessingResultsResponse.Message }}</div>
  </div>

  <div class="BatchPopupBody">
    <div *ngFor="let br of ProcessingResultsResponse?.BatchResults; let ri = index" class="ResultBatchCard" [class.result-failed]="!br.Success">
      <!-- Batch Result Header -->
      <div class="ResultBatchHeader">
        <div class="ResultBatchHeaderLeft">
          <i class="material-icons" [style.color]="br.Success ? '#4caf50' : '#f44336'">{{ br.Success ? 'check_circle' : 'error' }}</i>
          <span class="ResultBatchPartner">{{ br.PartnerName || br.PartnerID }}</span>
          <span class="ResultBatchBadge" [class.badge-success]="br.Success" [class.badge-error]="!br.Success">
            {{ br.Success ? ('StepSuccess' | translate) : ('StepFailed' | translate) }}
          </span>
        </div>
        <div class="ResultBatchHeaderRight">
          <span class="ResultBatchItems">{{ br.ItemCount }} {{ 'items' | translate }}</span>
          <div class="ResultRetryBtn" *ngIf="!br.Success && br.OriginalBatch" [class.disabled]="br._retrying" (click)="retryBatch(br)">
            <i class="material-icons" *ngIf="!br._retrying">refresh</i>
            <mat-spinner *ngIf="br._retrying" diameter="14"></mat-spinner>
            <span>{{ 'Retry' | translate }}</span>
          </div>
        </div>
      </div>

      <!-- Error Message -->
      <div class="ResultBatchError" *ngIf="br.ErrorMessage">
        <i class="material-icons">warning</i>
        <span>{{ br.ErrorMessage }}</span>
      </div>

      <!-- Editable Shipping Settings (for failed batches with OriginalBatch — fix & retry) -->
      <div class="ResultBatchSection ResultShippingDropdowns" *ngIf="!br.Success && br.OriginalBatch?.ShippingDetails">
        <div class="ResultSectionTitle"><i class="material-icons">local_shipping</i> {{ 'ShippingSettings' | translate }}</div>
        <div class="ResultDropdownsRow">
          <!-- Shipping Service Type -->
          <div class="CustomDropdownContainer ResultDropdown" [class.dropdown-open]="br._showResultServiceType">
            <div class="SendEmailOverlayTransparent" *ngIf="br._showResultServiceType" (click)="br._showResultServiceType = false"></div>
            <div class="CustomDropdownBar" (click)="br._showResultServiceType = !br._showResultServiceType">
              <span class="dropdown-label">{{ 'ShippingService' | translate }}</span>
              <i class="material-icons dropdown-icon-left">speed</i>
              <input type="text" class="CustomDropdownInput" readonly
                     [class.placeholder]="!br.OriginalBatch.ShippingDetails?.ShippingServiceType"
                     [value]="br.OriginalBatch.ShippingDetails?.ShippingServiceType?.Name || 'Select...'" />
              <i class="material-icons dropdown-icon">arrow_drop_down</i>
            </div>
            <div class="CustomDropdownResults" *ngIf="br._showResultServiceType">
              <div class="CustomDropdownResult" *ngFor="let svc of getResultAvailableServiceTypes(br)" (click)="br.OriginalBatch.ShippingDetails.ShippingServiceType = svc; br._showResultServiceType = false">
                <div class="CustomDropdownResultMain">
                  <i class="material-icons" [style.color]="br.OriginalBatch.ShippingDetails?.ShippingServiceType?.ID === svc.ID ? '#4caf50' : '#9ca3af'">
                    {{ br.OriginalBatch.ShippingDetails?.ShippingServiceType?.ID === svc.ID ? 'check_circle' : 'radio_button_unchecked' }}
                  </i>
                  <span class="CustomDropdownResultText">{{ svc.Name }}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Shipping Company -->
          <div class="CustomDropdownContainer ResultDropdown" [class.dropdown-open]="br._showResultCompany">
            <div class="SendEmailOverlayTransparent" *ngIf="br._showResultCompany" (click)="br._showResultCompany = false"></div>
            <div class="CustomDropdownBar" (click)="br._showResultCompany = !br._showResultCompany">
              <span class="dropdown-label">{{ 'ShippingCompany' | translate }}</span>
              <i class="material-icons dropdown-icon-left">local_shipping</i>
              <input type="text" class="CustomDropdownInput" readonly
                     [class.placeholder]="!br.OriginalBatch.ShippingDetails?.ShippingCompany"
                     [value]="br.OriginalBatch.ShippingDetails?.ShippingCompany?.Name || 'Select...'" />
              <i class="material-icons dropdown-icon">arrow_drop_down</i>
            </div>
            <div class="CustomDropdownResults" *ngIf="br._showResultCompany">
              <div class="CustomDropdownResult" *ngFor="let comp of getResultAvailableCompanies(br)" (click)="br.OriginalBatch.ShippingDetails.ShippingCompany = comp; br._showResultCompany = false">
                <div class="CustomDropdownResultMain">
                  <i class="material-icons" [style.color]="br.OriginalBatch.ShippingDetails?.ShippingCompany?.ID === comp.ID ? '#4caf50' : '#9ca3af'">
                    {{ br.OriginalBatch.ShippingDetails?.ShippingCompany?.ID === comp.ID ? 'check_circle' : 'radio_button_unchecked' }}
                  </i>
                  <span class="CustomDropdownResultText">{{ comp.Name }}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Shipping Responsability -->
          <div class="CustomDropdownContainer ResultDropdown" [class.dropdown-open]="br._showResultResponsability">
            <div class="SendEmailOverlayTransparent" *ngIf="br._showResultResponsability" (click)="br._showResultResponsability = false"></div>
            <div class="CustomDropdownBar" (click)="br._showResultResponsability = !br._showResultResponsability">
              <span class="dropdown-label">{{ 'ShippingResponsability' | translate }}</span>
              <i class="material-icons dropdown-icon-left">assignment_ind</i>
              <input type="text" class="CustomDropdownInput" readonly
                     [class.placeholder]="!br.OriginalBatch.ShippingDetails?.ShippingResponsability"
                     [value]="br.OriginalBatch.ShippingDetails?.ShippingResponsability?.Name || 'Select...'" />
              <i class="material-icons dropdown-icon">arrow_drop_down</i>
            </div>
            <div class="CustomDropdownResults" *ngIf="br._showResultResponsability">
              <div class="CustomDropdownResult" *ngFor="let resp of ShippingResponsabilities" (click)="br.OriginalBatch.ShippingDetails.ShippingResponsability = resp; br._showResultResponsability = false">
                <div class="CustomDropdownResultMain">
                  <i class="material-icons" [style.color]="br.OriginalBatch.ShippingDetails?.ShippingResponsability?.ID === resp.ID ? '#4caf50' : '#9ca3af'">
                    {{ br.OriginalBatch.ShippingDetails?.ShippingResponsability?.ID === resp.ID ? 'check_circle' : 'radio_button_unchecked' }}
                  </i>
                  <span class="CustomDropdownResultText">{{ resp.Name }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Processing Steps -->
      <div class="ResultBatchSection" *ngIf="br.Steps?.length > 0">
        <div class="ResultSectionTitle"><i class="material-icons">list_alt</i> {{ 'ProcessingSteps' | translate }}</div>
        <div class="ResultStepRow" *ngFor="let step of br.Steps" [ngClass]="getStepStatusClass(step.Status)">
          <i class="material-icons ResultStepIcon">
            {{ step.Status === 1 ? 'check_circle' : step.Status === 2 ? 'cancel' : step.Status === 0 ? 'skip_next' : 'hourglass_empty' }}
          </i>
          <span class="ResultStepName">{{ step.StepName }}</span>
          <span class="ResultStepStatus">{{ getStepStatusKey(step.Status) | translate }}</span>
          <span class="ResultStepMessage" *ngIf="step.Message">{{ step.Message }}</span>
        </div>
      </div>

      <!-- Receiver Address Used -->
      <div class="ResultBatchSection" *ngIf="br.ReceiverAddressUsed">
        <div class="ResultSectionTitle"><i class="material-icons">location_on</i> {{ 'ShippingAddressUsed' | translate }}</div>
        <div class="ResultAddressInfo">
          <span>{{ br.ReceiverAddressUsed.ContactCompany || br.ReceiverAddressUsed.ContactPerson || '-' }}</span>
          <span *ngIf="br.ReceiverAddressUsed.AddressLine">{{ br.ReceiverAddressUsed.AddressLine }}</span>
          <span>{{ br.ReceiverAddressUsed.City || '' }} {{ br.ReceiverAddressUsed.ZipCode || '' }}<ng-container *ngIf="br.ReceiverAddressUsed.Country?.Name">, {{ br.ReceiverAddressUsed.Country.Name }}</ng-container></span>
        </div>
      </div>

      <!-- Processed Items Summary -->
      <div class="ResultBatchSection" *ngIf="br.ItemsSummary?.length > 0">
        <div class="ResultSectionTitle"><i class="material-icons">inventory_2</i> {{ 'ProcessedItems' | translate }} ({{ br.ItemCount }})</div>
        <div class="ResultItemLine" *ngFor="let line of br.ItemsSummary">{{ line }}</div>
      </div>

      <!-- Settings Used (read-only chips for successful batches) -->
      <div class="ResultBatchSection" *ngIf="br.Success && br.SettingsUsed">
        <div class="ResultSectionTitle"><i class="material-icons">tune</i> {{ 'RequestedSettings' | translate }}</div>
        <div class="ResultSettingsGrid">
          <span class="ResultSettingChip" [class.active]="br.SettingsUsed.GenerateTrackingLabel">{{ 'GenerateTrackingLabel' | translate }}</span>
          <span class="ResultSettingChip" [class.active]="br.SettingsUsed.GenerateInvoice">{{ 'GenerateInvoice' | translate }}</span>
          <span class="ResultSettingChip" [class.active]="br.SettingsUsed.SeparateOrderInvoices">{{ 'SeparateOrderInvoices' | translate }}</span>
          <span class="ResultSettingChip" [class.active]="br.SettingsUsed.NotifiesWithAttachments">{{ 'NotifiesWithAttachments' | translate }}</span>
          <span class="ResultSettingChip" [class.active]="br.SettingsUsed.AutoPrinting">{{ 'AutoPrinting' | translate }}</span>
        </div>
      </div>

      <!-- Settings Editable (toggles for failed batches — modify OriginalBatch.ProcessingSettings for retry) -->
      <div class="ResultBatchSection ResultSettingsEditable" *ngIf="!br.Success && br.OriginalBatch?.ProcessingSettings">
        <div class="ResultSectionTitle"><i class="material-icons">tune</i> {{ 'RequestedSettings' | translate }}</div>
        <div class="ResultSettingsToggles">
          <div class="ResultToggleItem" [class.active]="br.OriginalBatch.ProcessingSettings.GenerateTrackingLabel">
            <label class="MiniToggle">
              <input type="checkbox" [(ngModel)]="br.OriginalBatch.ProcessingSettings.GenerateTrackingLabel">
              <span class="MiniToggleSlider"></span>
            </label>
            <span>{{ 'GenerateTrackingLabel' | translate }}</span>
          </div>
          <div class="ResultToggleItem" [class.active]="br.OriginalBatch.ProcessingSettings.GenerateInvoice">
            <label class="MiniToggle">
              <input type="checkbox" [(ngModel)]="br.OriginalBatch.ProcessingSettings.GenerateInvoice">
              <span class="MiniToggleSlider"></span>
            </label>
            <span>{{ 'GenerateInvoice' | translate }}</span>
          </div>
          <div class="ResultToggleItem" [class.active]="br.OriginalBatch.ProcessingSettings.SeparateOrderInvoices">
            <label class="MiniToggle">
              <input type="checkbox" [(ngModel)]="br.OriginalBatch.ProcessingSettings.SeparateOrderInvoices">
              <span class="MiniToggleSlider"></span>
            </label>
            <span>{{ 'SeparateOrderInvoices' | translate }}</span>
          </div>
          <div class="ResultToggleItem" [class.active]="br.OriginalBatch.ProcessingSettings.NotifiesWithAttachments">
            <label class="MiniToggle">
              <input type="checkbox" [(ngModel)]="br.OriginalBatch.ProcessingSettings.NotifiesWithAttachments">
              <span class="MiniToggleSlider"></span>
            </label>
            <span>{{ 'NotifiesWithAttachments' | translate }}</span>
          </div>
          <div class="ResultToggleItem" [class.active]="br.OriginalBatch.ProcessingSettings.AutoPrinting">
            <label class="MiniToggle">
              <input type="checkbox" [(ngModel)]="br.OriginalBatch.ProcessingSettings.AutoPrinting">
              <span class="MiniToggleSlider"></span>
            </label>
            <span>{{ 'AutoPrinting' | translate }}</span>
          </div>
          <div class="ResultToggleItem" [class.active]="br.OriginalBatch.ProcessingSettings.GenerateQWCertificate">
            <label class="MiniToggle">
              <input type="checkbox" [(ngModel)]="br.OriginalBatch.ProcessingSettings.GenerateQWCertificate">
              <span class="MiniToggleSlider"></span>
            </label>
            <span>{{ 'GenerateQWCertificate' | translate }}</span>
          </div>
          <div class="ResultToggleItem" [class.active]="br.OriginalBatch.ProcessingSettings.SellThroughPartnerCompany">
            <label class="MiniToggle">
              <input type="checkbox" [(ngModel)]="br.OriginalBatch.ProcessingSettings.SellThroughPartnerCompany">
              <span class="MiniToggleSlider"></span>
            </label>
            <span>{{ 'SellThroughPartnerCompany' | translate }}</span>
          </div>
        </div>
        <!-- PartnerCompany dropdown (only when SellThroughPartnerCompany is toggled on) -->
        <div class="ResultDropdownsRow" style="margin-top:8px;" *ngIf="br.OriginalBatch.ProcessingSettings.SellThroughPartnerCompany">
          <div class="CustomDropdownContainer ResultDropdown" [class.dropdown-open]="br._showResultPartnerCompany">
            <div class="SendEmailOverlayTransparent" *ngIf="br._showResultPartnerCompany" (click)="br._showResultPartnerCompany = false"></div>
            <div class="CustomDropdownBar" (click)="br._showResultPartnerCompany = !br._showResultPartnerCompany">
              <span class="dropdown-label">{{ 'PartnerCompany' | translate }}</span>
              <i class="material-icons dropdown-icon-left">business</i>
              <input type="text" class="CustomDropdownInput" readonly
                     [class.placeholder]="!br.OriginalBatch.ProcessingSettings?.PartnerCompany"
                     [value]="br.OriginalBatch.ProcessingSettings?.PartnerCompany?.Name || 'Select...'" />
              <i class="material-icons dropdown-icon">arrow_drop_down</i>
            </div>
            <div class="CustomDropdownResults" *ngIf="br._showResultPartnerCompany">
              <div class="CustomDropdownResult" *ngFor="let comp of getSlaveCompanies()" (click)="br.OriginalBatch.ProcessingSettings.PartnerCompany = comp; br._showResultPartnerCompany = false">
                <div class="CustomDropdownResultMain">
                  <i class="material-icons" [style.color]="br.OriginalBatch.ProcessingSettings?.PartnerCompany?.ID === comp.ID ? '#4caf50' : '#9ca3af'">
                    {{ br.OriginalBatch.ProcessingSettings?.PartnerCompany?.ID === comp.ID ? 'check_circle' : 'radio_button_unchecked' }}
                  </i>
                  <span class="CustomDropdownResultText">{{ comp.Name }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Generated Documents -->
      <div class="ResultBatchSection" *ngIf="br.Documents?.length > 0">
        <div class="ResultSectionTitle"><i class="material-icons">description</i> {{ 'GeneratedDocuments' | translate }} ({{ br.Documents.length }})</div>
        <div class="ResultDocRow" *ngFor="let doc of br.Documents">
          <i class="material-icons ResultDocIcon">picture_as_pdf</i>
          <span class="ResultDocName">{{ doc.Name || 'document.pdf' }}</span>
          <div class="ResultDocActions">
            <i class="material-icons ResultDocAction" (click)="downloadResultDocument(doc)" matTooltip="{{ 'DownloadFile' | translate }}" matTooltipClass="neutral-tool-tip-management">cloud_download</i>
            <i class="material-icons ResultDocAction" (click)="printResultDocument(doc)" matTooltip="{{ 'PrintFile' | translate }}" matTooltipClass="neutral-tool-tip-management">print</i>
          </div>
        </div>
      </div>
      <div class="ResultBatchSection ResultNoDocuments" *ngIf="!br.Documents || br.Documents.length === 0">
        <i class="material-icons">folder_open</i>
        <span>{{ 'NoDocumentsGenerated' | translate }}</span>
      </div>

      <!-- Errors -->
      <div class="ResultBatchSection ResultErrorsSection" *ngIf="br.Errors?.length > 0">
        <div class="ResultSectionTitle"><i class="material-icons">error_outline</i> {{ 'BatchErrors' | translate }} ({{ br.Errors.length }})</div>
        <div class="ResultErrorLine" *ngFor="let err of br.Errors">
          <i class="material-icons">warning_amber</i>
          <span>{{ err.Message }}</span>
        </div>
      </div>

      <!-- Snapshot -->
      <div class="ResultBatchSection ResultSnapshotInfo" *ngIf="br.SnapshotDBID">
        <i class="material-icons">camera_alt</i>
        <span>{{ 'SnapshotRegistered' | translate }}: #{{ br.SnapshotDBID }}</span>
      </div>
    </div>
  </div>

  <div class="BatchPopupFooter">
    <div class="GridCommandButton GridCommandButtonGreen" (click)="closeProcessingResults()">
      <i class="material-icons">check</i>
      <span>{{ 'Close' | translate }}</span>
    </div>
  </div>
</div>

<!-- ✅ Batch Grouping Settings Popup -->
<div class="BatchSettingsOverlay" *ngIf="ShowBatchGroupingSettings" (click)="closeBatchGroupingSettings()"></div>
<div class="BatchSettingsPopup animated fadeInDown faster" *ngIf="ShowBatchGroupingSettings">
  <div class="BatchSettingsHeader">
    <i class="material-icons">layers</i>
    <span>{{ 'GroupingSettingsFor' | translate }} {{ CurrentGroupingPartnerName }}</span>
    <i class="material-icons BatchSettingsClose" (click)="closeBatchGroupingSettings()">close</i>
  </div>

  <div class="BatchSettingsBody">
    <div class="BatchSettingsHint">
      <i class="material-icons">info</i>
      <span>{{ 'GroupingSettingsHint' | translate }}</span>
    </div>

    <div class="BatchSettingsToggleGroup">
      <div class="BatchToggleItem" [class.active]="CurrentGroupingSettings?.GroupByShippingServiceType">
        <label class="MiniToggle">
          <input type="checkbox" [(ngModel)]="CurrentGroupingSettings.GroupByShippingServiceType">
          <span class="MiniToggleSlider"></span>
        </label>
        <span>{{ 'GroupByShippingServiceType' | translate }}</span>
      </div>

      <div class="BatchToggleItem" [class.active]="CurrentGroupingSettings?.GroupByShippingAddress">
        <label class="MiniToggle">
          <input type="checkbox" [(ngModel)]="CurrentGroupingSettings.GroupByShippingAddress">
          <span class="MiniToggleSlider"></span>
        </label>
        <span>{{ 'GroupByShippingAddress' | translate }}</span>
      </div>

      <div class="BatchToggleItem" [class.active]="CurrentGroupingSettings?.GroupByShippingCompany">
        <label class="MiniToggle">
          <input type="checkbox" [(ngModel)]="CurrentGroupingSettings.GroupByShippingCompany">
          <span class="MiniToggleSlider"></span>
        </label>
        <span>{{ 'GroupByShippingCompany' | translate }}</span>
      </div>

      <div class="BatchToggleItem" [class.active]="CurrentGroupingSettings?.GroupByCurrency">
        <label class="MiniToggle">
          <input type="checkbox" [(ngModel)]="CurrentGroupingSettings.GroupByCurrency">
          <span class="MiniToggleSlider"></span>
        </label>
        <span>{{ 'GroupByCurrency' | translate }}</span>
      </div>

      <div class="BatchToggleItem" [class.active]="CurrentGroupingSettings?.GroupByInvoicingCompany">
        <label class="MiniToggle">
          <input type="checkbox" [(ngModel)]="CurrentGroupingSettings.GroupByInvoicingCompany">
          <span class="MiniToggleSlider"></span>
        </label>
        <span>{{ 'GroupByInvoicingCompany' | translate }}</span>
      </div>
    </div>
  </div>

  <div class="BatchSettingsFooter">
    <div class="GridCommandButton" (click)="closeBatchGroupingSettings()">
      <i class="material-icons">close</i>
      <span>{{ 'Cancel' | translate }}</span>
    </div>
    <div class="GridCommandButton" (click)="saveAndCloseGroupingSettings()">
      <i class="material-icons">save</i>
      <span>{{ 'Save' | translate }}</span>
    </div>
    <div class="GridCommandButton GridCommandButtonBlue"
         [class.disabled]="regroupingBatches"
         (click)="regroupBatchesForPartner()">
      <i class="material-icons" *ngIf="!regroupingBatches">refresh</i>
      <mat-spinner *ngIf="regroupingBatches" diameter="18"></mat-spinner>
      <span>{{ 'SaveAndRegroup' | translate }}</span>
    </div>
  </div>
</div>

<div class="InfoQuestion animated fadeInDown" *ngIf="ShowOrderCopy">
    <div class="InfoQuestionClose">
      <i class="material-icons" (click)="ShowOrderCopy = false; CurrentOrder = null;">close</i>
    </div>
    <div class="InfoQuestionTitle">
      {{ 'CopyOfferTitle' | translate }}
    </div>
    <div class="InfoQuestionBody">
      {{ 'CopyOfferDescription' | translate }}
    </div>

    <div class="InfoQuestionCommands">
      <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowOrderCopy = false; CurrentOrder = null;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
      <button [disabled]="this.parent.loading" mat-raised-button color="primary" class="InfoQuestionButton" (click)="ShowOrderCopy = false;CopyOrder(CurrentOrder);">{{ 'AcceptAndContinueCopy' | translate }}</button>
    </div>
</div>

<div class="InfoQuestion animated fadeInDown" *ngIf="ShowOrderCancelation">
    <div class="InfoQuestionClose">
      <i class="material-icons" (click)="ShowOrderCancelation = false; CurrentOrder = null;">close</i>
    </div>
    <div class="InfoQuestionTitle">
      {{ 'CancelQuestion' | translate }}
    </div>
    <div class="InfoQuestionBody">
      {{ 'CancelQuestionDescription' | translate }}
    </div>

    <div class="InfoQuestionCommands">
      <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowOrderCancelation = false; CurrentOrder = null;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
      <button [disabled]="this.parent.loading" mat-raised-button color="warn" class="InfoQuestionButton" (click)="ShowOrderCancelation = false;CancelOrder(CurrentOrder);">{{ 'YesCancel' | translate }}</button>
    </div>
</div>

<div class="InfoQuestion animated fadeInDown" *ngIf="ShowConfirmationQuestion">
  <div class="InfoQuestionClose">
    <i class="material-icons" (click)="ShowConfirmationQuestion = false; CurrentOrder = null;">close</i>
  </div>
  <div class="InfoQuestionTitle">
    {{ 'ConfirmOrder' | translate }}
  </div>
  <div class="InfoQuestionBody">
    {{ 'ConfirmOrderDescription' | translate }}
  </div>

  <div class="InfoQuestionCommands">
    <button [disabled]="this.parent.loading" mat-raised-button color="accent" class="InfoQuestionButton" (click)="ConfirmOrder(CurrentOrder); ShowConfirmationQuestion = false; CurrentOrder = null;">{{ 'ConfirmOrder' | translate }}</button>
    <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowConfirmationQuestion = false;">{{ 'YesCancel' | translate }}</button>
  </div>
</div>

<!-- Convert OfferRequest to Offer Confirmation Popup -->
<div class="ConvertToOrderConfirmationOverlay" *ngIf="ShowConvertToOfferConfirmation" (click)="ShowConvertToOfferConfirmation = false;"></div>
<div class="ConvertToOrderConfirmationPopup animated fadeInDown" *ngIf="ShowConvertToOfferConfirmation">
  <div class="ConvertPopupHeader">
    <div class="ConvertPopupIconWrapper">
      <i class="material-icons">swap_horiz</i>
    </div>
    <div class="ConvertPopupHeaderText">
      <span class="ConvertPopupTitle">{{ 'ConvertToOffer' | translate }}</span>
      <span class="ConvertPopupRef">{{ CurrentOrder?.ReferenceNumber }}</span>
    </div>
    <i class="material-icons ConvertPopupClose" (click)="ShowConvertToOfferConfirmation = false;">close</i>
  </div>
  <div class="ConvertPopupBody">
    <p class="ConvertPopupMessage">{{ 'ConvertToOfferConfirmation' | translate }}</p>
  </div>
  <div class="ConvertPopupFooter">
    <div class="GridCommandButton" [class.disabled]="this.parent.loading" (click)="ShowConvertToOfferConfirmation = false;">
      <i class="material-icons">close</i>
      <span>{{ 'No' | translate }}</span>
    </div>
    <div class="GridCommandButton GridCommandButtonGreen" [class.disabled]="this.parent.loading" (click)="ConfirmConvertToOffer();">
      <i class="material-icons" *ngIf="!this.parent.loading">check</i>
      <span *ngIf="!this.parent.loading">{{ 'Yes' | translate }}</span>
      <mat-spinner *ngIf="this.parent.loading" diameter="18"></mat-spinner>
    </div>
  </div>
</div>

<!-- Generate Purchase Order (PO) Confirmation Popup -->
<div class="ConvertToOrderConfirmationOverlay" *ngIf="ShowGeneratePOConfirmation" (click)="ShowGeneratePOConfirmation = false;"></div>
<div class="ConvertToOrderConfirmationPopup animated fadeInDown" *ngIf="ShowGeneratePOConfirmation">
  <div class="ConvertPopupHeader">
    <div class="ConvertPopupIconWrapper" style="background: #f60;">
      <i class="material-icons">shopping_cart</i>
    </div>
    <div class="ConvertPopupHeaderText">
      <span class="ConvertPopupTitle">{{ 'GeneratePO' | translate }}</span>
      <span class="ConvertPopupRef">{{ CurrentOrder?.ReferenceNumber }}</span>
    </div>
    <i class="material-icons ConvertPopupClose" (click)="ShowGeneratePOConfirmation = false;">close</i>
  </div>
  <div class="ConvertPopupBody">
    <p class="ConvertPopupMessage">{{ 'GeneratePOConfirmation' | translate }}</p>
  </div>
  <div class="ConvertPopupFooter">
    <div class="GridCommandButton" [class.disabled]="this.parent.loading" (click)="ShowGeneratePOConfirmation = false;">
      <i class="material-icons">close</i>
      <span>{{ 'No' | translate }}</span>
    </div>
    <div class="GridCommandButton GridCommandButtonOrange" [class.disabled]="this.parent.loading" (click)="ShowGeneratePOConfirmation = false;">
      <i class="material-icons" *ngIf="!this.parent.loading">check</i>
      <span *ngIf="!this.parent.loading">{{ 'Yes' | translate }}</span>
      <mat-spinner *ngIf="this.parent.loading" diameter="18"></mat-spinner>
    </div>
  </div>
</div>

<!-- Progress Status Change Confirmation Popup (guards accidental double-click status changes) -->
<div class="ConvertToOrderConfirmationOverlay" *ngIf="ShowStatusChangeConfirmation" (click)="cancelProgressStatusChange();"></div>
<div class="ConvertToOrderConfirmationPopup animated fadeInDown" *ngIf="ShowStatusChangeConfirmation">
  <div class="ConvertPopupHeader">
    <div class="ConvertPopupIconWrapper" style="background: #f60;">
      <i class="material-icons">sync_alt</i>
    </div>
    <div class="ConvertPopupHeaderText">
      <span class="ConvertPopupTitle">{{ 'ConfirmStatusChangeTitle' | translate }}</span>
      <span class="ConvertPopupRef">{{ CurrentOrder?.ReferenceNumber }}</span>
    </div>
    <i class="material-icons ConvertPopupClose" (click)="cancelProgressStatusChange();">close</i>
  </div>
  <div class="ConvertPopupBody">
    <p class="ConvertPopupMessage">{{ 'ConfirmStatusChangeMessage' | translate }}</p>
    <div class="StatusChangeItemsList">
      <div class="StatusChangeItem" *ngFor="let item of statusChangeConfirmItems">
        <div class="StatusChangeItemProduct">
          <span class="StatusChangeItemBrand" *ngIf="item.brand">{{ item.brand }}</span>
          <span class="StatusChangeItemName">{{ item.name }}</span>
        </div>
        <div class="StatusChangeItemTransition">
          <span class="StatusChangeFrom">{{ item.currentStatusName }}</span>
          <i class="material-icons StatusChangeArrow">arrow_forward</i>
          <span class="StatusChangeTo">{{ item.nextStatusName }}</span>
        </div>
      </div>
    </div>
  </div>
  <div class="ConvertPopupFooter">
    <div class="GridCommandButton" (click)="cancelProgressStatusChange();">
      <i class="material-icons">close</i>
      <span>{{ 'Cancel' | translate }}</span>
    </div>
    <div class="GridCommandButton GridCommandButtonOrange" (click)="confirmProgressStatusChange();">
      <i class="material-icons">check</i>
      <span>{{ 'Confirm' | translate }}</span>
    </div>
  </div>
</div>

<!-- Change Sell Currency Popup -->
<div class="ConvertToOrderConfirmationOverlay" *ngIf="ShowChangeSellCurrencyPopup" (click)="ShowChangeSellCurrencyPopup = false;"></div>
<div class="ConvertToOrderConfirmationPopup animated fadeInDown" *ngIf="ShowChangeSellCurrencyPopup" style="width: 420px; left: calc(50% - 210px); top: 25%;">
  <div class="ConvertPopupHeader">
    <div class="ConvertPopupIconWrapper">
      <i class="material-icons">currency_exchange</i>
    </div>
    <div class="ConvertPopupHeaderText">
      <span class="ConvertPopupTitle">{{ 'ChangeSellCurrency' | translate }}</span>
      <span class="ConvertPopupRef">{{ CurrentOrder?.ReferenceNumber }}</span>
    </div>
    <i class="material-icons ConvertPopupClose" (click)="ShowChangeSellCurrencyPopup = false;">close</i>
  </div>
  <div class="ConvertPopupBody" style="padding: 20px;">
    <div class="ConvertPopupMessage important" style="margin-bottom: 16px;">
      <i class="material-icons" style="color: #f60; font-size: 20px; flex-shrink: 0;">warning</i>
      <span>{{ 'ChangeSellCurrencyExplanation' | translate }}</span>
    </div>
    <div class="CurrencySearchContainer">
      <div class="CurrencySearchBar" (click)="showSellCurrencyResults = !showSellCurrencyResults">
        <span class="currency-label">{{'Currency' | translate}}</span>
        <input
          type="text"
          class="CurrencySearchInput"
          [value]="selectedSellCurrency ? selectedSellCurrency.Symbol + ' - ' + selectedSellCurrency.Name : ''"
          readonly
        />
        <i class="material-icons dropdown-icon">arrow_drop_down</i>
      </div>
      <div class="CurrencySearchResults" *ngIf="showSellCurrencyResults && parent.masterData?.Currencies?.length > 0">
        <div class="CurrencySearchResult" *ngFor="let c of parent.masterData?.Currencies" (click)="selectSellCurrency(c)" [class.selected]="selectedSellCurrency?.ID === c.ID">
          <div class="CurrencyResultMain">
            <span class="CurrencyResultSymbol">{{c.Symbol}}</span>
            <span class="CurrencyResultName">{{c.Name}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="ConvertPopupFooter">
    <div class="GridCommandButton" [class.disabled]="this.parent.loading" (click)="ShowChangeSellCurrencyPopup = false;">
      <i class="material-icons">close</i>
      <span>{{ 'Cancel' | translate }}</span>
    </div>
    <div class="GridCommandButton GridCommandButtonGreen" [class.disabled]="this.parent.loading || !selectedSellCurrency" (click)="confirmChangeSellCurrency();">
      <i class="material-icons" *ngIf="!this.parent.loading">check</i>
      <span *ngIf="!this.parent.loading">{{ 'Save' | translate }}</span>
      <mat-spinner *ngIf="this.parent.loading" diameter="18"></mat-spinner>
    </div>
  </div>
</div>


<!-- ✅ PO Purchase Data Missing Warning Popup -->
<div class="ModernPopupOverlay ModernPopupOverlayTop" *ngIf="ShowPOPurchaseDataWarning" (click)="closePOPurchaseDataWarning()">
  <div class="ModernPopup medium" (click)="$event.stopPropagation()" style="max-height: 70vh;">
    <!-- Header -->
    <div class="ModernPopupHeader GeneratePOPopupHeader" style="padding: 8px 14px; background: linear-gradient(135deg, #d32f2f 0%, #c62828 100%);">
      <div class="ModernPopupTitle" style="gap: 6px; font-size: 12px;">
        <i class="material-icons" style="font-size: 16px;">error_outline</i>
        <span>{{ 'POPurchaseDataMissingTitle' | translate }}</span>
      </div>
      <button class="ModernPopupClose" (click)="closePOPurchaseDataWarning()" style="width: 26px; height: 26px;">
        <i class="material-icons" style="font-size: 15px; color: #fff;">close</i>
      </button>
    </div>

    <!-- Body -->
    <div class="ModernPopupBody" style="padding: 10px 12px; overflow-y: auto; max-height: calc(70vh - 100px);">
      <!-- Description message -->
      <div style="font-size: 11px; color: #555; margin-bottom: 10px; line-height: 1.5;">
        {{ 'POPurchaseDataMissingDesc' | translate }}
      </div>

      <!-- Items count badge -->
      <div style="display: inline-flex; align-items: center; gap: 4px; background: rgba(211, 47, 47, 0.08); color: #d32f2f; padding: 3px 10px; border-radius: 10px; font-size: 10px; font-weight: 600; margin-bottom: 8px;">
        <i class="material-icons" style="font-size: 13px;">inventory_2</i>
        {{ POPurchaseDataWarningItems.length }} {{ 'ItemsWithIssues' | translate }}
      </div>

      <!-- Warning items list -->
      <div class="GeneratePOSupplierGroup" style="margin-bottom: 0;">
        <div *ngFor="let item of POPurchaseDataWarningItems; let i = index"
             style="display: flex; align-items: center; gap: 8px; padding: 6px 12px; border-bottom: 1px solid #f0f0f0; font-size: 10px;"
             [style.background]="i % 2 === 0 ? '#fff' : '#fafafa'">
          <i class="material-icons" style="font-size: 14px; color: #d32f2f;">error_outline</i>
          <span style="color: #333; font-weight: 500; font-size: 10px; flex: 1; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{ item.product }}</span>
          <span style="color: #d32f2f; font-size: 9px; font-weight: 600; background: rgba(211, 47, 47, 0.08); padding: 2px 8px; border-radius: 8px; flex-shrink: 0;">{{ item.missing }}</span>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="ModernPopupFooter GeneratePOPopupFooter" style="padding: 8px 14px; gap: 8px;">
      <button class="ModernButton outline" (click)="closePOPurchaseDataWarning()" style="padding: 5px 12px; font-size: 11px;">
        <i class="material-icons" style="font-size: 15px;">close</i>
        <span>{{ 'Close' | translate }}</span>
      </button>
      <button class="ModernButton POGetBestOffersBtn"
              (click)="getBestOffersAndGeneratePO()"
              [disabled]="POPurchaseDataBestOffersLoading"
              style="padding: 5px 14px; font-size: 11px;">
        <i class="material-icons" style="font-size: 15px;" *ngIf="!POPurchaseDataBestOffersLoading">auto_fix_high</i>
        <mat-spinner *ngIf="POPurchaseDataBestOffersLoading" diameter="14" style="margin-right: 4px;"></mat-spinner>
        <span>{{ 'GetBestOffersAndContinue' | translate }}</span>
      </button>
    </div>
  </div>
</div>

<!-- ✅ PO Mixed Purchase Currency Warning Popup -->
<div class="ModernPopupOverlay ModernPopupOverlayTop" *ngIf="ShowPOMixedCurrencyWarning" (click)="closePOMixedCurrencyWarning()">
  <div class="ModernPopup medium" (click)="$event.stopPropagation()" style="max-height: 70vh;">
    <!-- Header -->
    <div class="ModernPopupHeader GeneratePOPopupHeader" style="padding: 8px 14px; background: linear-gradient(135deg, #e65100 0%, #d84315 100%);">
      <div class="ModernPopupTitle" style="gap: 6px; font-size: 12px;">
        <i class="material-icons" style="font-size: 16px;">currency_exchange</i>
        <span>{{ 'POMixedCurrencyTitle' | translate }}</span>
      </div>
      <button class="ModernPopupClose" (click)="closePOMixedCurrencyWarning()" style="width: 26px; height: 26px;">
        <i class="material-icons" style="font-size: 15px; color: #fff;">close</i>
      </button>
    </div>

    <!-- Body -->
    <div class="ModernPopupBody" style="padding: 10px 12px; overflow-y: auto; max-height: calc(70vh - 100px);">
      <!-- Description -->
      <div style="font-size: 11px; color: #555; margin-bottom: 10px; line-height: 1.5;">
        {{ 'POMixedCurrencyDesc' | translate }}
      </div>

      <!-- Grouped items by supplier + currency -->
      <div class="GeneratePOSupplierGroup" style="margin-bottom: 0;">
        <div *ngFor="let group of POMixedCurrencyWarningItems; let i = index"
             style="padding: 6px 12px; border-bottom: 1px solid #f0f0f0; font-size: 10px;"
             [style.background]="i % 2 === 0 ? '#fff' : '#fafafa'">
          <div style="display: flex; align-items: center; gap: 6px; margin-bottom: 3px;">
            <i class="material-icons" style="font-size: 14px; color: #e65100;">business</i>
            <span style="font-weight: 600; color: #333; font-size: 10px;">{{ group.supplier }}</span>
            <span style="color: #fff; font-size: 9px; font-weight: 700; background: #e65100; padding: 1px 8px; border-radius: 8px;">{{ group.currency }}</span>
          </div>
          <div *ngFor="let product of group.products" style="padding: 2px 0 2px 22px; color: #555; font-size: 9px;">
            • {{ product }}
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="ModernPopupFooter GeneratePOPopupFooter" style="padding: 8px 14px; gap: 8px;">
      <button class="ModernButton outline" (click)="closePOMixedCurrencyWarning()" style="padding: 5px 12px; font-size: 11px;">
        <i class="material-icons" style="font-size: 15px;">close</i>
        <span>{{ 'Cancel' | translate }}</span>
      </button>
      <button class="ModernButton success GeneratePOSaveButton" (click)="proceedWithMixedCurrencyPOs()" style="padding: 5px 12px; font-size: 11px;">
        <i class="material-icons" style="font-size: 15px;">call_split</i>
        <span>{{ 'ProceedSplitByCurrency' | translate }}</span>
      </button>
    </div>
  </div>
</div>


<!-- ✅ PO Pre-Check Warning Popup (matches GeneratePO container style) -->
<div class="ModernPopupOverlay ModernPopupOverlayTop" *ngIf="ShowPOPreCheckWarning" (click)="preCheckClose()">
  <div class="ModernPopup medium" (click)="$event.stopPropagation()" style="max-height: 70vh;">
    <!-- Header — same #f60 as GeneratePOPopupHeader -->
    <div class="ModernPopupHeader GeneratePOPopupHeader" style="padding: 8px 14px;">
      <div class="ModernPopupTitle" style="gap: 6px; font-size: 12px;">
        <i class="material-icons" style="font-size: 16px;">warning</i>
        <span>{{ 'ProgressStatusWarning' | translate }}</span>
      </div>
      <button class="ModernPopupClose" (click)="preCheckClose()" style="width: 26px; height: 26px;">
        <i class="material-icons" style="font-size: 15px; color: #fff;">close</i>
      </button>
    </div>

    <!-- Body -->
    <div class="ModernPopupBody" style="padding: 10px 12px; overflow-y: auto; max-height: calc(70vh - 100px);">
      <!-- Warning message -->
      <div style="font-size: 11px; color: #555; margin-bottom: 8px; line-height: 1.5;">
        {{ POPreCheckWarningItems.length }} {{ 'ItemsAlreadyOrdered' | translate }}:
      </div>

      <!-- Warning items list — styled like GeneratePOSupplierGroup -->
      <div class="GeneratePOSupplierGroup" style="margin-bottom: 0;">
        <div *ngFor="let item of POPreCheckWarningItems; let i = index"
             style="display: flex; align-items: center; gap: 8px; padding: 6px 12px; border-bottom: 1px solid #f0f0f0; font-size: 10px;"
             [style.background]="i % 2 === 0 ? '#fff' : '#fafafa'">
          <i class="material-icons" style="font-size: 14px; color: #f60;">error_outline</i>
          <span *ngIf="item.Product?.Brand?.Name" style="color: #888; font-weight: 600; font-size: 9px; flex-shrink: 0; min-width: 40px;">{{ item.Product.Brand.Name }}</span>
          <span *ngIf="item.Product?.PartNumber" style="color: #555; font-weight: 500; font-size: 9px; flex-shrink: 0;">{{ item.Product.PartNumber }}</span>
          <span style="flex: 1; color: #333; font-weight: 400; font-size: 9px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{ item.Product?.Name || item.UIProductValue || 'Unknown' }}</span>
          <span style="color: #666; font-size: 9px; flex-shrink: 0; font-weight: 600;">x{{ item.Quantity }}</span>
          <span style="color: #f60; font-size: 9px; font-weight: 600; background: rgba(255,102,0,0.1); padding: 1px 6px; border-radius: 8px; flex-shrink: 0;">{{ item.ProgressStatus?.Alias || item.ProgressStatus?.Name }}</span>
        </div>
      </div>

      <!-- Valid items note -->
      <div *ngIf="POPreCheckValidItems.length > 0" style="font-size: 10px; color: #888; margin-top: 8px; font-style: italic;">
        {{ POPreCheckValidItems.length }} {{ 'ItemsNotOrdered' | translate }}
      </div>
    </div>

    <!-- Footer — same style as GeneratePOPopupFooter -->
    <div class="ModernPopupFooter GeneratePOPopupFooter" style="padding: 8px 14px; gap: 8px;">
      <button class="ModernButton outline" (click)="preCheckClose()" style="padding: 5px 12px; font-size: 11px;">
        <i class="material-icons" style="font-size: 15px;">close</i>
        <span>{{ 'Close' | translate }}</span>
      </button>
      <button class="ModernButton success GeneratePOSaveButton" *ngIf="POPreCheckValidItems.length > 0" (click)="preCheckRemoveAndProceed()" style="padding: 5px 12px; font-size: 11px;">
        <i class="material-icons" style="font-size: 15px;">delete_outline</i>
        <span>{{ 'RemoveAndContinue' | translate }}</span>
      </button>
      <button class="ModernButton outline" (click)="preCheckIgnoreAndProceed()" style="padding: 5px 12px; font-size: 11px; border-color: #999; color: #666;">
        <i class="material-icons" style="font-size: 15px;">skip_next</i>
        <span>{{ 'IgnoreAndContinue' | translate }}</span>
      </button>
    </div>
  </div>
</div>

<!-- ✅ NEW PO Pre-Popup: choose a supplier, then generate an EMPTY PO for him -->
<div class="ModernPopupOverlay ModernPopupOverlayTop" *ngIf="showNewPOPartnerPopup" (click)="closeNewPOPartnerPopup()">
  <div class="ModernPopup medium" (click)="$event.stopPropagation()" style="max-height: 70vh;">
    <!-- Header — same #f60 as GeneratePOPopupHeader -->
    <div class="ModernPopupHeader GeneratePOPopupHeader" style="padding: 8px 14px;">
      <div class="ModernPopupTitle" style="gap: 6px; font-size: 12px;">
        <i class="material-icons" style="font-size: 16px;">add_shopping_cart</i>
        <span>{{ 'NewPO' | translate }}</span>
      </div>
      <button class="ModernPopupClose" (click)="closeNewPOPartnerPopup()" style="width: 26px; height: 26px;">
        <i class="material-icons" style="font-size: 15px; color: #fff;">close</i>
      </button>
    </div>

    <!-- Body -->
    <div class="ModernPopupBody" style="padding: 10px 14px;">
      <div style="margin-bottom: 8px;">
        <input type="text" class="supplier-popup-search-input" placeholder="{{ 'SearchPartner' | translate }}"
               [(ngModel)]="newPOPartnerSearchTerm" (ngModelChange)="newPOPartnerSearchUpdate.next($event)"
               style="width: 100%; padding: 7px 10px; border: 1px solid #ddd; border-radius: 4px; font-size: 12px; outline: none; box-sizing: border-box;" />
      </div>

      <div *ngIf="loadingNewPOPartners" style="padding: 15px; text-align: center;">
        <mat-spinner [diameter]="22"></mat-spinner>
      </div>

      <div *ngIf="!loadingNewPOPartners && newPOPartners?.length > 0" style="max-height: 320px; overflow-y: auto;">
        <div class="supplier-popup-item" *ngFor="let p of newPOPartners" (click)="selectNewPOPartner(p)"
             style="display: flex; align-items: center; gap: 8px; padding: 8px 12px; border-bottom: 1px solid #f0f0f0; cursor: pointer; font-size: 11px;">
          <i class="material-icons" style="font-size: 15px; color: #f60;">business</i>
          <span style="flex: 1; color: #333; font-weight: 500;">{{ p?.Name }}</span>
          <span *ngIf="p?.VAT || p?.VATNumber" style="color: #888; font-size: 9px;">{{ p?.VAT || p?.VATNumber }}</span>
        </div>
      </div>

      <div *ngIf="!loadingNewPOPartners && newPOPartners?.length === 0 && newPOPartnerSearchTerm"
           style="padding: 12px; text-align: center; color: #999; font-size: 11px;">
        {{ 'NoPartnersFound' | translate }}
      </div>
    </div>
  </div>
</div>

<!-- ✅ Generate PO Popup - ModernPopup style with AG Grid -->
<div class="ModernPopupOverlay ModernPopupOverlayTop" *ngIf="ShowGeneratePOPopup">
  <div class="ModernPopup xxlarge" style="height: 85vh;" (click)="$event.stopPropagation()">
    <!-- Popup Header -->
    <div class="ModernPopupHeader GeneratePOPopupHeader">
      <div class="ModernPopupTitle">
        <i class="material-icons">shopping_cart</i>
        <span>{{ 'GeneratePO' | translate }} - Configure Purchase Orders</span>
      </div>
      <button class="ModernPopupClose" (click)="closeGeneratePOPopup()">
        <i class="material-icons">close</i>
      </button>
    </div>

    <!-- Popup Body -->
    <div class="ModernPopupBody" style="padding: 10px 12px; overflow-y: auto; flex: 1; max-height: calc(85vh - 90px);">

      <!-- ✅ Loading state while API is being called -->
      <div class="GeneratePOLoadingState" *ngIf="GeneratedPurchaseOrders.length === 0 && parent.loading" style="display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 48px;">
        <mat-spinner diameter="48"></mat-spinner>
        <span style="margin-top: 16px; color: #666; font-size: 14px;">Generating Purchase Orders...</span>
      </div>

      <!-- ✅ No results message -->
      <div class="GeneratePONoResults" *ngIf="GeneratedPurchaseOrders.length === 0 && !parent.loading" style="display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 48px;">
        <i class="material-icons" style="font-size: 48px; color: #ccc;">inventory_2</i>
        <span style="margin-top: 16px; color: #666; font-size: 14px;">No Purchase Orders generated</span>
      </div>

      <!-- ✅ Display Generated Purchase Orders with Shipping Settings -->
      <div class="GeneratePOSupplierGroups" *ngIf="GeneratedPurchaseOrders.length > 0">
        <div class="GeneratePOSupplierGroup" *ngFor="let po of GeneratedPurchaseOrders; let poIndex = index">
          <!-- PO Header - Partner is on po.Cart.Partner (set by backend ConvertFromCartItems) -->
          <div class="GeneratePOSupplierHeader" (click)="togglePOGroupCollapse(poIndex)" style="cursor: pointer;">
            <i class="material-icons">business</i>
            <span class="GeneratePOSupplierName">{{ poIndex + 1 }}). {{ po.Cart?.Partner?.Name || 'Supplier' }}</span>
            <span class="GeneratePOSupplierVAT" *ngIf="po.Cart?.Partner?.VAT || po.Cart?.Partner?.VATNumber">(VAT: {{ po.Cart?.Partner?.VAT || po.Cart?.Partner?.VATNumber }})</span>
            <span class="GeneratePOSupplierLocation" *ngIf="po.Cart?.Partner?.BillingAddress?.Country?.ShortName || po.Cart?.Partner?.BillingAddress?.City">
              - ({{ po.Cart?.Partner?.BillingAddress?.Country?.ShortName || '' }}{{ po.Cart?.Partner?.BillingAddress?.Country?.ShortName && po.Cart?.Partner?.BillingAddress?.City ? ', ' : '' }}{{ po.Cart?.Partner?.BillingAddress?.City || '' }})
            </span>
            <span class="GeneratePOSupplierCount">({{ po.Cart?.Items?.length || 0 }} {{ (po.Cart?.Items?.length || 0) === 1 ? 'item' : 'items' }})</span>
            <!-- Collapse / Delete controls -->
            <div class="GeneratePOHeaderActions">
              <button class="GeneratePOCollapseBtn" (click)="togglePOGroupCollapse(poIndex); $event.stopPropagation();" title="Collapse / Expand">
                <i class="material-icons" [class.collapsed]="generatePOGroupCollapsed[poIndex]">expand_more</i>
              </button>
              <button class="GeneratePODeleteBtn" (click)="removePOGroup(poIndex); $event.stopPropagation();" title="Remove">
                <i class="material-icons">close</i>
              </button>
            </div>
          </div>

          <!-- ✅ Collapsible PO Group Content -->
          <div class="GeneratePOGroupContent" *ngIf="!generatePOGroupCollapsed[poIndex]">

          <!-- ✅ Purchase Currency Selector for this PO (following CurrencySearchContainer pattern) -->
          <div class="CurrencySearchContainer" style="margin: 4px 0; position: relative;width: 100%;padding-left: 1%; padding-right: 1%;">
            <!-- Transparent Overlay (closes currency results when clicking outside) -->
            <div class="EditContainerOverlayTransparent" *ngIf="showGeneratePOCurrencyResults[poIndex]" (click)="showGeneratePOCurrencyResults[poIndex] = false"></div>

            <div class="CurrencySearchBar" (click)="toggleGeneratePOCurrencyDropdown(poIndex)" style="width:100%;">
              <i class="material-icons">attach_money</i>
              <span class="currency-label">{{ getGeneratePOCurrentCurrency(poIndex) }}</span>
              <i class="material-icons">expand_more</i>
            </div>

            <div class="CurrencySearchResults" *ngIf="showGeneratePOCurrencyResults[poIndex] && parent.masterData?.Currencies?.length > 0" style="width: 98%; margin-left: 1%;">
              <div class="CurrencySearchResult" *ngFor="let c of parent.masterData.Currencies" (click)="selectGeneratePOCurrency(poIndex, c)">
                <span class="CurrencyName">{{c.Name}}</span>
                <span class="CurrencySymbol">{{c.Symbol}}</span>
              </div>
            </div>
          </div>

          <!-- PO's AG Grid -->
          <div class="GeneratePOGridContainer" [style.height.px]="getGeneratePOGridHeight(po.Cart?.Items?.length || 0)" style="position: relative;">
            <ag-grid-angular
              class="ag-theme-alpine admin-grid"
              style="width: 100%; height: 100%;"
              [rowData]="po.Cart?.Items || []"
              [columnDefs]="generatePOColumnDefs"
              [defaultColDef]="{ resizable: true, sortable: true }"
              [gridOptions]="generatePOGridOptions"
              (gridReady)="onGeneratePOGridReady($event, poIndex)"
              (cellValueChanged)="onGeneratePOCellValueChanged($event, poIndex)">
            </ag-grid-angular>
          </div>

          <!-- ✅ Add rows button bar -->
          <div style="display: flex; align-items: center; gap: 8px; padding: 4px 8px; border-bottom: 1px solid #e5e7eb;">
            <button class="POAccentBtn" style="font-size: 10px; padding: 3px 10px;" (click)="addMoreGeneratePORows(poIndex, 10)">
              <i class="material-icons" style="font-size: 13px; margin-right: 3px;">add</i>
              {{ 'AddRows' | translate }}
            </button>
          </div>

          <!-- ✅ Deselect all button -->
          <div *ngIf="hasSelectedGeneratePOItems(poIndex)" class="GeneratePODeselectBar" (click)="deselectAllGeneratePOItems(poIndex)">
            <i class="material-icons">close</i>
            <span>{{ 'DeselectAll' | translate }}</span>
          </div>

          <!-- ✅ PO Settings Sections (Totals, Terms, Contact Info, Shipping) -->
          <div class="GeneratePOShippingSettings">

            <!-- 1. Totals Section (Financial Summary at the top) -->
            <div class="ModernFormSection" style="width: 100%; margin-bottom: 6px;">
              <div class="ModernFormSectionHeader AppleSectionHeader" (click)="togglePOSection(poIndex, 'totals')">
                <div class="AppleSectionHeaderLeft">
                  <i class="material-icons AppleSectionIcon">calculate</i>
                  <span class="AppleSectionTitle">{{ 'TotalsSection' | translate }}</span>
                </div>
                <i class="material-icons AppleSectionChevron" [class.collapsed]="generatePOSectionCollapsed[poIndex]?.totals">expand_more</i>
              </div>

              <div class="AppleSectionContent" *ngIf="!generatePOSectionCollapsed[poIndex]?.totals">
                <!-- Discount Row -->
                <div class="CustomDropdownContainer" style="margin-top: 6px; max-width: 50%;">
                  <div style="display: flex; align-items: center; gap: 6px; width: 100%;">
                    <span style="font-size: 10px; font-weight: 500; color: #6c757d; width: 70px; flex-shrink: 0;">{{ 'Discount' | translate }}:</span>
                    <!-- Discount Type Dropdown -->
                    <div style="flex: 1; min-width: 100px; position: relative;" [class.dropdown-open]="generatePODropdownStates[poIndex]?.showDiscountType" [style.z-index]="generatePODropdownStates[poIndex]?.showDiscountType ? 1000 : 1">
                      <div class="SendEmailOverlayTransparent" *ngIf="generatePODropdownStates[poIndex]?.showDiscountType" (click)="closePODropdowns(poIndex)"></div>
                      <div class="CustomDropdownBar" (click)="togglePODiscountType(poIndex)">
                        <i class="material-icons dropdown-icon-left" style="font-size: 14px;">percent</i>
                        <input type="text" class="CustomDropdownInput" readonly
                               [class.placeholder]="!po.Discount?.Type"
                               [value]="po.Discount?.Type?.Name || 'Select...'" />
                        <i class="material-icons dropdown-icon">arrow_drop_down</i>
                      </div>
                      <div class="CustomDropdownResults" *ngIf="generatePODropdownStates[poIndex]?.showDiscountType">
                        <div class="CustomDropdownResult" *ngFor="let type of parent.masterData?.DiscountTypes" (click)="selectPODiscountType(poIndex, type)">
                          <div class="CustomDropdownResultMain">
                            <span class="CustomDropdownResultText">{{ type.Name }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Discount Value Input -->
                    <div style="flex: 0 0 60px;">
                      <div class="CustomDropdownBar" style="padding: 0 6px;">
                        <input type="text" class="CustomDropdownInput" [(ngModel)]="po.Discount.Value"
                               placeholder="0" style="text-align: center;"
                               (click)="$event.target.select()"
                               (keypress)="validateDecimalInput($event)" />
                      </div>
                    </div>
                    <!-- Apply Button -->
                    <button class="POAccentBtn" (click)="applyPODiscount(poIndex)"
                            [disabled]="!po.Discount?.Type || !po.Discount?.Value"
                            style="height: 28px; width: 28px; padding: 0; min-width: 28px; display:flex; align-items:center; justify-content:center; cursor:pointer;">
                      <i class="material-icons" style="font-size: 15px;">check</i>
                    </button>
                    <!-- Clear Button -->
                    <button class="POClearBtn" (click)="clearPODiscount(poIndex)"
                            [disabled]="!po.Discount?.Type && !po.Discount?.Value"
                            style="height: 28px; width: 28px; padding: 0; min-width: 28px; display:flex; align-items:center; justify-content:center; cursor:pointer;">
                      <i class="material-icons" style="font-size: 15px;">close</i>
                    </button>
                  </div>
                </div>

                <!-- Shipping Cost Input -->
                <div class="CustomDropdownContainer" style="margin-top: 6px; max-width: 50%;">
                  <div style="display: flex; align-items: center; gap: 6px; width: 100%;">
                    <span style="font-size: 10px; font-weight: 500; color: #6c757d; width: 70px; flex-shrink: 0;">{{ 'ShippingCost' | translate }}:</span>
                    <div style="flex: 1;">
                      <div class="CustomDropdownBar" style="padding: 0 8px;">
                        <i class="material-icons dropdown-icon-left" style="font-size: 14px;">local_shipping</i>
                        <input type="text" class="CustomDropdownInput" [(ngModel)]="po.Cart.ShippingCost.UIUnitPrice"
                               placeholder="0.00" style="text-align: right;"
                               (click)="$event.target.select()"
                               (keypress)="validateDecimalInput($event)" />
                        <span style="margin-left: 6px; font-weight: 600; color: #666; font-size: 10px;">{{ po.Cart?.Currency?.Symbol || '' }}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Totals Display -->
                <div class="totals-section" style="margin-top: 6px;">
                  <div class="total-row subtotal-row">
                    <span class="total-label">{{ 'Subtotal' | translate }}:</span>
                    <span class="total-value subtotal-value">{{ getPOSubtotal(poIndex) | number:'1.2-2' }} {{ po.Cart?.Currency?.Symbol }}</span>
                  </div>
                  <div class="total-row discount-row" *ngIf="po.Discount?.Applied && po.Discount?.Value > 0">
                    <span class="total-label discount-label">
                      {{ 'ProjectDiscount' | translate }}
                      (<ng-container *ngIf="po.Discount?.Type?.ID === 1">{{ po.Discount?.Value | number:'1.2-2' }}%</ng-container><ng-container *ngIf="po.Discount?.Type?.ID === 2">{{ po.Discount?.Value | number:'1.2-2' }} {{ po.Cart?.Currency?.Symbol }}</ng-container>):
                    </span>
                    <span class="total-value discount-value">- {{ getPODiscountAmount(poIndex) | number:'1.2-2' }} {{ po.Cart?.Currency?.Symbol }}</span>
                  </div>
                  <div class="total-row subtotal-after-discount-row" *ngIf="po.Discount?.Applied && po.Discount?.Value > 0">
                    <span class="total-label">{{ 'SubtotalAfterDiscount' | translate }}:</span>
                    <span class="total-value">{{ getPOSubtotalAfterDiscount(poIndex) | number:'1.2-2' }} {{ po.Cart?.Currency?.Symbol }}</span>
                  </div>
                  <!-- Shipping + Purchase Total Row (side by side) -->
                  <div class="shipping-purchase-row">
                    <div class="total-row shipping-row">
                      <span class="total-label">{{ 'ShippingCost' | translate }}:</span>
                      <span class="total-value shipping-value">{{ getPOShippingCost(poIndex) | number:'1.2-2' }} {{ po.Cart?.Currency?.Symbol }}</span>
                    </div>
                    <div class="total-row purchase-total-row" *ngIf="po.Cart.PurchaseTotal?.TotalQtyPriceNOVAT > 0">
                      <span class="total-label">{{'PurchaseTotalNoVAT' | translate}}:</span>
                      <span class="total-value">{{ po.Cart.PurchaseTotal.TotalQtyPriceNOVAT | number:'1.2-2' }} {{ po.Cart.PurchaseTotal?.Currency?.Symbol || po.Cart?.Currency?.Symbol }}</span>
                    </div>
                  </div>
                  <!-- Pure Profit Row -->
                  <div class="total-row pure-profit-row" *ngIf="po.Cart.Total?.TotalPureProfit != null" [ngClass]="{'profit-positive': po.Cart.Total.TotalPureProfit > 0, 'profit-negative': po.Cart.Total.TotalPureProfit < 0}">
                    <span class="total-label">{{'PureProfit' | translate}}:</span>
                    <span class="total-value">{{ po.Cart.Total.TotalPureProfit | number:'1.2-2' }} {{ po.Cart?.Currency?.Symbol }}</span>
                  </div>
                  <div class="total-row absolute-total-row">
                    <span class="total-label">{{ 'GrandTotal' | translate }}:</span>
                    <span class="total-value absolute-total-value">{{ getPOGrandTotal(poIndex) | number:'1.2-2' }} {{ po.Cart?.Currency?.Symbol }}</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- 2. Terms Section -->
            <div class="ModernFormSection" style="width: 100%; margin-bottom: 6px;">
              <div class="ModernFormSectionHeader AppleSectionHeader" (click)="togglePOSection(poIndex, 'terms')">
                <div class="AppleSectionHeaderLeft">
                  <i class="material-icons AppleSectionIcon">receipt_long</i>
                  <span class="AppleSectionTitle">{{ 'TermsSection' | translate }}</span>
                </div>
                <i class="material-icons AppleSectionChevron" [class.collapsed]="generatePOSectionCollapsed[poIndex]?.terms">expand_more</i>
              </div>

              <div class="AppleSectionContent" *ngIf="!generatePOSectionCollapsed[poIndex]?.terms">
                <!-- Payment Term Dropdown -->
                <div class="CustomDropdownContainer" [class.dropdown-open]="generatePODropdownStates[poIndex]?.showPaymentTerm">
                  <div class="SendEmailOverlayTransparent" *ngIf="generatePODropdownStates[poIndex]?.showPaymentTerm" (click)="closePODropdowns(poIndex)"></div>
                  <div class="CustomDropdownBar" (click)="togglePOPaymentTerm(poIndex)">
                    <span class="dropdown-label">{{ 'SelectPaymentTerm' | translate }}</span>
                    <i class="material-icons dropdown-icon-left">receipt_long</i>
                    <i class="material-icons send-email-icon" [style.color]="po.Cart?.PaymentTerm?.ID ? '#f60' : '#ccc'">
                      {{ po.Cart?.PaymentTerm?.ID ? 'check_circle' : 'radio_button_unchecked' }}
                    </i>
                    <input type="text" class="CustomDropdownInput" [class.placeholder]="!po.Cart?.PaymentTerm" [value]="po.Cart?.PaymentTerm?.Name || ''" readonly />
                    <i class="material-icons dropdown-icon">arrow_drop_down</i>
                  </div>
                  <div class="CustomDropdownResults" *ngIf="generatePODropdownStates[poIndex]?.showPaymentTerm">
                    <div class="CustomDropdownResult" *ngFor="let term of parent.CartMasterData?.PaymentTerms" (click)="selectPOPaymentTerm(poIndex, term)">
                      <div class="CustomDropdownResultMain">
                        <i class="material-icons" [style.color]="po.Cart?.PaymentTerm?.ID === term.ID ? '#f60' : '#ccc'">
                          {{ po.Cart?.PaymentTerm?.ID === term.ID ? 'check_circle' : 'radio_button_unchecked' }}
                        </i>
                        <span class="CustomDropdownResultText">{{ term.Name }}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Payment Type Dropdown -->
                <div class="CustomDropdownContainer" [class.dropdown-open]="generatePODropdownStates[poIndex]?.showPaymentType">
                  <div class="SendEmailOverlayTransparent" *ngIf="generatePODropdownStates[poIndex]?.showPaymentType" (click)="closePODropdowns(poIndex)"></div>
                  <div class="CustomDropdownBar" (click)="togglePOPaymentType(poIndex)">
                    <span class="dropdown-label">{{ 'SelectPaymentType' | translate }}</span>
                    <i class="material-icons dropdown-icon-left">payment</i>
                    <i class="material-icons send-email-icon" [style.color]="po.Cart?.PaymentType?.ID ? '#f60' : '#ccc'">
                      {{ po.Cart?.PaymentType?.ID ? 'check_circle' : 'radio_button_unchecked' }}
                    </i>
                    <input type="text" class="CustomDropdownInput" [class.placeholder]="!po.Cart?.PaymentType" [value]="po.Cart?.PaymentType?.Name || ''" readonly />
                    <i class="material-icons dropdown-icon">arrow_drop_down</i>
                  </div>
                  <div class="CustomDropdownResults" *ngIf="generatePODropdownStates[poIndex]?.showPaymentType">
                    <div class="CustomDropdownResult" *ngFor="let type of parent.CartMasterData?.PaymentTypes" (click)="selectPOPaymentType(poIndex, type)">
                      <div class="CustomDropdownResultMain">
                        <i class="material-icons" [style.color]="po.Cart?.PaymentType?.ID === type.ID ? '#f60' : '#ccc'">
                          {{ po.Cart?.PaymentType?.ID === type.ID ? 'check_circle' : 'radio_button_unchecked' }}
                        </i>
                        <span class="CustomDropdownResultText">{{ type.Name }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 3. Contact Info Section -->
            <div class="ModernFormSection" style="width: 100%; margin-bottom: 6px;">
              <div class="ModernFormSectionHeader AppleSectionHeader" (click)="togglePOSection(poIndex, 'contactInfo')">
                <div class="AppleSectionHeaderLeft">
                  <i class="material-icons AppleSectionIcon">contact_mail</i>
                  <span class="AppleSectionTitle">{{ 'ContactInfoSection' | translate }}</span>
                </div>
                <i class="material-icons AppleSectionChevron" [class.collapsed]="generatePOSectionCollapsed[poIndex]?.contactInfo">expand_more</i>
              </div>

              <div class="AppleSectionContent" *ngIf="!generatePOSectionCollapsed[poIndex]?.contactInfo">
                <!-- Send Email Dropdown -->
                <div class="SendEmailSearchContainer" [class.dropdown-open]="generatePODropdownStates[poIndex]?.showSendEmail" style="margin-top: 6px;">
                  <div class="SendEmailOverlayTransparent" *ngIf="generatePODropdownStates[poIndex]?.showSendEmail" (click)="closePODropdowns(poIndex)"></div>
                  <div class="SendEmailSearchBar" (click)="togglePOSendEmail(poIndex)">
                    <span class="send-email-label">Send Email</span>
                    <i class="material-icons send-email-icon" [style.color]="po.SendEmail ? '#f60' : '#ccc'">
                      {{ po.SendEmail ? 'check_circle' : 'radio_button_unchecked' }}
                    </i>
                    <input type="text" class="SendEmailSearchInput" [value]="po.SendEmail ? 'Yes' : 'No'" readonly />
                    <i class="material-icons dropdown-icon">arrow_drop_down</i>
                  </div>
                  <div class="SendEmailSearchResults" *ngIf="generatePODropdownStates[poIndex]?.showSendEmail">
                    <div class="SendEmailSearchResult" (click)="selectPOSendEmail(poIndex, true)">
                      <div class="SendEmailResultMain">
                        <i class="material-icons" style="color: #f60;">check_circle</i>
                        <span class="SendEmailResultLabel">Yes</span>
                      </div>
                    </div>
                    <div class="SendEmailSearchResult" (click)="selectPOSendEmail(poIndex, false)">
                      <div class="SendEmailResultMain">
                        <i class="material-icons" style="color: #ccc;">radio_button_unchecked</i>
                        <span class="SendEmailResultLabel">No</span>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Partner Agents Dropdown (Multi-select) -->
                <div class="CustomDropdownContainer" [class.dropdown-open]="generatePODropdownStates[poIndex]?.showAgents" *ngIf="po.Cart?.Partner?.PartnerAgents?.length > 0">
                  <div class="SendEmailOverlayTransparent" *ngIf="generatePODropdownStates[poIndex]?.showAgents" (click)="closePODropdowns(poIndex)"></div>
                  <div class="CustomDropdownBar" (click)="togglePOAgents(poIndex)">
                    <span class="dropdown-label">{{ 'SelectAgents' | translate }}</span>
                    <i class="material-icons dropdown-icon-left">people</i>
                    <i class="material-icons send-email-icon" [style.color]="(generatePOSelectedAgents[poIndex]?.length || 0) > 0 ? '#f60' : '#ccc'">
                      {{ (generatePOSelectedAgents[poIndex]?.length || 0) > 0 ? 'check_circle' : 'radio_button_unchecked' }}
                    </i>
                    <input type="text" class="CustomDropdownInput" [class.placeholder]="(generatePOSelectedAgents[poIndex]?.length || 0) === 0"
                           [value]="getPOAgentsLabel(poIndex)" readonly />
                    <span class="selected-count" *ngIf="(generatePOSelectedAgents[poIndex]?.length || 0) > 0">{{ generatePOSelectedAgents[poIndex]?.length }}</span>
                    <i class="material-icons dropdown-icon">arrow_drop_up</i>
                  </div>
                  <div class="CustomDropdownResults CustomDropdownResultsUpward" *ngIf="generatePODropdownStates[poIndex]?.showAgents">
                    <!-- Email Input for Adding New Agent -->
                    <div class="CustomDropdownResult NewAgentInputRow">
                      <div class="NewAgentInputColumn">
                        <div class="NewAgentInputWrapper">
                          <i class="material-icons" style="color: #f60; margin-right: 8px;">person_add</i>
                          <input type="email" class="NewAgentEmailInput" [(ngModel)]="generatePONewAgentEmail[poIndex]"
                                 (input)="onPONewAgentEmailChange(poIndex)" placeholder="Enter email to add new agent..."
                                 (click)="$event.stopPropagation()" />
                        </div>
                        <button *ngIf="generatePOIsValidEmail[poIndex]" class="NewAgentAddButton"
                                (click)="createPONewAgentFromEmail(poIndex); $event.stopPropagation()" type="button">
                          <i class="material-icons">check</i>
                          <span>{{ 'AddNewAgent' | translate }}</span>
                        </button>
                      </div>
                    </div>
                    <!-- Existing Agents List -->
                    <div class="CustomDropdownResult" *ngFor="let agent of po.Cart?.Partner?.PartnerAgents" (click)="togglePOAgent(poIndex, agent)">
                      <div class="CustomDropdownResultMain">
                        <i class="material-icons" [style.color]="isPOAgentSelected(poIndex, agent) ? '#f60' : '#ccc'">
                          {{ isPOAgentSelected(poIndex, agent) ? 'check_circle' : 'radio_button_unchecked' }}
                        </i>
                        <span class="CustomDropdownResultText">{{ agent.Name }} - {{ agent.Email }}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Supplier Internal Reference -->
                <div class="ModernFormGroup" style="width: 100%; margin-top: 6px;">
                  <input type="text" class="ModernFormInput ModernFormInputOrange"
                         placeholder="{{ 'SupplierInternalReference' | translate }} ({{ 'Optional' | translate }})"
                         [(ngModel)]="po.SupplierReference"
                         (click)="$event.target.select()" />
                </div>
              </div>
            </div>

            <!-- Shipping Section -->
            <div class="ModernFormSection" style="width: 100%; margin-bottom: 6px;">
              <div class="ModernFormSectionHeader AppleSectionHeader" (click)="togglePOSection(poIndex, 'shipping')">
                <div class="AppleSectionHeaderLeft">
                  <i class="material-icons AppleSectionIcon">local_shipping</i>
                  <span class="AppleSectionTitle">{{ 'ShippingSection' | translate }}</span>
                </div>
                <i class="material-icons AppleSectionChevron" [class.collapsed]="generatePOSectionCollapsed[poIndex]?.shipping">expand_more</i>
              </div>

              <div class="AppleSectionContent" *ngIf="!generatePOSectionCollapsed[poIndex]?.shipping">
                <div class="GeneratePOShippingRow">
                  <!-- Shipping Company Dropdown -->
                  <div class="CustomDropdownContainer" [class.dropdown-open]="generatePODropdownStates[poIndex]?.showCompany">
                    <div class="SendEmailOverlayTransparent" *ngIf="generatePODropdownStates[poIndex]?.showCompany" (click)="closePODropdowns(poIndex)"></div>
                    <div class="CustomDropdownBar" (click)="togglePOShippingCompany(poIndex)">
                      <span class="dropdown-label">{{ 'SelectShippingCompany' | translate }}</span>
                      <i class="material-icons dropdown-icon-left">local_shipping</i>
                      <i class="material-icons send-email-icon" [style.color]="po.Cart?.ShippingCompany?.ID ? '#f60' : '#ccc'">
                        {{ po.Cart?.ShippingCompany?.ID ? 'check_circle' : 'radio_button_unchecked' }}
                      </i>
                      <input type="text" class="CustomDropdownInput" [class.placeholder]="!po.Cart?.ShippingCompany" [value]="po.Cart?.ShippingCompany?.Name || ''" readonly />
                      <i class="material-icons dropdown-icon">arrow_drop_up</i>
                    </div>
                    <div class="CustomDropdownResults CustomDropdownResultsUpward" *ngIf="generatePODropdownStates[poIndex]?.showCompany">
                      <div class="CustomDropdownResult" *ngFor="let company of ShippingCompanies" (click)="selectPOShippingCompany(poIndex, company)">
                        <div class="CustomDropdownResultMain">
                          <i class="material-icons" [style.color]="po.Cart?.ShippingCompany?.ID === company.ID ? '#f60' : '#ccc'">
                            {{ po.Cart?.ShippingCompany?.ID === company.ID ? 'check_circle' : 'radio_button_unchecked' }}
                          </i>
                          <span class="CustomDropdownResultText">{{ company.Name }}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Shipping Responsability Dropdown -->
                  <div class="CustomDropdownContainer" [class.dropdown-open]="generatePODropdownStates[poIndex]?.showResp">
                    <div class="SendEmailOverlayTransparent" *ngIf="generatePODropdownStates[poIndex]?.showResp" (click)="closePODropdowns(poIndex)"></div>
                    <div class="CustomDropdownBar" (click)="togglePOShippingResponsability(poIndex)">
                      <span class="dropdown-label">{{ 'SelectShippingResponsability' | translate }}</span>
                      <i class="material-icons dropdown-icon-left">assignment_ind</i>
                      <i class="material-icons send-email-icon" [style.color]="po.Cart?.ShippingResponsability?.ID ? '#f60' : '#ccc'">
                        {{ po.Cart?.ShippingResponsability?.ID ? 'check_circle' : 'radio_button_unchecked' }}
                      </i>
                      <input type="text" class="CustomDropdownInput" [class.placeholder]="!po.Cart?.ShippingResponsability" [value]="po.Cart?.ShippingResponsability?.Name || ''" readonly />
                      <i class="material-icons dropdown-icon">arrow_drop_up</i>
                    </div>
                    <div class="CustomDropdownResults CustomDropdownResultsUpward" *ngIf="generatePODropdownStates[poIndex]?.showResp">
                      <div class="CustomDropdownResult" *ngFor="let resp of ShippingResponsabilities" (click)="selectPOShippingResponsability(poIndex, resp)">
                        <div class="CustomDropdownResultMain">
                          <i class="material-icons" [style.color]="po.Cart?.ShippingResponsability?.ID === resp.ID ? '#f60' : '#ccc'">
                            {{ po.Cart?.ShippingResponsability?.ID === resp.ID ? 'check_circle' : 'radio_button_unchecked' }}
                          </i>
                          <span class="CustomDropdownResultText">{{ resp.Name }}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Shipping Service Type Dropdown -->
                  <div class="CustomDropdownContainer" [class.dropdown-open]="generatePODropdownStates[poIndex]?.showType">
                    <div class="SendEmailOverlayTransparent" *ngIf="generatePODropdownStates[poIndex]?.showType" (click)="closePODropdowns(poIndex)"></div>
                    <div class="CustomDropdownBar" (click)="togglePOShippingServiceType(poIndex)">
                      <span class="dropdown-label">{{ 'SelectShippingServiceType' | translate }}</span>
                      <i class="material-icons dropdown-icon-left">speed</i>
                      <i class="material-icons send-email-icon" [style.color]="po.Cart?.ShippingServiceType?.ID ? '#f60' : '#ccc'">
                        {{ po.Cart?.ShippingServiceType?.ID ? 'check_circle' : 'radio_button_unchecked' }}
                      </i>
                      <input type="text" class="CustomDropdownInput" [class.placeholder]="!po.Cart?.ShippingServiceType" [value]="po.Cart?.ShippingServiceType?.Name || ''" readonly />
                      <i class="material-icons dropdown-icon">arrow_drop_up</i>
                    </div>
                    <div class="CustomDropdownResults CustomDropdownResultsUpward" *ngIf="generatePODropdownStates[poIndex]?.showType">
                      <div class="CustomDropdownResult" *ngFor="let serviceType of ShippingServiceTypes" (click)="selectPOShippingServiceType(poIndex, serviceType)">
                        <div class="CustomDropdownResultMain">
                          <i class="material-icons" [style.color]="po.Cart?.ShippingServiceType?.ID === serviceType.ID ? '#f60' : '#ccc'">
                            {{ po.Cart?.ShippingServiceType?.ID === serviceType.ID ? 'check_circle' : 'radio_button_unchecked' }}
                          </i>
                          <span class="CustomDropdownResultText">{{ serviceType.Name }}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Delivery Preference Dropdown -->
                  <div class="CustomDropdownContainer" [class.dropdown-open]="generatePODropdownStates[poIndex]?.showDeliveryPref" *ngIf="MasterData?.OrderDeliveryPreferences?.length > 0">
                    <div class="SendEmailOverlayTransparent" *ngIf="generatePODropdownStates[poIndex]?.showDeliveryPref" (click)="closePODropdowns(poIndex)"></div>
                    <div class="CustomDropdownBar" (click)="togglePODeliveryPreference(poIndex)">
                      <span class="dropdown-label">{{ 'SelectDeliveryPrefference' | translate }}</span>
                      <i class="material-icons dropdown-icon-left">delivery_dining</i>
                      <i class="material-icons send-email-icon" [style.color]="po.DeliveryPreference?.ID ? '#f60' : '#ccc'">
                        {{ po.DeliveryPreference?.ID ? 'check_circle' : 'radio_button_unchecked' }}
                      </i>
                      <input type="text" class="CustomDropdownInput" [class.placeholder]="!po.DeliveryPreference" [value]="po.DeliveryPreference?.Name || ''" readonly />
                      <i class="material-icons dropdown-icon">arrow_drop_up</i>
                    </div>
                    <div class="CustomDropdownResults CustomDropdownResultsUpward" *ngIf="generatePODropdownStates[poIndex]?.showDeliveryPref">
                      <div class="CustomDropdownResult" *ngFor="let pref of MasterData.OrderDeliveryPreferences" (click)="selectPODeliveryPreference(poIndex, pref)">
                        <div class="CustomDropdownResultMain">
                          <i class="material-icons" [style.color]="po.DeliveryPreference?.ID === pref.ID ? '#f60' : '#ccc'">
                            {{ po.DeliveryPreference?.ID === pref.ID ? 'check_circle' : 'radio_button_unchecked' }}
                          </i>
                          <span class="CustomDropdownResultText">{{ pref.Name }}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Consolidation Type Dropdown -->
                  <div class="CustomDropdownContainer" [class.dropdown-open]="generatePODropdownStates[poIndex]?.showConsolidation" *ngIf="MasterData?.OrderConsolidationTypes?.length > 0">
                    <div class="SendEmailOverlayTransparent" *ngIf="generatePODropdownStates[poIndex]?.showConsolidation" (click)="closePODropdowns(poIndex)"></div>
                    <div class="CustomDropdownBar" (click)="togglePOConsolidationType(poIndex)">
                      <span class="dropdown-label">{{ 'OrderConsolidationType' | translate }}</span>
                      <i class="material-icons dropdown-icon-left">inventory_2</i>
                      <i class="material-icons send-email-icon" [style.color]="po.ConsolidationType?.ID ? '#f60' : '#ccc'">
                        {{ po.ConsolidationType?.ID ? 'check_circle' : 'radio_button_unchecked' }}
                      </i>
                      <input type="text" class="CustomDropdownInput" [class.placeholder]="!po.ConsolidationType" [value]="po.ConsolidationType?.Name || ''" readonly />
                      <i class="material-icons dropdown-icon">arrow_drop_up</i>
                    </div>
                    <div class="CustomDropdownResults CustomDropdownResultsUpward" *ngIf="generatePODropdownStates[poIndex]?.showConsolidation">
                      <div class="CustomDropdownResult" *ngFor="let type of MasterData.OrderConsolidationTypes" (click)="selectPOConsolidationType(poIndex, type)">
                        <div class="CustomDropdownResultMain">
                          <i class="material-icons" [style.color]="po.ConsolidationType?.ID === type.ID ? '#f60' : '#ccc'">
                            {{ po.ConsolidationType?.ID === type.ID ? 'check_circle' : 'radio_button_unchecked' }}
                          </i>
                          <span class="CustomDropdownResultText">{{ type.Name }}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Pickup Address Dropdown -->
                  <div class="CustomDropdownContainer" [class.dropdown-open]="generatePODropdownStates[poIndex]?.showPickupAddress" *ngIf="po.Cart?.Partner?.ShippingAddresses?.length > 0">
                    <div class="SendEmailOverlayTransparent" *ngIf="generatePODropdownStates[poIndex]?.showPickupAddress" (click)="closePODropdowns(poIndex)"></div>
                    <div class="CustomDropdownBar" (click)="togglePOPickupAddress(poIndex)">
                      <span class="dropdown-label">{{ 'PickupAddress' | translate }}</span>
                      <i class="material-icons dropdown-icon-left">location_on</i>
                      <i class="material-icons send-email-icon" [style.color]="po.PickupAddress?.ID ? '#f60' : '#ccc'">
                        {{ po.PickupAddress?.ID ? 'check_circle' : 'radio_button_unchecked' }}
                      </i>
                      <input type="text" class="CustomDropdownInput" [class.placeholder]="!po.PickupAddress" [value]="getPOPickupAddressLabel(poIndex)" readonly />
                      <i class="material-icons dropdown-icon">arrow_drop_up</i>
                    </div>
                    <div class="CustomDropdownResults CustomDropdownResultsUpward" *ngIf="generatePODropdownStates[poIndex]?.showPickupAddress">
                      <div class="CustomDropdownResult" *ngFor="let addr of po.Cart?.Partner?.ShippingAddresses" (click)="selectPOPickupAddress(poIndex, addr)">
                        <div class="CustomDropdownResultMain">
                          <i class="material-icons" [style.color]="po.PickupAddress?.ID === addr.ID ? '#f60' : '#ccc'">
                            {{ po.PickupAddress?.ID === addr.ID ? 'check_circle' : 'radio_button_unchecked' }}
                          </i>
                          <span class="CustomDropdownResultText">{{ addr.Country?.Name }} - {{ addr.City }} - {{ addr.AddressLine }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
          </div> <!-- /GeneratePOGroupContent -->
        </div>
      </div>

    </div>

    <!-- Popup Footer -->
    <div class="ModernPopupFooter GeneratePOPopupFooter">
      <button class="ModernButton outline" (click)="closeGeneratePOPopup()">
        <i class="material-icons">close</i>
        <span>{{ 'Cancel' | translate }}</span>
      </button>
      <!-- Save button to finalize POs -->
      <button class="ModernButton success GeneratePOSaveButton" *ngIf="GeneratedPurchaseOrders.length > 0" (click)="saveFinalPurchaseOrders()" [disabled]="parent.loading">
        <i class="material-icons" *ngIf="!parent.loading">check</i>
        <mat-spinner *ngIf="parent.loading" diameter="18"></mat-spinner>
        <span>{{ 'Save' | translate }}</span>
      </button>
    </div>
  </div>
</div>

<!-- ✅ Bulk PO Creation Results Popup -->
<div class="ModernPopupOverlay ModernPopupOverlayTop" *ngIf="ShowBulkPOResultsPopup">
  <div class="ModernPopup xlarge POResultsPopup" style="max-height: 85vh;" (click)="$event.stopPropagation()">
    <!-- Popup Header -->
    <div class="ModernPopupHeader">
      <div class="ModernPopupTitle">
        <i class="material-icons" style="color: #00c9bd;">check_circle</i>
        <span>Purchase Orders Created</span>
      </div>
      <button class="ModernPopupClose" (click)="ShowBulkPOResultsPopup = false">
        <i class="material-icons">close</i>
      </button>
    </div>

    <!-- Popup Body -->
    <div class="ModernPopupBody" style="overflow-y: auto; max-height: calc(85vh - 120px); padding: 16px;">
      <!-- Summary Section -->
      <div class="bulk-po-summary">
        <div class="summary-stat success" *ngIf="BulkPOCreationResults?.SuccessCount > 0">
          <i class="material-icons">check_circle</i>
          <span>{{ BulkPOCreationResults?.SuccessCount }} Purchase Order(s) Created Successfully</span>
        </div>
        <div class="summary-stat error" *ngIf="BulkPOCreationResults?.FailedCount > 0">
          <i class="material-icons">error</i>
          <span>{{ BulkPOCreationResults?.FailedCount }} Purchase Order(s) Failed</span>
        </div>
      </div>

      <!-- Success Cards -->
      <div class="po-results-section" *ngIf="BulkPOCreationResults?.CreatedPurchaseOrders?.length > 0">
        <h3 class="section-title success"><i class="material-icons">done_all</i> Successfully Created</h3>
        <div class="po-result-card success" *ngFor="let po of BulkPOCreationResults?.CreatedPurchaseOrders">
          <div class="po-card-header">
            <span class="po-number">PO #{{ po.PONumber }}</span>
            <span class="po-dbid">DBID: {{ po.DBID }}</span>
          </div>
          <div class="po-card-body">
            <div class="po-card-row">
              <span class="label">Supplier:</span>
              <span class="value">{{ po.PartnerName }}</span>
            </div>
            <div class="po-card-row">
              <span class="label">Items:</span>
              <span class="value">{{ po.ItemCount }}</span>
            </div>
            <div class="po-card-row">
              <span class="label">Subtotal:</span>
              <span class="value">{{ po.Subtotal | number:'1.2-2' }} {{ po.CurrencyCode }}</span>
            </div>
            <div class="po-card-row" *ngIf="po.DiscountPercent > 0">
              <span class="label">Discount:</span>
              <span class="value">{{ po.DiscountPercent }}% (-{{ po.DiscountAmount | number:'1.2-2' }} {{ po.CurrencyCode }})</span>
            </div>
            <div class="po-card-row total">
              <span class="label">Total:</span>
              <span class="value">{{ po.TotalAmount | number:'1.2-2' }} {{ po.CurrencyCode }}</span>
            </div>
          </div>

          <!-- ✅ PO Document Actions (Re-Download PDF+Excel / Re-Print PDF) -->
          <div class="po-shipping-actions" style="margin-top: 8px; margin-left: 12px;">
            <button class="ModernButton primary" [disabled]="po._downloadingDocument" (click)="downloadBulkPODocument(po)">
              <mat-spinner *ngIf="po._downloadingDocument" diameter="16"></mat-spinner>
              <i class="material-icons" *ngIf="!po._downloadingDocument">download</i>
              <span>{{ 'DownloadPDF' | translate }}</span>
            </button>
            <button class="ModernButton" [disabled]="po._printingDocument" (click)="printBulkPODocument(po)">
              <mat-spinner *ngIf="po._printingDocument" diameter="16"></mat-spinner>
              <i class="material-icons" *ngIf="!po._printingDocument">print</i>
              <span>{{ 'Print' | translate }}</span>
            </button>
          </div>

          <!-- ✅ Shipping Label Section (per created PO) -->
          <div class="po-shipping-section" *ngIf="po.Shipping">
            <div class="po-shipping-title">
              <i class="material-icons">local_shipping</i>
              <span>{{ 'ShippingLabel' | translate }}</span>
            </div>

            <!-- Settings + Parcels + Address (hidden once a label is generated) -->
            <ng-container *ngIf="!po.Shipping._generated">

              <!-- Shipping Settings -->
              <div class="BatchShippingSettings">
                <div class="BatchSettingGroup">
                  <div class="CustomDropdownContainer" [class.dropdown-open]="po.Shipping._showServiceTypeDropdown">
                    <div class="SendEmailOverlayTransparent" *ngIf="po.Shipping._showServiceTypeDropdown" (click)="po.Shipping._showServiceTypeDropdown = false"></div>
                    <div class="CustomDropdownBar" (click)="po.Shipping._showServiceTypeDropdown = !po.Shipping._showServiceTypeDropdown">
                      <span class="dropdown-label">{{ 'ShippingService' | translate }}</span>
                      <i class="material-icons dropdown-icon-left">speed</i>
                      <input type="text" class="CustomDropdownInput" readonly
                             [class.placeholder]="!po.Shipping.ShippingDetails?.ShippingServiceType"
                             [value]="po.Shipping.ShippingDetails?.ShippingServiceType?.Name || 'Select...'" />
                      <i class="material-icons dropdown-icon">arrow_drop_down</i>
                    </div>
                    <div class="CustomDropdownResults" *ngIf="po.Shipping._showServiceTypeDropdown">
                      <div class="CustomDropdownResult" *ngFor="let svc of getBatchAvailableServiceTypes(po.Shipping)" (click)="po.Shipping.ShippingDetails.ShippingServiceType = svc; po.Shipping._showServiceTypeDropdown = false">
                        <div class="CustomDropdownResultMain">
                          <i class="material-icons" [style.color]="po.Shipping.ShippingDetails?.ShippingServiceType?.ID === svc.ID ? '#4caf50' : '#9ca3af'">
                            {{ po.Shipping.ShippingDetails?.ShippingServiceType?.ID === svc.ID ? 'check_circle' : 'radio_button_unchecked' }}
                          </i>
                          <span class="CustomDropdownResultText">{{ svc.Name }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="BatchSettingGroup">
                  <div class="CustomDropdownContainer" [class.dropdown-open]="po.Shipping._showCompanyDropdown">
                    <div class="SendEmailOverlayTransparent" *ngIf="po.Shipping._showCompanyDropdown" (click)="po.Shipping._showCompanyDropdown = false"></div>
                    <div class="CustomDropdownBar" (click)="po.Shipping._showCompanyDropdown = !po.Shipping._showCompanyDropdown">
                      <span class="dropdown-label">{{ 'ShippingCompany' | translate }}</span>
                      <i class="material-icons dropdown-icon-left">local_shipping</i>
                      <input type="text" class="CustomDropdownInput" readonly
                             [class.placeholder]="!po.Shipping.ShippingDetails?.ShippingCompany"
                             [value]="po.Shipping.ShippingDetails?.ShippingCompany?.Name || 'Select...'" />
                      <i class="material-icons dropdown-icon">arrow_drop_down</i>
                    </div>
                    <div class="CustomDropdownResults" *ngIf="po.Shipping._showCompanyDropdown">
                      <div class="CustomDropdownResult" *ngFor="let comp of (po.Shipping.AvailableShippingCompanies?.length > 0 ? po.Shipping.AvailableShippingCompanies : APIShippingCompanies)" (click)="po.Shipping.ShippingDetails.ShippingCompany = comp; po.Shipping._showCompanyDropdown = false">
                        <div class="CustomDropdownResultMain">
                          <i class="material-icons" [style.color]="po.Shipping.ShippingDetails?.ShippingCompany?.ID === comp.ID ? '#4caf50' : '#9ca3af'">
                            {{ po.Shipping.ShippingDetails?.ShippingCompany?.ID === comp.ID ? 'check_circle' : 'radio_button_unchecked' }}
                          </i>
                          <span class="CustomDropdownResultText">{{ comp.Name }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="BatchSettingGroup">
                  <div class="CustomDropdownContainer" [class.dropdown-open]="po.Shipping._showResponsabilityDropdown">
                    <div class="SendEmailOverlayTransparent" *ngIf="po.Shipping._showResponsabilityDropdown" (click)="po.Shipping._showResponsabilityDropdown = false"></div>
                    <div class="CustomDropdownBar" (click)="po.Shipping._showResponsabilityDropdown = !po.Shipping._showResponsabilityDropdown">
                      <span class="dropdown-label">{{ 'ShippingResponsability' | translate }}</span>
                      <i class="material-icons dropdown-icon-left">assignment_ind</i>
                      <input type="text" class="CustomDropdownInput" readonly
                             [class.placeholder]="!po.Shipping.ShippingDetails?.ShippingResponsability"
                             [value]="po.Shipping.ShippingDetails?.ShippingResponsability?.Name || 'Select...'" />
                      <i class="material-icons dropdown-icon">arrow_drop_down</i>
                    </div>
                    <div class="CustomDropdownResults" *ngIf="po.Shipping._showResponsabilityDropdown">
                      <div class="CustomDropdownResult" *ngFor="let resp of ShippingResponsabilities" (click)="po.Shipping.ShippingDetails.ShippingResponsability = resp; po.Shipping._showResponsabilityDropdown = false">
                        <div class="CustomDropdownResultMain">
                          <i class="material-icons" [style.color]="po.Shipping.ShippingDetails?.ShippingResponsability?.ID === resp.ID ? '#4caf50' : '#9ca3af'">
                            {{ po.Shipping.ShippingDetails?.ShippingResponsability?.ID === resp.ID ? 'check_circle' : 'radio_button_unchecked' }}
                          </i>
                          <span class="CustomDropdownResultText">{{ resp.Name }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- From / To Addresses (editable) -->
              <div class="BatchFromToRow">

                <!-- FROM (Sender / supplier pickup) -->
                <div class="BatchFromToCol">
                  <div class="BatchFromToTitle">
                    <span>{{ 'From' | translate }}</span>
                  </div>

                  <!-- From address selector dropdown -->
                  <div class="CustomDropdownContainer BatchFromToDropdown" [class.dropdown-open]="po.Shipping._showSenderSelector">
                    <div class="SendEmailOverlayTransparent" *ngIf="po.Shipping._showSenderSelector" (click)="po.Shipping._showSenderSelector = false"></div>
                    <div class="CustomDropdownBar" (click)="po.Shipping._showSenderSelector = !po.Shipping._showSenderSelector">
                      <span class="dropdown-label">{{ 'PickupAddress' | translate }}</span>
                      <i class="material-icons dropdown-icon-left">location_on</i>
                      <input type="text" class="CustomDropdownInput" readonly
                             [class.placeholder]="!po.Shipping.ShippingDetails?.Sender"
                             [value]="po.Shipping.ShippingDetails?.Sender?.ContactCompany || po.Shipping.ShippingDetails?.Sender?.ContactPerson || 'Select...'" />
                      <i class="material-icons dropdown-icon">arrow_drop_down</i>
                    </div>
                    <div class="CustomDropdownResults" *ngIf="po.Shipping._showSenderSelector">
                      <div class="CustomDropdownResult" *ngFor="let addr of po.Shipping.AvailablePartnerAddresses" (click)="selectBulkPOSenderAddress(po, addr)">
                        <div class="CustomDropdownResultMain">
                          <i class="material-icons" [style.color]="po.Shipping.ShippingDetails?.Sender?.ID === addr.ID ? '#4caf50' : '#9ca3af'">
                            {{ po.Shipping.ShippingDetails?.Sender?.ID === addr.ID ? 'check_circle' : 'radio_button_unchecked' }}
                          </i>
                          <div class="BatchAddressSelectorItemInfo">
                            <span class="BatchAddrName">{{ addr.ContactCompany || addr.ContactPerson || '-' }}</span>
                            <span class="BatchAddrLine">{{ addr.AddressLine || '' }}</span>
                            <span class="BatchAddrLine">{{ addr.City || '' }} {{ addr.ZipCode || '' }}<ng-container *ngIf="addr.Country?.Name">, {{ addr.Country.Name }}</ng-container></span>
                          </div>
                        </div>
                      </div>
                      <div class="BatchAddressSelectorEmpty" *ngIf="!po.Shipping.AvailablePartnerAddresses || po.Shipping.AvailablePartnerAddresses.length === 0">
                        {{ 'NoAddressesAvailable' | translate }}
                      </div>
                    </div>
                  </div>

                  <div class="BatchAddrFields" *ngIf="po.Shipping.ShippingDetails?.Sender">
                    <div class="CustomDropdownBar CustomDropdownBarInput">
                      <span class="dropdown-label">{{ 'ContactCompany' | translate }}</span>
                      <input type="text" class="CustomDropdownInput" [(ngModel)]="po.Shipping.ShippingDetails.Sender.ContactCompany" />
                    </div>
                    <div class="CustomDropdownBar CustomDropdownBarInput">
                      <span class="dropdown-label">{{ 'ContactPerson' | translate }}</span>
                      <input type="text" class="CustomDropdownInput" [(ngModel)]="po.Shipping.ShippingDetails.Sender.ContactPerson" />
                    </div>
                    <div class="CustomDropdownBar CustomDropdownBarInput">
                      <span class="dropdown-label">{{ 'AddressLine' | translate }}</span>
                      <input type="text" class="CustomDropdownInput" [(ngModel)]="po.Shipping.ShippingDetails.Sender.AddressLine" />
                    </div>
                    <div class="CustomDropdownBar CustomDropdownBarInput">
                      <span class="dropdown-label">{{ 'City' | translate }}</span>
                      <input type="text" class="CustomDropdownInput" [(ngModel)]="po.Shipping.ShippingDetails.Sender.City" />
                    </div>
                    <div class="CustomDropdownBar CustomDropdownBarInput">
                      <span class="dropdown-label">{{ 'StateProvince' | translate }}</span>
                      <input type="text" class="CustomDropdownInput" [(ngModel)]="po.Shipping.ShippingDetails.Sender.State" />
                    </div>
                    <div class="CustomDropdownBar CustomDropdownBarInput">
                      <span class="dropdown-label">{{ 'ZipCode' | translate }}</span>
                      <input type="text" class="CustomDropdownInput" [(ngModel)]="po.Shipping.ShippingDetails.Sender.ZipCode" />
                    </div>
                    <div class="CustomDropdownBar CustomDropdownBarInput">
                      <span class="dropdown-label">{{ 'Phone' | translate }}</span>
                      <input type="text" class="CustomDropdownInput" [(ngModel)]="po.Shipping.ShippingDetails.Sender.Phone" />
                    </div>
                    <div class="CustomDropdownBar CustomDropdownBarInput">
                      <span class="dropdown-label">{{ 'Email' | translate }}</span>
                      <input type="text" class="CustomDropdownInput" [(ngModel)]="po.Shipping.ShippingDetails.Sender.Email" />
                    </div>
                    <!-- Sender country selector -->
                    <div class="CustomDropdownContainer BatchFromToDropdown" [class.dropdown-open]="po.Shipping._showSenderCountryDropdown">
                      <div class="SendEmailOverlayTransparent" *ngIf="po.Shipping._showSenderCountryDropdown" (click)="po.Shipping._showSenderCountryDropdown = false"></div>
                      <div class="CustomDropdownBar" (click)="po.Shipping._showSenderCountryDropdown = !po.Shipping._showSenderCountryDropdown">
                        <span class="dropdown-label">{{ 'Country' | translate }}</span>
                        <i class="material-icons dropdown-icon-left">public</i>
                        <input type="text" class="CustomDropdownInput" readonly
                               [class.placeholder]="!po.Shipping.ShippingDetails.Sender.Country?.Name"
                               [value]="po.Shipping.ShippingDetails.Sender.Country?.Name || 'Select...'" />
                        <i class="material-icons dropdown-icon">arrow_drop_down</i>
                      </div>
                      <div class="CustomDropdownResults" *ngIf="po.Shipping._showSenderCountryDropdown">
                        <div class="CustomDropdownResult" *ngFor="let c of getBulkPOCountries()" (click)="selectBulkPOSenderCountry(po, c)">
                          <div class="CustomDropdownResultMain">
                            <i class="material-icons" [style.color]="po.Shipping.ShippingDetails.Sender.Country?.ID === c.ID ? '#4caf50' : '#9ca3af'">
                              {{ po.Shipping.ShippingDetails.Sender.Country?.ID === c.ID ? 'check_circle' : 'radio_button_unchecked' }}
                            </i>
                            <span class="CustomDropdownResultText">{{ c.Name }}</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Add (new) / Update (existing) supplier pickup address -->
                    <button type="button" class="ModernButton outline BatchAddrSaveBtn"
                            [disabled]="po.Shipping._savingSenderAddress"
                            (click)="addUpdateBulkPOPartnerShippingAddress(po)">
                      <i class="material-icons">{{ po.Shipping.ShippingDetails.Sender.ID > 0 ? 'save' : 'add' }}</i>
                      {{ (po.Shipping.ShippingDetails.Sender.ID > 0 ? 'Update' : 'Add') | translate }}
                    </button>
                  </div>

                </div>

                <!-- TO (Receiver / company delivery) -->
                <div class="BatchFromToCol">
                  <div class="BatchFromToTitle">
                    <span>{{ 'To' | translate }}</span>
                  </div>

                  <!-- To address selector dropdown -->
                  <div class="CustomDropdownContainer BatchFromToDropdown" [class.dropdown-open]="po.Shipping._showAddressSelector">
                    <div class="SendEmailOverlayTransparent" *ngIf="po.Shipping._showAddressSelector" (click)="po.Shipping._showAddressSelector = false"></div>
                    <div class="CustomDropdownBar" (click)="po.Shipping._showAddressSelector = !po.Shipping._showAddressSelector">
                      <span class="dropdown-label">{{ 'Receiver' | translate }}</span>
                      <i class="material-icons dropdown-icon-left">location_on</i>
                      <input type="text" class="CustomDropdownInput" readonly
                             [class.placeholder]="!po.Shipping.ShippingDetails?.Receiver"
                             [value]="po.Shipping.ShippingDetails?.Receiver?.ContactCompany || po.Shipping.ShippingDetails?.Receiver?.ContactPerson || 'Select...'" />
                      <i class="material-icons dropdown-icon">arrow_drop_down</i>
                    </div>
                    <div class="CustomDropdownResults" *ngIf="po.Shipping._showAddressSelector">
                      <div class="CustomDropdownResult" *ngFor="let addr of po.Shipping.AvailableShippingAddresses" (click)="selectBulkPOReceiverAddress(po, addr)">
                        <div class="CustomDropdownResultMain">
                          <i class="material-icons" [style.color]="po.Shipping.ShippingDetails?.Receiver?.ID === addr.ID ? '#4caf50' : '#9ca3af'">
                            {{ po.Shipping.ShippingDetails?.Receiver?.ID === addr.ID ? 'check_circle' : 'radio_button_unchecked' }}
                          </i>
                          <div class="BatchAddressSelectorItemInfo">
                            <span class="BatchAddrName">{{ addr.ContactCompany || addr.ContactPerson || '-' }}</span>
                            <span class="BatchAddrLine">{{ addr.AddressLine || '' }}</span>
                            <span class="BatchAddrLine">{{ addr.City || '' }} {{ addr.ZipCode || '' }}<ng-container *ngIf="addr.Country?.Name">, {{ addr.Country.Name }}</ng-container></span>
                          </div>
                        </div>
                      </div>
                      <div class="BatchAddressSelectorEmpty" *ngIf="!po.Shipping.AvailableShippingAddresses || po.Shipping.AvailableShippingAddresses.length === 0">
                        {{ 'NoAddressesAvailable' | translate }}
                      </div>
                    </div>
                  </div>

                  <div class="BatchAddrFields" *ngIf="po.Shipping.ShippingDetails?.Receiver">
                    <div class="CustomDropdownBar CustomDropdownBarInput">
                      <span class="dropdown-label">{{ 'ContactCompany' | translate }}</span>
                      <input type="text" class="CustomDropdownInput" [(ngModel)]="po.Shipping.ShippingDetails.Receiver.ContactCompany" />
                    </div>
                    <div class="CustomDropdownBar CustomDropdownBarInput">
                      <span class="dropdown-label">{{ 'ContactPerson' | translate }}</span>
                      <input type="text" class="CustomDropdownInput" [(ngModel)]="po.Shipping.ShippingDetails.Receiver.ContactPerson" />
                    </div>
                    <div class="CustomDropdownBar CustomDropdownBarInput">
                      <span class="dropdown-label">{{ 'AddressLine' | translate }}</span>
                      <input type="text" class="CustomDropdownInput" [(ngModel)]="po.Shipping.ShippingDetails.Receiver.AddressLine" />
                    </div>
                    <div class="CustomDropdownBar CustomDropdownBarInput">
                      <span class="dropdown-label">{{ 'City' | translate }}</span>
                      <input type="text" class="CustomDropdownInput" [(ngModel)]="po.Shipping.ShippingDetails.Receiver.City" />
                    </div>
                    <div class="CustomDropdownBar CustomDropdownBarInput">
                      <span class="dropdown-label">{{ 'StateProvince' | translate }}</span>
                      <input type="text" class="CustomDropdownInput" [(ngModel)]="po.Shipping.ShippingDetails.Receiver.State" />
                    </div>
                    <div class="CustomDropdownBar CustomDropdownBarInput">
                      <span class="dropdown-label">{{ 'ZipCode' | translate }}</span>
                      <input type="text" class="CustomDropdownInput" [(ngModel)]="po.Shipping.ShippingDetails.Receiver.ZipCode" />
                    </div>
                    <div class="CustomDropdownBar CustomDropdownBarInput">
                      <span class="dropdown-label">{{ 'Phone' | translate }}</span>
                      <input type="text" class="CustomDropdownInput" [(ngModel)]="po.Shipping.ShippingDetails.Receiver.Phone" />
                    </div>
                    <div class="CustomDropdownBar CustomDropdownBarInput">
                      <span class="dropdown-label">{{ 'Email' | translate }}</span>
                      <input type="text" class="CustomDropdownInput" [(ngModel)]="po.Shipping.ShippingDetails.Receiver.Email" />
                    </div>
                    <!-- Receiver country selector -->
                    <div class="CustomDropdownContainer BatchFromToDropdown" [class.dropdown-open]="po.Shipping._showReceiverCountryDropdown">
                      <div class="SendEmailOverlayTransparent" *ngIf="po.Shipping._showReceiverCountryDropdown" (click)="po.Shipping._showReceiverCountryDropdown = false"></div>
                      <div class="CustomDropdownBar" (click)="po.Shipping._showReceiverCountryDropdown = !po.Shipping._showReceiverCountryDropdown">
                        <span class="dropdown-label">{{ 'Country' | translate }}</span>
                        <i class="material-icons dropdown-icon-left">public</i>
                        <input type="text" class="CustomDropdownInput" readonly
                               [class.placeholder]="!po.Shipping.ShippingDetails.Receiver.Country?.Name"
                               [value]="po.Shipping.ShippingDetails.Receiver.Country?.Name || 'Select...'" />
                        <i class="material-icons dropdown-icon">arrow_drop_down</i>
                      </div>
                      <div class="CustomDropdownResults" *ngIf="po.Shipping._showReceiverCountryDropdown">
                        <div class="CustomDropdownResult" *ngFor="let c of getBulkPOCountries()" (click)="selectBulkPOReceiverCountry(po, c)">
                          <div class="CustomDropdownResultMain">
                            <i class="material-icons" [style.color]="po.Shipping.ShippingDetails.Receiver.Country?.ID === c.ID ? '#4caf50' : '#9ca3af'">
                              {{ po.Shipping.ShippingDetails.Receiver.Country?.ID === c.ID ? 'check_circle' : 'radio_button_unchecked' }}
                            </i>
                            <span class="CustomDropdownResultText">{{ c.Name }}</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Update the company receiver address (companies always exist) -->
                    <button type="button" class="ModernButton outline BatchAddrSaveBtn"
                            [disabled]="po.Shipping._savingReceiverAddress"
                            (click)="addUpdateBulkPOCompanyShippingAddress(po)">
                      <i class="material-icons">save</i>
                      {{ 'Update' | translate }}
                    </button>
                  </div>

                </div>

              </div>

              <!-- Parcels -->
              <div class="BatchBoxesSection">
                <div class="BatchBoxesHeader">
                  <span class="BatchBoxesTitle">
                    <i class="material-icons" style="font-size:16px;vertical-align:middle;margin-right:4px;">inventory_2</i>
                    {{ 'Parcels' | translate }} ({{ po.Shipping.ShippingDetails?.Boxes?.length || 0 }})
                  </span>
                  <div class="GridCommandButton" style="height:28px;line-height:28px;font-size:11px;padding:0 10px;" (click)="addBulkPOBox(po)">
                    <i class="material-icons" style="font-size:14px;">add</i>
                    <span>{{ 'AddNewParcel' | translate }}</span>
                  </div>
                </div>

                <div class="ParcelContainerHeadder" *ngIf="po.Shipping.ShippingDetails?.Boxes?.length > 0">
                  <div class="ParcelIndexHeadder"><span>#</span></div>
                  <div class="ParcelMultiplyHeadder"><span>{{ 'Multiply' | translate }}</span></div>
                  <div class="ParcelDimentionHeadder"><span>{{ 'Length' | translate }}</span></div>
                  <i class="material-icons BetweenDimentionsX">close</i>
                  <div class="ParcelDimentionHeadder"><span>{{ 'Width' | translate }}</span></div>
                  <i class="material-icons BetweenDimentionsX">close</i>
                  <div class="ParcelDimentionHeadder"><span>{{ 'Height' | translate }}</span></div>
                  <i class="material-icons BetweenDimentionsX" style="line-height: 35px;">minimize</i>
                  <div class="ParcelDimentionHeadder"><span>{{ 'Weight' | translate }}</span></div>
                </div>

                <div class="ParcelContainer" *ngFor="let box of po.Shipping.ShippingDetails?.Boxes; let bIdx = index;" style="border-bottom: solid 1px #ddd;">
                  <div class="ParcelIndex">
                    <i class="material-icons">local_shipping</i>
                    <span style="float: left;">{{'Parcel' | translate}}</span>
                    <span style="float: left;">#{{bIdx + 1}}</span>
                  </div>

                  <div class="ParcelMultiplyContainer">
                    <input type="number" min="1" max="10" class="ParcelMultiplyInput" [(ngModel)]="box._multiplyFactor" placeholder="1" (click)="$event.target.select();" (blur)="multiplyBulkPOBox(po, box, bIdx)" (keydown.enter)="$event.target.blur();" (keydown.tab)="multiplyBulkPOBox(po, box, bIdx)">
                    <i class="material-icons ParcelMultiplyIcon" (click)="multiplyBulkPOBox(po, box, bIdx)" title="{{'Multiply' | translate}}">close</i>
                  </div>

                  <mat-form-field appearance="outline" class="ParcelDimention">
                    <mat-label>{{ 'Length' | translate }}*</mat-label>
                    <input matInput placeholder="{{'Length' | translate}}" autocomplete="off" [(ngModel)]="box.Length" (click)="$event.target.select();">
                  </mat-form-field>

                  <i class="material-icons BetweenDimentionsX">close</i>

                  <mat-form-field appearance="outline" class="ParcelDimention">
                    <mat-label>{{ 'Width' | translate }}*</mat-label>
                    <input matInput placeholder="{{'Width' | translate}}" autocomplete="off" [(ngModel)]="box.Width" (click)="$event.target.select();">
                  </mat-form-field>

                  <i class="material-icons BetweenDimentionsX">close</i>

                  <mat-form-field appearance="outline" class="ParcelDimention">
                    <mat-label>{{ 'Height' | translate }}*</mat-label>
                    <input matInput placeholder="{{'Height' | translate}}" autocomplete="off" [(ngModel)]="box.Height" (click)="$event.target.select();">
                  </mat-form-field>

                  <i class="material-icons BetweenDimentionsX" style="line-height: 35px;">minimize</i>

                  <mat-form-field appearance="outline" class="ParcelDimention">
                    <mat-label>{{ 'Weight' | translate }}*</mat-label>
                    <input matInput placeholder="{{'Weight' | translate}}" autocomplete="off" [(ngModel)]="box.Weight" (click)="$event.target.select();">
                  </mat-form-field>

                  <i class="material-icons ParcelDeleteIcon" (click)="removeBulkPOBox(po, bIdx)">remove_circle_outline</i>
                </div>
              </div>

              <!-- Error message -->
              <div class="po-shipping-error" *ngIf="po.Shipping._errorMessage">
                <i class="material-icons">warning</i>
                <span>{{ po.Shipping._errorMessage }}</span>
              </div>

              <!-- Generate buttons -->
              <div class="po-shipping-actions">
                <button class="ModernButton primary" [disabled]="po.Shipping._generating" (click)="generateBulkPOLabel(po, false)">
                  <mat-spinner *ngIf="po.Shipping._generating" diameter="16"></mat-spinner>
                  <i class="material-icons" *ngIf="!po.Shipping._generating">verified</i>
                  <span>{{ (po.Shipping._generating ? 'GeneratingLabel' : 'GenerateLabel') | translate }}</span>
                </button>
                <button class="ModernButton" [disabled]="po.Shipping._generating" (click)="generateBulkPOLabel(po, true)">
                  <mat-spinner *ngIf="po.Shipping._generating" diameter="16"></mat-spinner>
                  <i class="material-icons" *ngIf="!po.Shipping._generating">group_add</i>
                  <span>{{ 'GenerateAndPickup' | translate }}</span>
                </button>
              </div>
            </ng-container>

            <!-- Generated result -->
            <div class="po-shipping-result" *ngIf="po.Shipping._generated">
              <div class="po-shipping-result-info">
                <i class="material-icons" style="color:#2e7d32;">verified</i>
                <span>{{ 'ProcessSuccessfullyCompleted' | translate }}</span>
              </div>
              <div class="po-shipping-result-row" *ngIf="po.Shipping.ShippingDetails?.TrackingLabel?.length > 0">
                <span class="label">{{ 'TrackingLabel' | translate }}:</span>
                <span class="value">{{ po.Shipping.ShippingDetails.TrackingLabel }}</span>
              </div>
              <div class="po-shipping-result-row" *ngIf="po.Shipping.ShippingDetails?.PickupInformation?.CarrierPickupNumber?.length > 0">
                <span class="label">{{ 'PickupNumber' | translate }}:</span>
                <span class="value">{{ po.Shipping.ShippingDetails.PickupInformation.CarrierPickupNumber }}</span>
              </div>
              <div class="po-shipping-actions">
                <button class="ModernButton primary" (click)="downloadBulkPOLabel(po, 1)">
                  <i class="material-icons">download</i>
                  <span>{{ 'DownloadLabel' | translate }}</span>
                </button>
                <button class="ModernButton" (click)="downloadBulkPOLabel(po, 2)">
                  <i class="material-icons">print</i>
                  <span>{{ 'PrintLabel' | translate }}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Failed Cards -->
      <div class="po-results-section" *ngIf="BulkPOCreationResults?.FailedPurchaseOrders?.length > 0">
        <h3 class="section-title error"><i class="material-icons">error_outline</i> Failed to Create</h3>
        <div class="po-result-card error" *ngFor="let po of BulkPOCreationResults?.FailedPurchaseOrders">
          <div class="po-card-header">
            <span class="po-partner">{{ po.PartnerName }}</span>
            <span class="po-items">{{ po.ItemCount }} item(s)</span>
          </div>
          <div class="po-card-body">
            <div class="po-card-row error-message">
              <i class="material-icons">warning</i>
              <span>{{ po.ErrorMessage }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Popup Footer -->
    <div class="ModernPopupFooter">
      <button class="ModernButton primary" (click)="ShowBulkPOResultsPopup = false">
        <i class="material-icons">close</i>
        <span>Close</span>
      </button>
    </div>
  </div>
</div>

<div class="EditContainer animated fadeInDown" *ngIf="this.ShowEditContainer == true;">
    <div class="EditContainerCloseButton" (click)="this.ShowEditContainer = false;">
        <i class="material-icons">close</i>
    </div>

    <!-- Modern Header -->
    <div class="EditContainerHeader">
      <div class="EditHeaderLeft">
        <div class="EditHeaderTitle">
          <i class="material-icons">description</i>
          <span>{{'Offer' | translate}}</span>
        </div>
        <div class="EditHeaderMeta">
          <span class="EditRefNumber">{{CurrentOrder.ReferenceNumber}}</span>
          <span class="EditDebatorPO" *ngIf="CurrentOrder?.DebatorPO?.length > 0;">PO: {{CurrentOrder.DebatorPO}}</span>
          <span class="EditRegisterDate" *ngIf="CurrentOrder?.EventRegisterUI?.length > 0;">
            <i class="material-icons" style="font-size: 13px; vertical-align: middle; margin-right: 2px;">event</i>{{CurrentOrder.EventRegisterUI}}
          </span>
        </div>
      </div>
      <div class="EditHeaderRight">
        <span class="EditStatusBadge" [ngClass]="{
          'StatusNew': CurrentOrder.OCStatus?.ID == -1,
          'StatusProcessing': CurrentOrder.OCStatus?.ID == 1,
          'StatusPartial': CurrentOrder.OCStatus?.ID == 9,
          'StatusConfirmed': CurrentOrder.OCStatus?.ID == 10 || CurrentOrder.OCStatus?.ID == 12,
          'StatusCanceled': CurrentOrder.OCStatus?.ID == 11
        }">
          {{CurrentOrder.OCStatus?.Name}}
        </span>
      </div>
    </div>

    <div class="EditContainerBody">

      <!-- ✅ Partner & Currency Management Section -->
      <div class="PartnerCurrencyManagementSection">
        <!-- Partner Search Container -->
        <div class="PartnerSearchContainer" [class.disabled]="isCanceled">
          <!-- Transparent Overlay (closes partner results when clicking outside) -->
          <div class="EditContainerOverlayTransparent" *ngIf="showEditContainerPartnerResults && !isCanceled" (click)="showEditContainerPartnerResults = false"></div>

          <div class="PartnerSearchBar">
            <i class="material-icons search-icon" *ngIf="!editContainerPartnerSearchTerm || editContainerPartnerSearchTerm.length === 0">search</i>
            <i class="material-icons clear-icon" *ngIf="editContainerPartnerSearchTerm?.length > 0 && !isCanceled" (click)="clearEditContainerPartnerSearch()">close</i>
            <input type="text" class="PartnerSearchInput" [placeholder]="'SearchPartnerPlaceholder' | translate"
                   [(ngModel)]="editContainerPartnerSearchTerm" (focus)="!isCanceled && onEditContainerPartnerSearchFocus()"
                   (ngModelChange)="!isCanceled && editContainerPartnerSearchTermUpdate.next($event)" [disabled]="isCanceled" />
            <mat-spinner class="search-spinner" *ngIf="editContainerLoadingPartners" [diameter]="20"></mat-spinner>
          </div>

          <div class="PartnerSearchResults" *ngIf="showEditContainerPartnerResults && editContainerSearchedPartners?.length > 0">
            <div class="PartnerSearchResult" *ngFor="let p of editContainerSearchedPartners" (click)="selectEditContainerPartner(p)">
              <div class="PartnerResultMain">
                <span class="PartnerCountryBadge" *ngIf="p.BillingAddress?.Country?.ShortName">[{{p.BillingAddress.Country.ShortName}}]</span>
                <span class="PartnerName">{{p.Name}}</span>
                <span class="PartnerVAT" *ngIf="p.BillingAddress?.VATNumber">{{p.BillingAddress.VATNumber}}</span>
              </div>
            </div>
          </div>

          <div class="SelectedPartnerDisplay" *ngIf="CurrentOrder?.Cart?.Partner" (click)="openPartnerInNewTab()" style="cursor: pointer;" matTooltip="{{ 'OpenPartnerDetails' | translate }}" matTooltipClass='neutral-tool-tip-management'>
            <div class="SelectedPartnerInfo">
              <i class="material-icons SelectedPartnerCheckmark">check_circle</i>
              <span class="SelectedPartnerName">{{CurrentOrder.Cart.Partner.Name}}</span>
              <span class="SelectedPartnerVAT" *ngIf="CurrentOrder.Cart.Partner.BillingAddress?.VATNumber">{{CurrentOrder.Cart.Partner.BillingAddress.VATNumber}}</span>
            </div>
          </div>
        </div>

        <!-- Currency Search Container -->
        <div class="CurrencySearchContainer" [class.disabled]="isCanceled">
          <!-- Transparent Overlay (closes currency results when clicking outside) -->
          <div class="EditContainerOverlayTransparent" *ngIf="showEditContainerCurrencyResults && !isCanceled" (click)="showEditContainerCurrencyResults = false"></div>

          <div class="CurrencySearchBar" (click)="!isCanceled && toggleEditContainerCurrencyDropdown()" [class.disabled]="isCanceled">
            <i class="material-icons">attach_money</i>
            <span class="currency-label">{{CurrentOrder?.Cart?.Currency?.Name || 'Select Currency'}}</span>
            <i class="material-icons">expand_more</i>
          </div>

          <div class="CurrencySearchResults" *ngIf="showEditContainerCurrencyResults && MasterData?.Currencies?.length > 0 && !isCanceled">
            <div class="CurrencySearchResult" *ngFor="let c of MasterData.Currencies" (click)="selectEditContainerCurrency(c)">
              <span class="CurrencyName">{{c.Name}}</span>
              <span class="CurrencySymbol">{{c.Symbol}}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- ✅ Totals Section (like accept-offer page) -->
      <div class="totals-section" *ngIf="CurrentOrder?.Cart?.Total">
        <!-- Subtotal (from OriginalTotal - before any project discount) -->
        <div class="total-row subtotal-row">
          <span class="total-label">{{'Subtotal' | translate}}:</span>
          <span class="total-value subtotal-value">{{ CurrentOrder.Cart.OriginalTotal?.TotalQtyPriceNOVAT | number:'1.2-2' }} {{ CurrentOrder.Cart?.Currency?.Symbol }}</span>
        </div>

        <!-- Project Discount Row (only shown if discount exists) -->
        <div class="total-row discount-row" *ngIf="CurrentOrder.Cart.Total?.Discount?.Value > 0">
          <span class="total-label discount-label">
            {{'ProjectDiscount' | translate}}
            (<ng-container *ngIf="CurrentOrder.Cart.Total.Discount.Type?.ID === 1">{{ CurrentOrder.Cart.Total.Discount.Value | number:'1.2-2' }}%</ng-container><ng-container *ngIf="CurrentOrder.Cart.Total.Discount.Type?.ID === 2">{{ CurrentOrder.Cart.Total.Discount.Value | number:'1.2-2' }} {{ CurrentOrder.Cart?.Currency?.Symbol }}</ng-container>):
          </span>
          <span class="total-value discount-value">- {{ getProjectDiscountAmount() }} {{ CurrentOrder.Cart?.Currency?.Symbol }}</span>
        </div>

        <!-- Subtotal After Discount (only shown if discount exists) -->
        <div class="total-row subtotal-after-discount-row" *ngIf="CurrentOrder.Cart.Total?.Discount?.Value > 0">
          <span class="total-label">{{'SubtotalAfterDiscount' | translate}}:</span>
          <span class="total-value">{{ CurrentOrder.Cart.Total.TotalQtyPriceNOVAT | number:'1.2-2' }} {{ CurrentOrder.Cart?.Currency?.Symbol }}</span>
        </div>

        <!-- Shipping + Purchase Total Row (side by side) -->
        <div class="shipping-purchase-row">
          <div class="total-row shipping-row">
            <span class="total-label">{{'ShippingCost' | translate}}:</span>
            <span class="total-value shipping-value">{{ CurrentOrder.Cart.ShippingCost?.UIUnitPrice != null ? (CurrentOrder.Cart.ShippingCost.UIUnitPrice | number:'1.2-2') : '--,--' }} {{ CurrentOrder.Cart?.Currency?.Symbol }}</span>
          </div>
          <div class="total-row purchase-total-row" *ngIf="CurrentOrder.Cart.PurchaseTotal?.TotalQtyPriceNOVAT > 0">
            <span class="total-label">{{'PurchaseTotalNoVAT' | translate}}:</span>
            <span class="total-value">{{ CurrentOrder.Cart.PurchaseTotal.TotalQtyPriceNOVAT | number:'1.2-2' }} {{ CurrentOrder.Cart.PurchaseTotal?.Currency?.Symbol || CurrentOrder.Cart?.Currency?.Symbol }}</span>
          </div>
        </div>
        <!-- Pure Profit Row -->
        <div class="total-row pure-profit-row" *ngIf="CurrentOrder.Cart.Total?.TotalPureProfit != null" [ngClass]="{'profit-positive': CurrentOrder.Cart.Total.TotalPureProfit > 0, 'profit-negative': CurrentOrder.Cart.Total.TotalPureProfit < 0}">
          <span class="total-label">{{'PureProfit' | translate}}:</span>
          <span class="total-value">{{ CurrentOrder.Cart.Total.TotalPureProfit | number:'1.2-2' }} {{ CurrentOrder.Cart?.Currency?.Symbol }}</span>
        </div>

        <!-- Final Total (Subtotal + Shipping) -->
        <div class="total-row absolute-total-row">
          <span class="total-label">{{'GrandTotal' | translate}}:</span>
          <span class="total-value absolute-total-value">{{ getAbsoluteTotal() }} {{ CurrentOrder.Cart?.Currency?.Symbol }}</span>
        </div>
      </div>

      <!-- ✅ Discount Controls (kept for editing) -->
      <div class="OrderTotalRow">
        <span class="OrderTotalLabel">{{'Discount' | translate}}:</span>
        <div class="DiscountControls">
          <!-- Discount Type Dropdown -->
          <div class="CustomDropdownContainer DiscountDropdownContainer">
            <div class="DropdownOverlayTransparent" *ngIf="showDiscountTypeDropdown" (click)="showDiscountTypeDropdown = false"></div>
            <div class="CustomDropdownBar" (click)="showDiscountTypeDropdown = !showDiscountTypeDropdown">
              <i class="material-icons dropdown-icon-left">percent</i>
              <input type="text" class="CustomDropdownInput" readonly
                     [class.placeholder]="!this.CurrentOrder?.Cart?.Total?.Discount?.Type"
                     [value]="this.CurrentOrder?.Cart?.Total?.Discount?.Type?.Name || 'Select...'" />
              <i class="material-icons dropdown-icon">arrow_drop_down</i>
            </div>
            <div class="CustomDropdownResults" *ngIf="showDiscountTypeDropdown">
              <div class="CustomDropdownResult" *ngFor="let type of parent.masterData?.DiscountTypes"
                   (click)="selectDiscountType(type)">
                <div class="CustomDropdownResultMain">
                  <span class="CustomDropdownResultText">{{type.Name}}</span>
                </div>
              </div>
            </div>
          </div>
          <!-- Discount Value Input -->
          <div class="CustomDropdownBar CustomDropdownBarInput DiscountValueContainer">
            <input type="text" class="CustomDropdownInput DiscountValueInput"
                   [(ngModel)]="this.CurrentOrder.Cart.Total.Discount.Value"
                   (keypress)="validateDiscountInput($event)"
                   placeholder="0" />
          </div>
          <!-- Apply Discount Button -->
          <button class="GridCommandButton GridCommandButtonBlue" (click)="ApplyOrderDiscount()" [disabled]="!this.CurrentOrder?.Cart?.Total?.Discount?.Type || !this.CurrentOrder?.Cart?.Total?.Discount?.Value">
            <i class="material-icons">check</i>
          </button>
          <!-- Clear Discount Button -->
          <button class="GridCommandButton GridCommandButtonRed" (click)="ClearOrderDiscount()" [disabled]="!this.CurrentOrder?.Cart?.Total?.Discount?.Type && !this.CurrentOrder?.Cart?.Total?.Discount?.Value">
            <i class="material-icons">close</i>
          </button>
        </div>
      </div>

      <!-- Modern Collapsible Section -->
      <div class="EditSection">
        <div class="EditSectionHeader" (click)="this.ShowOrderGeneralInformation = !this.ShowOrderGeneralInformation">
          <div class="EditSectionHeaderLeft">
            <i class="material-icons">info</i>
            <span>{{'GeneralInfomration' | translate}}</span>
          </div>
          <i class="material-icons EditSectionToggle">{{this.ShowOrderGeneralInformation ? 'expand_less' : 'expand_more'}}</i>
        </div>

        <div class="EditSectionBody" *ngIf="this.ShowOrderGeneralInformation == true;">
          <div class="EditFieldsGrid EditFieldsGridCustom">
            <!-- Request Number -->
            <div class="CustomDropdownContainer EditField">
              <div class="CustomDropdownBar CustomDropdownBarInput disabled">
                <i class="material-icons dropdown-icon-left">tag</i>
                <span class="dropdown-label">{{'RequestNumber' | translate}}</span>
                <input type="text" class="CustomDropdownInput" readonly [value]="this.CurrentOrder.ReferenceNumber" />
              </div>
            </div>

            <!-- Debator PO -->
            <!-- Supplier Offer Number -->
            <div class="CustomDropdownContainer EditField">
              <div class="CustomDropdownBar CustomDropdownBarInput" [class.disabled]="isCanceled" style="border: 2px solid #1976d2;">
                <i class="material-icons dropdown-icon-left" style="color: #1976d2;">description</i>
                <span class="dropdown-label">{{'SupplierOfferNumber' | translate}}</span>
                <input type="text" class="CustomDropdownInput" style="letter-spacing: 2px;font-weight: 600;color: #1976d2;" [(ngModel)]="this.CurrentOrder.SupplierOfferNumber" [disabled]="isCanceled" />
              </div>
            </div>

            <div class="CustomDropdownContainer EditField">
              <div class="CustomDropdownBar CustomDropdownBarInput" [class.disabled]="isCanceled">
                <i class="material-icons dropdown-icon-left">receipt</i>
                <span class="dropdown-label">{{'DebatorPO' | translate}}</span>
                <input type="text" class="CustomDropdownInput" style="letter-spacing: 2px;font-weight: 600;color: #00a79d;" [(ngModel)]="this.CurrentOrder.DebatorPO" [disabled]="isCanceled" />
              </div>
            </div>

            <!-- Uploader -->
            <div class="CustomDropdownContainer EditField">
              <div class="CustomDropdownBar CustomDropdownBarInput disabled">
                <i class="material-icons dropdown-icon-left">upload</i>
                <span class="dropdown-label">{{'Uploader' | translate}}</span>
                <input type="text" class="CustomDropdownInput" readonly [value]="this.CurrentOrder.UserUploader?.UIName" />
              </div>
            </div>

            <!-- Manager -->
            <div class="CustomDropdownContainer EditField">
              <div class="CustomDropdownBar CustomDropdownBarInput disabled">
                <i class="material-icons dropdown-icon-left">person</i>
                <span class="dropdown-label">{{'Manager' | translate}}</span>
                <input type="text" class="CustomDropdownInput" readonly [value]="this.CurrentOrder.UserManager?.UIName" />
              </div>
            </div>

            <!-- Weight -->
            <div class="CustomDropdownContainer EditField">
              <div class="CustomDropdownBar CustomDropdownBarInput disabled">
                <i class="material-icons dropdown-icon-left">scale</i>
                <span class="dropdown-label">{{'Weight' | translate}}</span>
                <input type="text" class="CustomDropdownInput" readonly
                       [value]="this.CurrentOrder.Cart?.Weight ? (this.CurrentOrder.Cart.Weight + ' ' + (this.CurrentOrder.Cart?.WeightMeasurementType?.Name || '')) : '--'" />
              </div>
            </div>

            <!-- Currency -->
            <div class="CustomDropdownContainer EditField">
              <div class="CustomDropdownBar CustomDropdownBarInput disabled">
                <i class="material-icons dropdown-icon-left">currency_exchange</i>
                <span class="dropdown-label">{{'Currency' | translate}}</span>
                <input type="text" class="CustomDropdownInput" readonly
                       [value]="this.CurrentOrder.Cart?.Currency?.Name && this.CurrentOrder.Cart?.Currency?.ExchangeRate ? (this.CurrentOrder.Cart.Currency.Name + ' (' + this.CurrentOrder.Cart.Currency.ExchangeRate + ')') : '--'" />
              </div>
            </div>
          </div>

          <div class="EditAgentsSection" [class.disabled]="isCanceled">
            <div class="EditAgentsTitle">
              <i class="material-icons">people</i>
              <span>{{'OrderContactAgents' | translate}}</span>
            </div>
            <div class="EditAgentsList">
              <div class="EditAgentRow" *ngFor="let agent of this.CurrentOrder.Cart.Partner?.PartnerAgents">
                <div class="EditAgentToggleRow">
                  <label class="EditAgentToggle" [class.disabled]="isCanceled">
                    <input type="checkbox" [checked]="agent.IsSelected == true"
                           (change)="!isCanceled && (agent.IsSelected = !agent.IsSelected)"
                           [disabled]="isCanceled">
                    <span class="EditAgentToggleSlider"></span>
                  </label>
                  <span class="EditAgentLabel">{{agent.Name || agent.Email}}</span>
                  <span class="EditAgentEmail" *ngIf="agent.Name">{{agent.Email}}</span>
                  <button class="AgentSelectPhasesBtn"
                          *ngIf="agent.IsSelected == true"
                          [class.has-phases]="agent.OrderPhases?.length > 0"
                          (click)="openAgentPhasesPopup(agent); $event.stopPropagation();">
                    <i class="material-icons">tune</i>
                    <span>{{ 'SelectNotificationPhases' | translate }}</span>
                    <span class="AgentPhasesCount" *ngIf="agent.OrderPhases?.length > 0">{{agent.OrderPhases.length}}</span>
                    <i class="material-icons AgentPhaseExpandArrow">expand_more</i>
                  </button>
                </div>
                <div class="AgentPhaseBadges" *ngIf="agent.IsSelected == true && agent.OrderPhases?.length > 0">
                  <span class="AgentPhaseBadge" *ngFor="let phase of agent.OrderPhases">{{phase.Name}}</span>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

        <div class="EditSection">
          <div class="EditSectionHeader" (click)="this.ShowOrderBillingInformation = !this.ShowOrderBillingInformation">
            <div class="EditSectionHeaderLeft">
              <i class="material-icons">receipt_long</i>
              <span>{{'BillingInformation' | translate}}</span>
            </div>
            <i class="material-icons EditSectionToggle">{{this.ShowOrderBillingInformation ? 'expand_less' : 'expand_more'}}</i>
          </div>

         <div class="EditSectionBody" *ngIf="this.ShowOrderBillingInformation == true;">
          <div class="EditFieldsGrid">
            <mat-form-field appearance="outline" class="EditField">
              <mat-label>{{'Name' | translate}}</mat-label>
              <input matInput disabled="true" [(ngModel)]="this.CurrentOrder.Cart.Partner.Name">
            </mat-form-field>

            <mat-form-field appearance="outline" class="EditField">
              <mat-label>{{'VAT' | translate}}</mat-label>
              <input matInput disabled="true" [(ngModel)]="this.CurrentOrder.Cart.Partner.VAT">
            </mat-form-field>

            <mat-form-field appearance="outline" class="EditField">
              <mat-label>{{'COCRegNumber' | translate}}</mat-label>
              <input matInput disabled="true" [(ngModel)]="this.CurrentOrder.Cart.Partner.COCRegNumber">
            </mat-form-field>

            <mat-form-field appearance="outline" class="EditField">
              <mat-label>{{'Country' | translate}}</mat-label>
              <input matInput disabled="true" [(ngModel)]="this.CurrentOrder.Cart.Partner.BillingAddress.Country.Name">
            </mat-form-field>

            <mat-form-field appearance="outline" class="EditField">
              <mat-label>{{'StateProvince' | translate}}</mat-label>
              <input matInput disabled="true" [(ngModel)]="this.CurrentOrder.Cart.Partner.BillingAddress.StateProvince">
            </mat-form-field>

            <mat-form-field appearance="outline" class="EditField">
              <mat-label>{{'City' | translate}}</mat-label>
              <input matInput disabled="true" [(ngModel)]="this.CurrentOrder.Cart.Partner.BillingAddress.City">
            </mat-form-field>

            <mat-form-field appearance="outline" class="EditFieldFull">
              <mat-label>{{'AddressLine' | translate}}</mat-label>
              <input matInput disabled="true" [(ngModel)]="this.CurrentOrder.Cart.Partner.BillingAddress.AddressLine">
            </mat-form-field>

            <!-- Payment Term Dropdown -->
            <div class="CustomDropdownContainer EditFieldFull" [class.disabled]="isCanceled">
              <div class="DropdownOverlayTransparent" *ngIf="showPaymentTermDropdown && !isCanceled" (click)="showPaymentTermDropdown = false"></div>
              <div class="CustomDropdownBar" (click)="!isCanceled && (showPaymentTermDropdown = !showPaymentTermDropdown)" [class.disabled]="isCanceled">
                <i class="material-icons dropdown-icon-left">payments</i>
                <span class="dropdown-label">{{'PaymentTerms' | translate}}</span>
                <input type="text" class="CustomDropdownInput" readonly
                       [class.placeholder]="!this.CurrentOrder?.Cart?.PaymentTerm"
                       [value]="this.CurrentOrder?.Cart?.PaymentTerm?.Name || 'Select...'" />
                <i class="material-icons dropdown-icon">arrow_drop_down</i>
              </div>
              <div class="CustomDropdownResults CustomDropdownResultsUpward" *ngIf="showPaymentTermDropdown && !isCanceled">
                <div class="CustomDropdownResult" *ngFor="let term of parent.CartMasterData?.PaymentTerms"
                     (click)="selectPaymentTerm(term)">
                  <div class="CustomDropdownResultMain">
                    <i class="material-icons" [style.color]="CurrentOrder?.Cart?.PaymentTerm?.ID === term.ID ? '#10b981' : '#9ca3af'">
                      {{ CurrentOrder?.Cart?.PaymentTerm?.ID === term.ID ? 'check_circle' : 'radio_button_unchecked' }}
                    </i>
                    <span class="CustomDropdownResultText">{{term.Name}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
         </div>
        </div>

        <div class="EditSection">
          <div class="EditSectionHeader" (click)="this.ShowOrderShippingInformation = !this.ShowOrderShippingInformation">
            <div class="EditSectionHeaderLeft">
              <i class="material-icons">local_shipping</i>
              <span>{{'ShippingInformation' | translate}}</span>
              <!-- Lock Shipping Settings Toggle -->
              <div class="auto-save-toggle-container" (click)="$event.stopPropagation()" [class.disabled]="isCanceled">
                <label class="auto-save-toggle">
                  <input type="checkbox" [(ngModel)]="this.CurrentOrder.Cart.LockShippingSettings" (change)="onLockShippingSettingsChange()" [disabled]="isCanceled">
                  <span class="toggle-slider"></span>
                </label>
                <span class="auto-save-label"><i class="material-icons" style="font-size: 14px;">{{this.CurrentOrder.Cart.LockShippingSettings ? 'lock' : 'lock_open'}}</i></span>
              </div>
            </div>
            <i class="material-icons EditSectionToggle">{{this.ShowOrderShippingInformation ? 'expand_less' : 'expand_more'}}</i>
          </div>

           <div class="EditSectionBody" *ngIf="this.ShowOrderShippingInformation == true;">
            <div class="EditFieldsGrid EditFieldsGridCustom">
              <!-- Shipping Address Dropdown -->
              <div class="CustomDropdownContainer EditFieldFull" *ngIf="this.CurrentOrder.Cart.Partner.ShippingAddresses?.length > 0" [class.disabled]="isCanceled">
                <div class="DropdownOverlayTransparent" *ngIf="showShippingAddressDropdown && !isCanceled" (click)="showShippingAddressDropdown = false"></div>
                <div class="CustomDropdownBar" (click)="!isCanceled && (showShippingAddressDropdown = !showShippingAddressDropdown)" [class.disabled]="isCanceled">
                  <i class="material-icons dropdown-icon-left">location_on</i>
                  <span class="dropdown-label">{{ 'ShippingAddresses' | translate }}</span>
                  <input type="text" class="CustomDropdownInput" readonly
                         [class.placeholder]="!this.CurrentOrder.ShippingAddress"
                         [value]="this.CurrentOrder.ShippingAddress ? (this.CurrentOrder.ShippingAddress.Country?.Name + ' ' + this.CurrentOrder.ShippingAddress.City + ' ' + this.CurrentOrder.ShippingAddress.AddressLine) : 'Select...'" />
                  <i class="material-icons dropdown-icon">arrow_drop_down</i>
                </div>
                <div class="CustomDropdownResults" *ngIf="showShippingAddressDropdown && !isCanceled">
                  <div class="CustomDropdownResult" *ngFor="let a of this.CurrentOrder.Cart.Partner.ShippingAddresses"
                       (click)="selectShippingAddress(a)">
                    <div class="CustomDropdownResultMain">
                      <i class="material-icons">place</i>
                      <span class="CustomDropdownResultText">{{a.Country?.Name}} {{a.City}} {{a.AddressLine}}</span>
                    </div>
                  </div>
                </div>
              </div>

              <ng-container *ngIf="this.CurrentOrder.ShippingAddress">
                <!-- Country Dropdown -->
                <div class="CustomDropdownContainer EditField" [class.disabled]="isCanceled">
                  <div class="DropdownOverlayTransparent" *ngIf="showShippingCountryDropdown && !isCanceled" (click)="showShippingCountryDropdown = false"></div>
                  <div class="CustomDropdownBar" (click)="!isCanceled && (showShippingCountryDropdown = !showShippingCountryDropdown)" [class.disabled]="isCanceled">
                    <i class="material-icons dropdown-icon-left">public</i>
                    <span class="dropdown-label">{{ 'Country' | translate }}</span>
                    <input type="text" class="CustomDropdownInput" readonly
                           [class.placeholder]="!this.CurrentOrder.ShippingAddress?.Country"
                           [value]="this.CurrentOrder.ShippingAddress?.Country?.Name || 'Select...'" />
                    <i class="material-icons dropdown-icon">arrow_drop_down</i>
                  </div>
                  <div class="CustomDropdownResults" *ngIf="showShippingCountryDropdown && !isCanceled">
                    <div class="CustomDropdownResult" *ngFor="let c of this.parent.masterData.Countries"
                         (click)="selectShippingCountry(c)">
                      <div class="CustomDropdownResultMain">
                        <span class="CustomDropdownResultText">{{c.Name}}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- State/Province -->
                <div class="CustomDropdownContainer EditField" [class.disabled]="isCanceled">
                  <div class="CustomDropdownBar CustomDropdownBarInput" [class.disabled]="isCanceled">
                    <i class="material-icons dropdown-icon-left">map</i>
                    <span class="dropdown-label">{{'StateProvince' | translate}}</span>
                    <input type="text" class="CustomDropdownInput" [(ngModel)]="this.CurrentOrder.ShippingAddress.State" [disabled]="isCanceled" />
                  </div>
                </div>

                <!-- City -->
                <div class="CustomDropdownContainer EditField" [class.disabled]="isCanceled">
                  <div class="CustomDropdownBar CustomDropdownBarInput" [class.disabled]="isCanceled">
                    <i class="material-icons dropdown-icon-left">location_city</i>
                    <span class="dropdown-label">{{'Partners.PartnerWindow.City' | translate}}</span>
                    <input type="text" class="CustomDropdownInput" [(ngModel)]="this.CurrentOrder.ShippingAddress.City" [disabled]="isCanceled" />
                  </div>
                </div>

                <!-- Zip Code -->
                <div class="CustomDropdownContainer EditField" [class.disabled]="isCanceled">
                  <div class="CustomDropdownBar CustomDropdownBarInput" [class.disabled]="isCanceled">
                    <i class="material-icons dropdown-icon-left">markunread_mailbox</i>
                    <span class="dropdown-label">{{'ZipCode' | translate}}</span>
                    <input type="text" class="CustomDropdownInput" style="letter-spacing: 2px;font-weight: 600;" [(ngModel)]="this.CurrentOrder.ShippingAddress.ZipCode" [disabled]="isCanceled" />
                  </div>
                </div>

                <!-- Address Line -->
                <div class="CustomDropdownContainer EditFieldFull" [class.disabled]="isCanceled">
                  <div class="CustomDropdownBar CustomDropdownBarInput" [class.disabled]="isCanceled">
                    <i class="material-icons dropdown-icon-left">home</i>
                    <span class="dropdown-label">{{'Partners.PartnerWindow.AddressLine' | translate}}</span>
                    <input type="text" class="CustomDropdownInput" [(ngModel)]="this.CurrentOrder.ShippingAddress.AddressLine" [disabled]="isCanceled" />
                  </div>
                </div>
              </ng-container>
            </div>

            <!-- ✅ Delimiter -->
            <div class="ShippingSectionDelimiter"></div>

            <!-- ✅ Shipping Settings -->
            <div class="EditFieldsGrid EditFieldsGridCustom">
              <!-- Shipping Responsability -->
              <div class="CustomDropdownContainer CustomDropdownContainerUpward EditField" [class.locked]="this.CurrentOrder.Cart?.LockShippingSettings" [class.disabled]="isCanceled">
                <div class="DropdownOverlayTransparent" *ngIf="showShippingResponsabilityDropdown && !this.CurrentOrder.Cart?.LockShippingSettings && !isCanceled" (click)="showShippingResponsabilityDropdown = false"></div>
                <div class="CustomDropdownBar" (click)="!this.CurrentOrder.Cart?.LockShippingSettings && !isCanceled && (showShippingResponsabilityDropdown = !showShippingResponsabilityDropdown)" [class.disabled]="isCanceled">
                  <i class="material-icons dropdown-icon-left">assignment_ind</i>
                  <span class="dropdown-label">{{'ShippingResponsability' | translate}}</span>
                  <input type="text" class="CustomDropdownInput" readonly
                         [class.placeholder]="!this.CurrentOrder.Cart?.ShippingResponsability"
                         [value]="this.CurrentOrder.Cart?.ShippingResponsability?.Name || 'Select...'" />
                  <i class="material-icons dropdown-icon" *ngIf="!this.CurrentOrder.Cart?.LockShippingSettings && !isCanceled">arrow_drop_up</i>
                  <i class="material-icons dropdown-icon locked-icon" *ngIf="this.CurrentOrder.Cart?.LockShippingSettings || isCanceled">lock</i>
                </div>
                <div class="CustomDropdownResults CustomDropdownResultsUpward" *ngIf="showShippingResponsabilityDropdown && !this.CurrentOrder.Cart?.LockShippingSettings && !isCanceled">
                  <div class="CustomDropdownResult" *ngFor="let item of ShippingResponsabilities"
                       (click)="selectShippingResponsability(item)">
                    <div class="CustomDropdownResultMain">
                      <span class="CustomDropdownResultText">{{item.Name}}</span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Shipping Service Type (hidden when EXW selected) -->
              <div class="CustomDropdownContainer CustomDropdownContainerUpward EditField" [class.locked]="this.CurrentOrder.Cart?.LockShippingSettings" [class.disabled]="isCanceled" *ngIf="this.CurrentOrder.Cart?.ShippingResponsability?.ID !== 0">
                <div class="DropdownOverlayTransparent" *ngIf="showShippingServiceTypeDropdown && !this.CurrentOrder.Cart?.LockShippingSettings && !isCanceled" (click)="showShippingServiceTypeDropdown = false"></div>
                <div class="CustomDropdownBar" (click)="!this.CurrentOrder.Cart?.LockShippingSettings && !isCanceled && (showShippingServiceTypeDropdown = !showShippingServiceTypeDropdown)" [class.disabled]="isCanceled">
                  <i class="material-icons dropdown-icon-left">speed</i>
                  <span class="dropdown-label">{{'ShippingServiceType' | translate}}</span>
                  <input type="text" class="CustomDropdownInput" readonly
                         [class.placeholder]="!this.CurrentOrder.Cart?.ShippingServiceType"
                         [value]="this.CurrentOrder.Cart?.ShippingServiceType?.Name || 'Select...'" />
                  <i class="material-icons dropdown-icon" *ngIf="!this.CurrentOrder.Cart?.LockShippingSettings && !isCanceled">arrow_drop_up</i>
                  <i class="material-icons dropdown-icon locked-icon" *ngIf="this.CurrentOrder.Cart?.LockShippingSettings || isCanceled">lock</i>
                </div>
                <div class="CustomDropdownResults CustomDropdownResultsUpward" *ngIf="showShippingServiceTypeDropdown && !this.CurrentOrder.Cart?.LockShippingSettings && !isCanceled">
                  <div class="CustomDropdownResult" *ngFor="let item of ShippingServiceTypes"
                       (click)="selectShippingServiceType(item)">
                    <div class="CustomDropdownResultMain">
                      <span class="CustomDropdownResultText">{{item.Name}}</span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Shipping Company (hidden when EXW selected) -->
              <div class="CustomDropdownContainer CustomDropdownContainerUpward EditField" [class.locked]="this.CurrentOrder.Cart?.LockShippingSettings" [class.disabled]="isCanceled" *ngIf="this.CurrentOrder.Cart?.ShippingResponsability?.ID !== 0">
                <div class="DropdownOverlayTransparent" *ngIf="showShippingCompanyDropdown && !this.CurrentOrder.Cart?.LockShippingSettings && !isCanceled" (click)="showShippingCompanyDropdown = false"></div>
                <div class="CustomDropdownBar" (click)="!this.CurrentOrder.Cart?.LockShippingSettings && !isCanceled && (showShippingCompanyDropdown = !showShippingCompanyDropdown)" [class.disabled]="isCanceled">
                  <i class="material-icons dropdown-icon-left">local_shipping</i>
                  <span class="dropdown-label">{{'ShippingCompany' | translate}}</span>
                  <input type="text" class="CustomDropdownInput" readonly
                         [class.placeholder]="!this.CurrentOrder.Cart?.ShippingCompany"
                         [value]="this.CurrentOrder.Cart?.ShippingCompany?.Name || 'Select...'" />
                  <i class="material-icons dropdown-icon" *ngIf="!this.CurrentOrder.Cart?.LockShippingSettings && !isCanceled">arrow_drop_up</i>
                  <i class="material-icons dropdown-icon locked-icon" *ngIf="this.CurrentOrder.Cart?.LockShippingSettings || isCanceled">lock</i>
                </div>
                <div class="CustomDropdownResults CustomDropdownResultsUpward" *ngIf="showShippingCompanyDropdown && !this.CurrentOrder.Cart?.LockShippingSettings && !isCanceled">
                  <div class="CustomDropdownResult" *ngFor="let item of ShippingCompanies"
                       (click)="selectShippingCompany(item)">
                    <div class="CustomDropdownResultMain">
                      <span class="CustomDropdownResultText">{{item.Name}}</span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Shipping Cost + Currency -->
              <div class="CustomDropdownContainer EditField" [class.disabled]="isCanceled">
                <div class="CustomDropdownBar CustomDropdownBarInput" [class.disabled]="isCanceled">
                  <i class="material-icons dropdown-icon-left">payments</i>
                  <span class="dropdown-label">{{'ShippingCost' | translate}}</span>
                  <input type="number" class="CustomDropdownInput" style="font-weight: 600;"
                         [(ngModel)]="this.CurrentOrder.Cart.ShippingCost.UIUnitPrice"
                         placeholder="0.00" [disabled]="isCanceled" />
                  <span class="ShippingCostCurrency">{{this.CurrentOrder.Cart?.Currency?.Symbol || this.CurrentOrder.Cart?.Currency?.Name || ''}}</span>
                </div>
              </div>

              <!-- Original Shipping Cost (read-only) -->
              <div class="CustomDropdownContainer EditField disabled" *ngIf="this.CurrentOrder.Cart?.OriginalShippingCost?.UIUnitPrice != null">
                <div class="CustomDropdownBar CustomDropdownBarInput disabled">
                  <i class="material-icons dropdown-icon-left" style="color:#9e9e9e;">history</i>
                  <span class="dropdown-label">{{'OriginalShippingCost' | translate}}</span>
                  <input type="number" class="CustomDropdownInput" style="font-weight: 600; color: #9e9e9e;"
                         [value]="this.CurrentOrder.Cart.OriginalShippingCost.UIUnitPrice"
                         disabled readonly />
                  <span class="ShippingCostCurrency" style="color:#9e9e9e;">{{this.CurrentOrder.Cart?.Currency?.Symbol || this.CurrentOrder.Cart?.Currency?.Name || ''}}</span>
                </div>
              </div>

              <!-- Shipping Cost Discharge Type -->
              <div class="CustomDropdownContainer CustomDropdownContainerUpward EditField" [class.disabled]="isCanceled || HasInvoicedShippingCosts" [class.locked]="HasInvoicedShippingCosts">
                <div class="DropdownOverlayTransparent" *ngIf="showShippingCostDischargeTypeDropdown && !isCanceled && !HasInvoicedShippingCosts" (click)="showShippingCostDischargeTypeDropdown = false"></div>
                <div class="CustomDropdownBar" (click)="!isCanceled && !HasInvoicedShippingCosts && (showShippingCostDischargeTypeDropdown = !showShippingCostDischargeTypeDropdown)" [class.disabled]="isCanceled || HasInvoicedShippingCosts">
                  <i class="material-icons dropdown-icon-left">request_quote</i>
                  <span class="dropdown-label">{{'ShippingCostDischargeType' | translate}}</span>
                  <input type="text" class="CustomDropdownInput" readonly
                         [class.placeholder]="!this.CurrentOrder.Cart?.ShippingCostDischargeType"
                         [value]="this.CurrentOrder.Cart?.ShippingCostDischargeType?.Name || 'Select...'" />
                  <i class="material-icons dropdown-icon" *ngIf="!isCanceled && !HasInvoicedShippingCosts">arrow_drop_up</i>
                  <i class="material-icons dropdown-icon locked-icon" *ngIf="HasInvoicedShippingCosts">lock</i>
                </div>
                <div class="CustomDropdownResults CustomDropdownResultsUpward" *ngIf="showShippingCostDischargeTypeDropdown && !isCanceled && !HasInvoicedShippingCosts">
                  <div class="CustomDropdownResult" *ngFor="let item of MasterData?.ShippingCostDischargeTypes"
                       (click)="selectShippingCostDischargeType(item)">
                    <div class="CustomDropdownResultMain">
                      <i class="material-icons" [style.color]="this.CurrentOrder.Cart?.ShippingCostDischargeType?.ID === item.ID ? '#4caf50' : '#9ca3af'">
                        {{ this.CurrentOrder.Cart?.ShippingCostDischargeType?.ID === item.ID ? 'check_circle' : 'radio_button_unchecked' }}
                      </i>
                      <span class="CustomDropdownResultText">{{ item.Name }}</span>
                    </div>
                    <span class="CustomDropdownResultDescription" *ngIf="item.Description">{{ item.Description }}</span>
                  </div>
                </div>
              </div>

              <!-- Weight Type Dropdown -->
              <div class="CustomDropdownContainer EditField" [class.disabled]="isCanceled">
                <div class="DropdownOverlayTransparent" *ngIf="showWeightTypeDropdown && !isCanceled" (click)="showWeightTypeDropdown = false"></div>
                <div class="CustomDropdownBar" (click)="!isCanceled && (showWeightTypeDropdown = !showWeightTypeDropdown)" [class.disabled]="isCanceled">
                  <i class="material-icons dropdown-icon-left">scale</i>
                  <span class="dropdown-label">{{'WeightType' | translate}}</span>
                  <input type="text" class="CustomDropdownInput" readonly
                         [class.placeholder]="!this.CurrentOrder?.Cart?.WeightMeasurementType"
                         [value]="this.CurrentOrder?.Cart?.WeightMeasurementType?.Name || 'Select...'" />
                  <i class="material-icons dropdown-icon">arrow_drop_down</i>
                </div>
                <div class="CustomDropdownResults CustomDropdownResultsUpward" *ngIf="showWeightTypeDropdown && !isCanceled">
                  <div class="CustomDropdownResult" *ngFor="let wt of parent.CartMasterData?.WeightTypes"
                       (click)="selectWeightType(wt)">
                    <div class="CustomDropdownResultMain">
                      <i class="material-icons" [style.color]="CurrentOrder?.Cart?.WeightMeasurementType?.ID === wt.ID ? '#10b981' : '#9ca3af'">
                        {{ CurrentOrder?.Cart?.WeightMeasurementType?.ID === wt.ID ? 'check_circle' : 'radio_button_unchecked' }}
                      </i>
                      <span class="CustomDropdownResultText">{{wt.Name}}</span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Weight Input -->
              <div class="CustomDropdownContainer EditField" [class.disabled]="isCanceled">
                <div class="CustomDropdownBar CustomDropdownBarInput"
                     [style.border]="this.CurrentOrder?.Cart?.ForcedUIWeight ? '2px solid #ff6600' : ''" [class.disabled]="isCanceled">
                  <i class="material-icons dropdown-icon-left">fitness_center</i>
                  <span class="dropdown-label">{{'Weight' | translate}}</span>
                  <input type="number" step="0.01" class="CustomDropdownInput"
                         [style.font-weight]="600"
                         [(ngModel)]="this.CurrentOrder.Cart.Weight"
                         (ngModelChange)="onWeightChange($event)"
                         placeholder="0.00" [disabled]="isCanceled" />
                </div>
              </div>
            </div>

            <!-- ✅ Products Insurance Section (shown when DAP, DDP, or FCA selected) -->
            <div class="InsuranceContainer" *ngIf="this.CurrentOrder.Cart?.ShippingResponsability?.RequiresInsurance != null" [class.disabled]="isCanceled">
              <mat-slide-toggle
                matTooltip="{{ 'RequestProductsInsuranceDescription' | translate}}"
                matTooltipClass='neutral-tool-tip'
                class="InsuranceToggleSetting"
                [(ngModel)]="this.CurrentOrder.Cart.HasInsurance"
                [disabled]="isCanceled">
              </mat-slide-toggle>
              <span class="InsuranceContainerInfo">{{ 'RequestProductsInsuranceDescription2' | translate}}</span>
            </div>

           </div>
        </div>

        <div class="EditSection EditSectionProducts">
          <div class="EditSectionHeader" (click)="this.ShowOrderProductsInformation = !this.ShowOrderProductsInformation">
            <div class="EditSectionHeaderLeft">
              <i class="material-icons">shopping_cart</i>
              <span>{{'Products' | translate}}</span>
              <span class="ProductCount">({{this.CurrentOrder.Cart?.Items?.length || 0}})</span>
              <div class="GridCommandButton GridCommandButtonBlue HeaderAddRowsButton" *ngIf="!isCanceled" (click)="addMoreRows(50); $event.stopPropagation()">
                <i class="material-icons">add</i>
                <span>{{'AddRows' | translate}}</span>
              </div>
            </div>
            <i class="material-icons EditSectionToggle">{{this.ShowOrderProductsInformation ? 'expand_less' : 'expand_more'}}</i>
          </div>

          <div class="EditSectionBody EditSectionBodyGrid" *ngIf="this.ShowOrderProductsInformation == true;">
            <!-- AG Grid Container - same as Products tab -->
            <!-- ✅ Overlay for popups -->
            <div class="overlayTransparent"
                 *ngIf="ShowETAAlternatives == true || ShowSupplierAlternatives == true || ShowBrandCollateral == true || ShowFallbackSelection == true || ShowPartnerSearchPopup == true || ShowCOOSearchPopup == true"
                 (click)="closeAllPopups();">
            </div>

            <div class="ProductsAGGridContainer" (click)="onGridCellButtonClick($event)">
              <!-- ✅ Excel Export Column Control Row - aligned with ag-Grid columns (must match productsColumnDefs order) -->
              <div class="ExcelExportControlRow" *ngIf="CurrentOrder?.PDFColumns">
                <!-- 1. index -->
                <div class="ExcelExportControlCell" [ngStyle]="getColumnWidth('index')">
                  <mat-checkbox [checked]="allExportColumnsSelected" (change)="toggleAllExportColumns($event.checked)" color="primary"></mat-checkbox>
                </div>
                <!-- 2. partnerName (Partner column) -->
                <div class="ExcelExportControlCell" [ngStyle]="getColumnWidth('partnerName')"></div>
                <!-- 3. offerRef (Offer column) -->
                <div class="ExcelExportControlCell" [ngStyle]="getColumnWidth('offerRef')"></div>
                <!-- 4. brand -->
                <div class="ExcelExportControlCell" [ngStyle]="getColumnWidth('brand')"></div>
                <!-- 5. partNumber -->
                <div class="ExcelExportControlCell" [ngStyle]="getColumnWidth('partNumber')"></div>
                <!-- 6. name -->
                <div class="ExcelExportControlCell" [ngStyle]="getColumnWidth('name')"></div>
                <!-- 7. quantity -->
                <div class="ExcelExportControlCell" [ngStyle]="getColumnWidth('quantity')"></div>
                <!-- 8. officialListPrice -->
                <div class="ExcelExportControlCell" [ngStyle]="getColumnWidth('officialListPrice')">
                  <mat-checkbox [checked]="CurrentOrder?.PDFColumns?.ListPrice" (change)="onExportColumnChange('ListPrice', $event.checked)" color="primary"></mat-checkbox>
                </div>
                <!-- 9. officialDiscount -->
                <div class="ExcelExportControlCell" [ngStyle]="getColumnWidth('officialDiscount')">
                  <mat-checkbox [checked]="CurrentOrder?.PDFColumns?.Discount" (change)="onExportColumnChange('Discount', $event.checked)" color="primary"></mat-checkbox>
                </div>
                <!-- 10. price -->
                <div class="ExcelExportControlCell" [ngStyle]="getColumnWidth('price')"></div>
                <!-- 11. sellCurrency -->
                <div class="ExcelExportControlCell" [ngStyle]="getColumnWidth('sellCurrency')"></div>
                <!-- 12. total -->
                <div class="ExcelExportControlCell" [ngStyle]="getColumnWidth('total')"></div>
                <!-- 13. eta -->
                <div class="ExcelExportControlCell" [ngStyle]="getColumnWidth('eta')">
                  <mat-checkbox [checked]="CurrentOrder?.PDFColumns?.StandardDelivery" (change)="onExportColumnChange('ETA', $event.checked)" color="primary"></mat-checkbox>
                </div>
                <!-- 14. supplier -->
                <div class="ExcelExportControlCell" [ngStyle]="getColumnWidth('supplier')"></div>
                <!-- 15. purchase -->
                <div class="ExcelExportControlCell" [ngStyle]="getColumnWidth('purchase')"></div>
                <!-- 16. purchaseCurrency -->
                <div class="ExcelExportControlCell" [ngStyle]="getColumnWidth('purchaseCurrency')"></div>
                <!-- 17. hscode -->
                <div class="ExcelExportControlCell" [ngStyle]="getColumnWidth('hscode')">
                  <mat-checkbox [checked]="CurrentOrder?.PDFColumns?.HSCode" (change)="onExportColumnChange('HSCode', $event.checked)" color="primary"></mat-checkbox>
                </div>
                <!-- 18. coo -->
                <div class="ExcelExportControlCell" [ngStyle]="getColumnWidth('coo')">
                  <mat-checkbox [checked]="CurrentOrder?.PDFColumns?.COO" (change)="onExportColumnChange('COO', $event.checked)" color="primary"></mat-checkbox>
                </div>
                <!-- 19. weight -->
                <div class="ExcelExportControlCell" [ngStyle]="getColumnWidth('weight')">
                  <mat-checkbox [checked]="CurrentOrder?.PDFColumns?.Weight" (change)="onExportColumnChange('Weight', $event.checked)" color="primary"></mat-checkbox>
                </div>
                <!-- 20. save -->
                <div class="ExcelExportControlCell" [ngStyle]="getColumnWidth('save')"></div>
                <!-- 22. delete -->
                <div class="ExcelExportControlCell" [ngStyle]="getColumnWidth('delete')"></div>
              </div>

              <ag-grid-angular
                class="ag-theme-alpine admin-grid"
                style="width: 100%;"
                [rowData]="offerGridRowData"
                [columnDefs]="productsColumnDefs"
                [defaultColDef]="productsDefaultColDef"
                [gridOptions]="offerGridOptions"
                (gridReady)="onOfferGridReady($event)"
                (columnResized)="syncColumnWidths()"
                (contextmenu)="$event.preventDefault()">
              </ag-grid-angular>

              <!-- ✅ Name Column Popup (ShowETAAlternatives) - matching original -->
              <div class="SearchResultsAlternativesContainer grid-style-popup animated fadeIn"
                  *ngIf="ShowETAAlternatives === true"
                  [ngStyle]="SearchResultsPosition">

                <div class="SearchResultsHeader">
                  <span>{{ 'OtherOffers' | translate }}</span>
                  <button class="CloseBtn" (click)="ShowETAAlternatives = false">×</button>
                </div>

                <!-- ✅ Tabs for unified popup -->
                <div class="GridModeTabsWrapper">
                  <div class="GridModeTab"
                       [ngClass]="{'SelectedGridModeTab': selectedNamePopupTab === 1}"
                       (click)="onNamePopupTabChange(1)">
                    <span>{{ 'OtherOffers' | translate }}</span>
                  </div>
                </div>

                <div class="SearchResultsList" *ngIf="LoadingSideOffers === true" style="margin-top: 50px; margin-bottom: 50px;">
                  <mat-spinner class="smallSpinner" [diameter]="30"></mat-spinner>
                </div>

                <!-- ✅ Tab 1: Other Offers -->
                <div class="SearchResultsList" *ngIf="LoadingSideOffers !== true && selectedNamePopupTab === 1">
                  <div class="OfferRow header-row">
                    <div class="GridCell indexx-column" style="font-style: italic;">#</div>
                    <div class="GridCell brand-column" style="font-style: italic;">{{'Brand' | translate}}</div>
                    <div class="GridCell partnumber-column" style="font-style: italic;">{{'ProductCode' | translate}}</div>
                    <div class="GridCell name-column" style="font-style: italic;">{{'ProductName' | translate}}</div>
                    <div class="GridCell qty-column" style="font-style: italic;">min.{{'Quantity' | translate}}</div>
                    <div class="GridCell price-column" style="font-style: italic;">{{'SellPrice' | translate}}</div>
                    <div class="GridCell total-column" style="font-style: italic;">{{'Total' | translate}}</div>
                    <div class="GridCell eta-column" style="font-style: italic;">{{'ETA' | translate}}</div>
                    <div class="GridCell supplier-column" style="font-style: italic;">Supplier</div>
                    <div class="GridCell purchase-column" style="font-style: italic;">Purchase</div>
                    <div class="GridCell hscode-column" style="font-style: italic;">{{'HSCode' | translate}}</div>
                    <div class="GridCell coo-column" style="font-style: italic;">{{'COO' | translate}}</div>
                    <div class="GridCell weight-column" style="font-style: italic;">{{'Weight' | translate}}</div>
                    <div class="GridCell x-column" style="font-style: italic;"></div>
                  </div>
                  <div class="OfferRow"
                      *ngFor="let result of SideOffers; index as i"
                      (click)="SwitchGridProductOffer(result)"
                      [ngClass]="{ 'SelectedRow': result.IsSelected, 'GridValid': result.SelectedOffer?.IsStockOffer == true && result.SelectedOffer?.IsManufacturerStockOffer != true }">
                    <div class="GridCell indexx-column">{{i + 1}}</div>
                    <div class="GridCell brand-column">{{result.Product?.Brand?.Name}}</div>
                    <div class="GridCell partnumber-column">{{result.Product?.PartNumber}}</div>
                    <div class="GridCell name-column">
                      <i class="material-icons SelectedGridRowName" *ngIf="result.IsSelected == true;">check</i>
                      <span>{{result.Product?.Name}}</span>
                      <span class="GridCellSpecialPriceSignal" *ngIf="result.SelectedOffer?.Configuration?.SpecialPriceList == true;">({{'SpecialPriceOffer' | translate}})</span>
                    </div>
                    <div class="GridCell qty-column">{{result.Quantity}}</div>
                    <div class="GridCell price-column">{{result.Price?.UIUnitPrice}} {{result.SelectedOffer?.Currency?.Symbol}}</div>
                    <div class="GridCell total-column">{{result.Price?.UIQtyPrice}} {{result.SelectedOffer?.Currency?.Symbol}}</div>
                    <div class="GridCell eta-column">
                      <span *ngIf="result.SelectedOffer?.LeadTime?.Units > 0">{{result.SelectedOffer.LeadTime.Units}} {{result.SelectedOffer.LeadTime.Type?.Name}}</span>
                      <span *ngIf="!result.SelectedOffer?.LeadTime?.Units || result.SelectedOffer?.LeadTime?.Units <= 0">------</span>
                    </div>
                    <div class="GridCell supplier-column">{{result.SelectedOffer?.Partner?.Name}}</div>
                    <div class="GridCell purchase-column">{{result.SelectedOffer?.ListPrice}} {{result.SelectedOffer?.Currency?.Symbol}}</div>
                    <div class="GridCell hscode-column">{{result.Product?.Stats?.HSCode}}</div>
                    <div class="GridCell coo-column">{{result.Product?.Stats?.COO?.Name}}</div>
                    <div class="GridCell weight-column">{{result.Product?.Stats?.Weight}}</div>
                    <div class="GridCell x-column"></div>
                  </div>
                  <div class="NoAlternatives" *ngIf="SideOffers?.length === 0">
                    No alternatives available
                  </div>
                </div>


              </div>

              <!-- Brand Collateral Popup (matching original) -->
              <div class="BrandCollateralContainer" *ngIf="ShowBrandCollateral == true" [ngStyle]="BrandPopupPosition">
                <div class="SearchResultsList" *ngIf="LoadingSideOffers === true" style="margin-top: 50px; margin-bottom: 50px; overflow: hidden;">
                  <mat-spinner class="smallSpinner" [diameter]="30"></mat-spinner>
                </div>
                <div *ngIf="LoadingSideOffers != true;" class="SearchResultsList" style="overflow: hidden;">
                  <div class="brand-collateral-item" *ngFor="let b of BrandCollateralList" (click)="SwitchGridBrandVersion2(b);">
                    <span>{{ b?.Name}}</span>
                    <i class="material-icons" *ngIf="b.IsSelected == true;">check</i>
                  </div>
                </div>
              </div>

              <!-- Supplier Alternatives Popup (matching original) -->
              <div class="SearchResultsAlternativesContainer grid-style-popup supplier-alternatives-popup animated fadeIn"
                  *ngIf="ShowSupplierAlternatives === true && LoadingSideOffers !== true && (SideOffers?.length > 0 || SupplierPopupSearchTerm?.length > 0)"
                  [ngStyle]="SupplierPopupPosition">

                <!-- Search Textbox -->
                <div style="padding: 8px; border-bottom: 1px solid #e0e0e0;">
                  <input
                    type="text"
                    class="supplier-popup-search-input"
                    placeholder="Search supplier..."
                    [(ngModel)]="SupplierPopupSearchTerm"
                    (ngModelChange)="SearchSupplierPopup()"
                    style="width: 100%; padding: 6px 10px; border: 1px solid #ddd; border-radius: 4px; font-size: 11px; outline: none; box-sizing: border-box;"
                  />
                </div>

                <!-- Show search results when searching -->
                <div *ngIf="SupplierPopupSearchTerm?.length > 0 && SupplierPopupSearchResults?.length > 0">
                  <div class="supplier-popup-item" *ngFor="let partner of SupplierPopupSearchResults" (click)="SelectPartnerFromSearch(partner)">
                    <div class="supplier-popup-column" style="flex: 1; padding: 8px 12px;">
                      {{ partner?.Name }}
                    </div>
                  </div>
                </div>

                <!-- Show original side offers when NOT searching -->
                <div *ngIf="!SupplierPopupSearchTerm || SupplierPopupSearchTerm?.length === 0">
                  <div class="supplier-popup-item" *ngFor="let cartItem of SideOffers" (click)="SelectSideOffer(cartItem)">
                    <div class="supplier-popup-column supplier-name-column">
                      <span *ngIf="cartItem?.SelectedOffer?.MOQ > 0">[{{ cartItem?.SelectedOffer?.MOQ }}] </span>{{ cartItem?.SelectedOffer?.Partner?.Name || 'N/A' }}
                    </div>
                    <div class="supplier-popup-column purchase-info-column">
                      {{ cartItem?.SelectedOffer?.ListPrice || 'N/A' }} {{ cartItem?.SelectedOffer?.Currency?.Symbol || 'N/A' }}
                    </div>
                    <div class="supplier-popup-column stock-column">
                      <span *ngIf="cartItem?.SelectedOffer?.StockQuantity > 0">STOCK</span>
                    </div>
                    <div class="supplier-popup-column leadtime-column">
                      <span *ngIf="cartItem?.SelectedOffer?.LeadTime?.Units > 0">
                        {{ cartItem.SelectedOffer.LeadTime.Units }} {{ cartItem.SelectedOffer.LeadTime.Type?.Name || '' }}
                      </span>
                      <span *ngIf="!cartItem?.SelectedOffer?.LeadTime?.Units || cartItem?.SelectedOffer?.LeadTime?.Units <= 0">
                        ------
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Loading spinner for supplier popup -->
              <div class="SearchResultsAlternativesContainer grid-style-popup supplier-alternatives-popup animated fadeIn"
                  *ngIf="ShowSupplierAlternatives === true && LoadingSideOffers === true"
                  [ngStyle]="SupplierPopupPosition"
                  style="min-height: 100px; display: flex; align-items: center; justify-content: center;">
                <mat-spinner class="smallSpinner" [diameter]="30"></mat-spinner>
              </div>

              <!-- Partner Search Popup -->
              <div class="PartnerSearchContainer GridModeTabsWrapper"
                   *ngIf="ShowPartnerSearchPopup"
                   [style.top]="SupplierPopupPosition.top"
                   [style.left]="SupplierPopupPosition.left">
                <div class="PopupHeader">
                  <span>Search Supplier</span>
                  <i class="material-icons ClosePopup" (click)="ShowPartnerSearchPopup = false">close</i>
                </div>
                <div class="PopupBody">
                  <input type="text"
                         class="PartnerSearchInput"
                         [(ngModel)]="PartnerSearchTerm"
                         placeholder="Search partner..."
                         (input)="searchPartnerUpdate.next(PartnerSearchTerm)">
                  <div class="PartnerSearchResults" *ngIf="PartnerSearchResults?.length > 0">
                    <div class="PartnerItem"
                         *ngFor="let partner of PartnerSearchResults"
                         (click)="selectPartner(partner)">
                      {{partner?.Name}}
                    </div>
                  </div>
                </div>
              </div>

              <!-- COO Search Popup -->
              <div class="COOSearchContainer GridModeTabsWrapper"
                   *ngIf="ShowCOOSearchPopup"
                   [style.top]="COOPopupPosition.top"
                   [style.left]="COOPopupPosition.left">
                <div class="PopupHeader">
                  <span>Select Country of Origin</span>
                  <i class="material-icons ClosePopup" (click)="ShowCOOSearchPopup = false">close</i>
                </div>
                <div class="PopupBody">
                  <input type="text"
                         class="COOSearchInput"
                         [(ngModel)]="COOSearchTerm"
                         placeholder="Search country...">
                  <div class="COOSearchResults" *ngIf="parent?.masterData?.Countries?.length > 0">
                    <div class="COOItem"
                         *ngFor="let country of parent?.masterData?.Countries"
                         (click)="selectCOO(country)"
                         [class.hidden]="COOSearchTerm && !country?.Name?.toLowerCase().includes(COOSearchTerm.toLowerCase())">
                      {{country?.Name}}
                    </div>
                  </div>
                </div>
              </div>

            </div>




          </div>
        </div>

    </div>

    <!-- Modern Footer -->
    <div class="EditContainerFooter">
      <div class="GridCommandButton GridCommandButtonBlue" (click)="!isCanceled && AddNewOffer();" [class.disabled]="this.parent.loading || isCanceled">
        <i class="material-icons" *ngIf="!this.parent.loading">save</i>
        <span *ngIf="!this.parent.loading">{{'Save' | translate}}</span>
        <mat-spinner *ngIf="this.parent.loading" diameter="18"></mat-spinner>
      </div>

      <!-- Auto-Save Toggle for Single-Order Popup Grid -->
      <div class="auto-save-toggle-container" *ngIf="CurrentOrder?.DBID > 0"
           [matTooltip]="'AutoSaveDescription' | translate" matTooltipPosition="above">
        <label class="auto-save-toggle">
          <input type="checkbox" [(ngModel)]="OfferAutoSave">
          <span class="toggle-slider"></span>
        </label>
        <span class="auto-save-label">{{ 'AutoSave' | translate }}</span>
      </div>

      <!-- Convert to Order Section -->
      <div class="ConvertToOrderSection" *ngIf="!isCanceled">
        <!-- Send Email Dropdown -->
        <div class="SendEmailSearchContainer">
          <div class="SendEmailOverlayTransparent" *ngIf="showSendEmailResults" (click)="showSendEmailResults = false"></div>
          <div class="SendEmailSearchBar" (click)="onSendEmailFocus()">
            <span class="send-email-label">{{'SendEmail' | translate}}</span>
            <i class="material-icons send-email-icon" [style.color]="sendEmailOnConvert ? '#4caf50' : '#f44336'">
              {{ sendEmailOnConvert ? 'check_circle' : 'cancel' }}
            </i>
            <input type="text" class="SendEmailSearchInput" [value]="getSendEmailLabel()" readonly />
            <i class="material-icons dropdown-icon">arrow_drop_down</i>
          </div>
          <div class="SendEmailSearchResults" *ngIf="showSendEmailResults">
            <div class="SendEmailSearchResult" *ngFor="let option of sendEmailOptions" (click)="selectSendEmailOption(option)">
              <div class="SendEmailResultMain">
                <i class="material-icons" [style.color]="option.value ? '#4caf50' : '#f44336'">
                  {{ option.value ? 'check_circle' : 'cancel' }}
                </i>
                <span class="SendEmailResultLabel">{{option.label}}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="GridCommandButton GridCommandButtonOrange" (click)="ShowGeneratePOConfirmation = true;" [class.disabled]="this.parent.loading">
          <i class="material-icons" *ngIf="!this.parent.loading">shopping_cart</i>
          <span *ngIf="!this.parent.loading">{{'GeneratePO' | translate}}</span>
          <mat-spinner *ngIf="this.parent.loading" diameter="18"></mat-spinner>
        </div>
      </div>
    </div>
</div>

<div class="MainOrdersContainer">

  <div class="OrderControlls">
    <!-- Page Header -->
    <div class="PurchaseOrderPageHeader">
      <div class="QuotationPageTitle">
        <i class="material-icons">local_shipping</i>
        <span>{{ 'NewPurchaseOrderPageTitle' | translate }}</span>
      </div>
      <div class="QuotationPageTitle QuotationPageTitleRight">
        <span>{{ 'PurchasingAgent' | translate }}: {{this.parent.User?.Email}}</span>
        <i class="material-icons">person</i>
      </div>
      <div style="clear: both;"></div>
      <div class="QuotationPageSubtitle">
        {{ 'NewPurchaseOrderPageDescription' | translate }}
      </div>
    </div>

    <!-- Compact Filter Bar -->
    <div class="CompactFilterBar">
      <div class="FilterBarLeft">
        <div class="GroupingDropdownContainer">
          <div class="GroupingDropdownOverlay" *ngIf="showPeriodDropdown" (click)="showPeriodDropdown = false"></div>
          <button class="GroupingButton" #periodBtn (click)="togglePeriodDropdown(periodBtn)">
            <span class="GroupingLabel">{{ 'Receptions.ChoosePeriod' | translate }}</span>
            <span class="GroupingValue">{{ Filter?.Period?.Name || '—' }}</span>
            <i class="material-icons GroupingChevron">expand_more</i>
          </button>
          <div class="GroupingDropdownOptions" *ngIf="showPeriodDropdown"
               [style.top]="periodDropdownPosition.top"
               [style.left]="periodDropdownPosition.left">
            <div class="GroupingDropdownOption" *ngFor="let a of MasterData?.Periods"
                 [class.selected]="Filter?.Period?.Name === a.Name"
                 (click)="selectPeriod(a)">
              <i class="material-icons" style="font-size: 14px;">{{ Filter?.Period?.Name === a.Name ? 'check_circle' : 'radio_button_unchecked' }}</i>
              <span>{{ a.Name }}</span>
            </div>
          </div>
        </div>

        <mat-form-field class="CompactField" appearance="outline">
          <mat-label>{{ 'Receptions.FromDate' | translate }}</mat-label>
          <input matInput [matDatepicker]="dp" [formControl]="FromDate" (dateChange)="ClearPeriod()">
          <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
          <mat-datepicker #dp panelClass="purchaseOrderDatepicker"></mat-datepicker>
        </mat-form-field>

        <mat-form-field class="CompactField" appearance="outline">
          <mat-label>{{ 'Receptions.ToDate' | translate }}</mat-label>
          <input matInput [matDatepicker]="dp1" [formControl]="ToDate" (click)="DisablePeriod();" (dateChange)="ClearPeriod()">
          <mat-datepicker-toggle matSuffix [for]="dp1"></mat-datepicker-toggle>
          <mat-datepicker #dp1 panelClass="purchaseOrderDatepicker"></mat-datepicker>
        </mat-form-field>


      </div>

      <button class="GroupingButton ApplyFilterButton" (click)="resetAllFilters()">
        <i class="material-icons" style="font-size: 16px;">restart_alt</i>
        <span class="GroupingValue">{{ 'ClearFilters' | translate }}</span>
      </button>
    </div>

  </div>

  <!-- Unified Pagination Row -->
  <div class="ProductsPaginationRow">
    <!-- Offers Pagination -->
    <ng-container *ngIf="showOffersTab">
      <div class="PaginationInfo">
        <span>{{Orders?.length}} {{'OfWord' | translate}} {{Filter.Pager.TotalCount}} {{'Orders' | translate}}</span>
      </div>
      <div class="PaginationControls">
        <button mat-stroked-button class="PaginationButton" [disabled]="Filter.Pager.PageIndex == 1" (click)="GetOrdersFiltered(1);">
          <mat-icon>first_page</mat-icon>
        </button>
        <button mat-stroked-button class="PaginationButton" [disabled]="Filter.Pager.PageIndex == 1" (click)="GetOrdersFiltered(Filter.Pager.PageIndex - 1);">
          <mat-icon>chevron_left</mat-icon>
        </button>
        <div class="PageNumberDisplay">
          <span class="CurrentPage">{{Filter.Pager.PageIndex}}</span>
          <span class="PageSeparator">/</span>
          <span class="TotalPages">{{Filter.Pager.Pages}}</span>
        </div>
        <button mat-stroked-button class="PaginationButton" [disabled]="Filter.Pager.PageIndex == Filter.Pager.Pages" (click)="GetOrdersFiltered(Filter.Pager.PageIndex + 1);">
          <mat-icon>chevron_right</mat-icon>
        </button>
        <button mat-stroked-button class="PaginationButton" [disabled]="Filter.Pager.PageIndex == Filter.Pager.Pages" (click)="GetOrdersFiltered(Filter.Pager.Pages);">
          <mat-icon>last_page</mat-icon>
        </button>
        <input type="number" class="PageSizeInput" [(ngModel)]="Filter.Pager.PageSize" (change)="GetOrdersFiltered(1)" min="10" max="500" title="Page Size">
      </div>
      <!-- Minimalist grid saving indicator (right side) for Offers tab -->
      <div class="grid-saving-indicator" *ngIf="savingGridRow">
        <div class="grid-saving-spinner"></div>
        <span>{{ 'SavingRows' | translate }}</span>
      </div>
    </ng-container>
    <!-- Products Pagination -->
    <ng-container *ngIf="!showOffersTab">
      <div class="PaginationInfo">
        <span>{{ProductItems?.length}} {{'OfWord' | translate}} {{ProductsPager?.TotalCount}} {{'Products' | translate}}</span>
      </div>
      <div class="PaginationControls">
        <button mat-stroked-button class="PaginationButton" [disabled]="ProductsPager?.PageIndex == 1" (click)="applyFilter(1);">
          <mat-icon>first_page</mat-icon>
        </button>
        <button mat-stroked-button class="PaginationButton" [disabled]="ProductsPager?.PageIndex == 1" (click)="applyFilter(ProductsPager?.PageIndex - 1);">
          <mat-icon>chevron_left</mat-icon>
        </button>
        <div class="PageNumberDisplay">
          <span class="CurrentPage">{{ProductsPager?.PageIndex}}</span>
          <span class="PageSeparator">/</span>
          <span class="TotalPages">{{ProductsPager?.Pages}}</span>
        </div>
        <button mat-stroked-button class="PaginationButton" [disabled]="ProductsPager?.PageIndex == ProductsPager?.Pages" (click)="applyFilter(ProductsPager?.PageIndex + 1);">
          <mat-icon>chevron_right</mat-icon>
        </button>
        <button mat-stroked-button class="PaginationButton" [disabled]="ProductsPager?.PageIndex == ProductsPager?.Pages" (click)="applyFilter(ProductsPager?.Pages);">
          <mat-icon>last_page</mat-icon>
        </button>
        <input type="number" class="PageSizeInput" [(ngModel)]="Filter.Pager.PageSize" (change)="applyFilter(1)" min="10" max="500" title="Page Size">
        <!-- Auto-Save Toggle + Delay Control -->
        <div class="auto-save-toggle-container">
          <label class="auto-save-toggle">
            <input type="checkbox" [(ngModel)]="AutoSave">
            <span class="toggle-slider"></span>
          </label>
          <span class="auto-save-label">Auto-Save</span>
          <div class="auto-save-delay-control" *ngIf="AutoSave">
            <button class="delay-btn" (click)="decreaseAutoSaveDelay()" [disabled]="autoSaveDelay <= 0.25" title="Decrease delay">−</button>
            <span class="delay-value">{{autoSaveDelay.toFixed(2)}}s</span>
            <button class="delay-btn" (click)="increaseAutoSaveDelay()" [disabled]="autoSaveDelay >= 2.00" title="Increase delay">+</button>
          </div>
        </div>
      </div>
      <!-- Save All After Undo Button - only when AutoSave is OFF (when ON, undo auto-saves) -->
      <button mat-stroked-button class="CompactFilterButton SaveAfterUndoButton"
              *ngIf="!AutoSave && showSaveAfterUndo && !savingGridRow"
              (click)="SaveAllCartItemsAfterUndo()"
              title="Save all items to persist the undo changes">
        <mat-icon style="font-size: 13px; height: 13px; width: 13px;">save</mat-icon>
        <span>{{ 'SaveAll' | translate }}</span>
      </button>
      <!-- Undo Button - only show when there's actually something to undo to (count > 1) -->
      <button mat-stroked-button class="CompactFilterButton UndoButton"
              *ngIf="undoSnapshotCount > 1 && !savingGridRow"
              (click)="undoLastChange()"
              [title]="'Undo last change (' + (undoSnapshotCount - 1) + ' steps available)'">
        <mat-icon style="font-size: 13px; height: 13px; width: 13px;">undo</mat-icon>
        <span class="undo-count-badge">{{undoSnapshotCount - 1}}</span>
      </button>
      <button mat-stroked-button class="CompactFilterButton"
              *ngIf="!AutoSave && hasSelectedCartItems() && !savingGridRow"
              (click)="SaveAllSelectedCartItems()"
              title="Save all selected rows"
              style="margin-left: auto; margin-top: 0px;">
        <mat-icon style="font-size: 13px; height: 13px; width: 13px;">save</mat-icon> Save
      </button>
      <!-- Minimalist grid saving indicator (right side) -->
      <div class="grid-saving-indicator" *ngIf="savingGridRow">
        <div class="grid-saving-spinner"></div>
        <span>{{ 'SavingRows' | translate }}</span>
      </div>
    </ng-container>
  </div>



  <!-- Modern Card-Based List -->
  <div class="OrdersListContainer" *ngIf="activeTab === 'offers'">
    <div class="OrdersBody" *ngIf="this.loadingOrders == true;">
        <mat-spinner class="smallSpinner" [diameter]="30"></mat-spinner>
    </div>

    <div class="OrdersBody" *ngIf="this.loadingOrders != true;">
        <div class="OrderCardRow" [class.selected]="CurrentOrder?.ID == o.ID" *ngFor="let o of this.Orders; let i = index" (dblclick)="GetOffer(o.ID);">
            <!-- Client & Ref -->
            <div class="OrderRowSection OrderRowClient">
              <i class="material-icons">business</i>
              <span class="OrderRowIndex">#{{i + 1}}</span>
              <div class="OrderRowContent">
                <span class="OrderRowLabel">{{'Client' | translate}}</span>
                <span class="OrderRowValue ClientName" (click)="GetOffer(o.ID);">{{o.Cart?.Partner?.Name}}</span>
                <div class="OrderRowMeta">
                  <span class="OrderRefNumber">{{o.ReferenceNumber}}</span>
                  <span class="OrderDebatorPO" *ngIf="o?.DebatorPO?.length > 0;">{{o.DebatorPO}}</span>
                </div>
              </div>
            </div>

            <!-- Date -->
            <div class="OrderRowSection">
              <i class="material-icons">event</i>
              <div class="OrderRowContent">
                <span class="OrderRowLabel">{{'Date' | translate}}</span>
                <span class="OrderRowValue">{{o.EventRegisterUI}}</span>
              </div>
            </div>

            <!-- Agent -->
            <div class="OrderRowSection">
              <i class="material-icons">person</i>
              <div class="OrderRowContent">
                <span class="OrderRowLabel">{{'Agent' | translate}}</span>
                <span class="OrderRowValue">{{o.UserManager.Email}}</span>
              </div>
            </div>

            <!-- Payment -->
            <div class="OrderRowSection">
              <i class="material-icons">payment</i>
              <div class="OrderRowContent">
                <span class="OrderRowLabel">{{'Payment' | translate}}</span>
                <span class="OrderRowValue">{{o.Cart.PaymentType.Name}}</span>
              </div>
            </div>

            <!-- Compact Shipping & Totals Section -->
            <div class="OrderRowSection OrderRowShippingTotals">
              <i class="material-icons">local_shipping</i>
              <div class="OrderRowShippingTotalsContent">

                <!-- Left Column: Shipping Metadata -->
                <div class="OrderRowShippingMeta">
                  <span class="OrderRowLabel">{{'Shipping' | translate}}</span>
                  <div class="OrderRowShippingBadges">
                    <span class="ShippingBadge" *ngIf="o.Cart?.ShippingCompany?.Name">{{o.Cart.ShippingCompany.Name}}</span>
                    <span class="ShippingBadge" *ngIf="o.Cart?.ShippingServiceType?.Name">{{o.Cart.ShippingServiceType.Name}}</span>
                    <span class="ShippingBadge" *ngIf="o.Cart?.ShippingResponsability?.Name">{{o.Cart.ShippingResponsability.Name}}</span>
                    <span class="ShippingBadge" *ngIf="o.Cart?.DeliveryPreference?.Name">{{o.Cart.DeliveryPreference.Name}}</span>
                  </div>
                </div>

                <!-- Right Column: Totals -->
                <div class="OrderRowTotalsCompact">
                  <!-- Subtotal (OriginalTotal before discount) -->
                  <div class="OrderRowTotalLine" *ngIf="o.Cart?.OriginalTotal?.TotalQtyPriceNOVAT">
                    <span class="OrderRowTotalLabel">{{'Subtotal' | translate}}:</span>
                    <span class="OrderRowTotalValue">{{o.Cart.OriginalTotal.TotalQtyPriceNOVAT | number:'1.2-2'}} {{o.Cart?.Currency?.Name}}</span>
                  </div>

                  <!-- Discount (only if exists and > 0) -->
                  <div class="OrderRowTotalLine OrderRowDiscount" *ngIf="o.Cart?.Total?.Discount?.Value > 0">
                    <span class="OrderRowTotalLabel">{{'Discount' | translate}}:</span>
                    <span class="OrderRowTotalValue" *ngIf="o.Cart.Total.Discount.Type?.ID === 1">-{{o.Cart.Total.Discount.Value | number:'1.0-2'}}%</span>
                    <span class="OrderRowTotalValue" *ngIf="o.Cart.Total.Discount.Type?.ID === 2">-{{o.Cart.Total.Discount.Value | number:'1.2-2'}} {{o.Cart?.Currency?.Name}}</span>
                  </div>

                  <!-- Subtotal after discount (only if discount exists) -->
                  <div class="OrderRowTotalLine" *ngIf="o.Cart?.Total?.Discount?.Value > 0 && o.Cart?.Total?.TotalQtyPriceNOVAT">
                    <span class="OrderRowTotalLabel">{{'SubtotalAfterDiscount' | translate}}:</span>
                    <span class="OrderRowTotalValue">{{o.Cart.Total.TotalQtyPriceNOVAT | number:'1.2-2'}} {{o.Cart?.Currency?.Name}}</span>
                  </div>

                  <!-- Shipping Cost -->
                  <div class="OrderRowTotalLine">
                    <span class="OrderRowTotalLabel">{{'ShippingCost' | translate}}:</span>
                    <span class="OrderRowTotalValue">{{(o.Cart?.ShippingCost?.UIUnitPrice || 0) | number:'1.2-2'}} {{o.Cart?.Currency?.Name}}</span>
                  </div>

                  <!-- Grand Total -->
                  <div class="OrderRowTotalLine OrderRowGrandTotal">
                    <span class="OrderRowTotalLabel">{{'GrandTotal' | translate}}:</span>
                    <span class="OrderRowTotalValue OrderRowValueBold">
                      {{((o.Cart?.ShippingCost?.UIUnitPrice || 0) + (o.Cart?.Total?.TotalQtyPriceNOVAT || 0)) | number:'1.2-2'}} {{o.Cart?.Currency?.Name}}
                    </span>
                  </div>
                </div>

              </div>
            </div>

            <!-- Status Dropdown -->
            <div class="OrderRowSection OrderRowStatus">
              <div class="StatusDropdownContainer" *ngIf="o.OCStatus?.ID != 11">
                <span class="OrderStatusBadge StatusDropdownTrigger" [ngClass]="{
                  'StatusNew': o.OCStatus?.ID == -1,
                  'StatusProcessing': o.OCStatus?.ID == 1,
                  'StatusPartial': o.OCStatus?.ID == 9,
                  'StatusConfirmed': o.OCStatus?.ID == 10 || o.OCStatus?.ID == 12,
                  'StatusCanceled': o.OCStatus?.ID == 11
                }" (click)="toggleStatusDropdown(o, $event)" matTooltip="{{o.OCStatus?.Description}} → {{o.OCStatus?.NextStep}}" matTooltipClass='neutral-tool-tip'>
                  {{o.OCStatus?.Name}}
                  <i class="material-icons StatusDropdownIcon">arrow_drop_down</i>
                </span>
                <div class="StatusDropdownOptions" *ngIf="o.showStatusDropdown">
                  <ng-container *ngFor="let status of MasterData?.OrderConfirmationStatuses">
                    <div class="StatusDropdownOption"
                         *ngIf="status.ID != 11"
                         [ngClass]="{
                           'StatusNew': status.ID == -1,
                           'StatusProcessing': status.ID == 1,
                           'StatusPartial': status.ID == 9,
                           'StatusConfirmed': status.ID == 10 || status.ID == 12,
                           'StatusSelected': status.ID == o.OCStatus?.ID
                         }"
                         (click)="OnStatusChange(o, status); $event.stopPropagation();">
                      {{status.Name}}
                    </div>
                  </ng-container>
                </div>
              </div>
              <!-- Static badge for canceled orders (cannot change status) -->
              <span class="OrderStatusBadge StatusCanceled" *ngIf="o.OCStatus?.ID == 11" matTooltip="{{o.OCStatus?.Description}}" matTooltipClass='neutral-tool-tip'>
                {{o.OCStatus?.Name}}
              </span>
              <div class="StatusIndicator" *ngIf="o.ProcessingStatus?.ID == 0;" matTooltip="{{'NeedsWork' | translate}}" matTooltipClass='neutral-tool-tip'></div>
            </div>

            <!-- Actions -->
            <div class="OrderRowSection OrderRowActions">
              <button mat-icon-button (click)="GetOffer(o.ID);" matTooltip="{{'Edit' | translate}}" matTooltipClass='neutral-tool-tip'>
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button (click)="ExportOrder(o);" matTooltip="{{'PDF' | translate}}" matTooltipClass='neutral-tool-tip'>
                <mat-icon>picture_as_pdf</mat-icon>
              </button>
              <button mat-icon-button (click)="ExportOrderExcel(o);" matTooltip="{{'ExportExcel' | translate}}" matTooltipClass='neutral-tool-tip'>
                <mat-icon>grid_on</mat-icon>
              </button>
              <button mat-icon-button (click)="PreCheckOfferConfirmation(o);" matTooltip="{{'Confirm' | translate}}" matTooltipClass='neutral-tool-tip' color="primary">
                <mat-icon>check_circle</mat-icon>
              </button>
              <button mat-icon-button (click)="OpenOrderCancelation(o);" matTooltip="{{'CancelOrder' | translate}}" matTooltipClass='neutral-tool-tip' *ngIf="o.OCStatus?.ID != 11" style="color: #d32f2f;">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>

            <!-- Error Indicator -->
            <div class="OrderRowError" *ngIf="o.InjectionError?.HasError == true || o.InjectionError?.Message?.length > 0;"
                 matTooltip="{{o.InjectionError?.Message || 'APIInjectionError'}}" matTooltipClass='neutral-tool-tip'>
              <i class="material-icons">error</i>
            </div>
        </div>
    </div>
  </div>

  <!-- Products / On-Hold Tab Content (same grid, different data) -->
  <div class="ProductsListContainer" *ngIf="activeTab === 'products' || activeTab === 'onhold'">
    <!-- ✅ Deselect overlay - covers header/filter area above the grid, clicking deselects all -->
    <div class="deselect-above-grid-overlay"
         *ngIf="hasSelectedCartItems()"
         (click)="deselectAllProductItems()"
         #deselectOverlay>
    </div>

    <div class="OrdersBody" *ngIf="loadingProducts">
      <mat-spinner class="smallSpinner" [diameter]="30"></mat-spinner>
    </div>

    <div class="ProductsGrid" *ngIf="!loadingProducts">
      <!-- ✅ Products Grid Actions Bar -->
      <div class="ProductsGridActions" style="display: flex; justify-content: space-between; align-items: center; padding: 8px 12px; background: #f8f9fa; border-bottom: 1px solid #e0e0e0;">
        <!-- Left side: Export & Package List buttons -->
        <div style="display: flex; align-items: center; gap: 8px;">
          <button class="ProductsGridActionButton ExportButton"
                  (click)="openExportDialog()"
                  title="Export products to Excel"
                  [disabled]="exporting">
            <i class="material-icons">file_download</i>
            <span>Export</span>
          </button>


          <!-- Grouping Dropdown -->
          <div class="GroupingDropdownContainer">
            <div class="GroupingDropdownOverlay" *ngIf="showGroupingDropdown" (click)="showGroupingDropdown = false"></div>
            <button class="GroupingButton" #groupingBtn (click)="toggleGroupingDropdown(groupingBtn)" (dblclick)="selectBrandGrouping()">
              <span class="GroupingLabel">{{ 'ProductsGrouping' | translate }}</span>
              <span class="GroupingValue">{{ selectedGrouping?.Name || ('NoGrouping' | translate) }}</span>
              <i class="material-icons GroupingChevron">expand_more</i>
            </button>
            <div class="GroupingDropdownOptions" *ngIf="showGroupingDropdown"
                 [style.top]="groupingDropdownPosition.top"
                 [style.left]="groupingDropdownPosition.left">
              <div class="GroupingDropdownOption" *ngFor="let g of MasterData?.ProductsGroupingSettings"
                   [class.selected]="selectedGrouping?.ID === g.ID"
                   (click)="selectGrouping(g)">
                <i class="material-icons" style="font-size: 14px;">{{ selectedGrouping?.ID === g.ID ? 'check_circle' : 'radio_button_unchecked' }}</i>
                <span>{{ g.Name }}</span>
              </div>
            </div>
          </div>

          <!-- Dispatch Filter Dropdown -->
          <div class="GroupingDropdownContainer">
            <div class="GroupingDropdownOverlay" *ngIf="showDispatchFilterDropdown" (click)="showDispatchFilterDropdown = false"></div>
            <button class="GroupingButton" #dispatchBtn (click)="toggleDispatchFilterDropdown(dispatchBtn)">
              <span class="GroupingLabel">{{ 'Filter' | translate }}</span>
              <span class="GroupingValue">{{ dispatchFilterMode === 'dispatch' ? 'Dispatch Immediately' : 'All' }}</span>
              <i class="material-icons GroupingChevron">expand_more</i>
            </button>
            <div class="GroupingDropdownOptions" *ngIf="showDispatchFilterDropdown"
                 [style.top]="dispatchFilterDropdownPosition.top"
                 [style.left]="dispatchFilterDropdownPosition.left">
              <div class="GroupingDropdownOption"
                   [class.selected]="dispatchFilterMode === 'all'"
                   (click)="selectDispatchFilter('all')">
                <i class="material-icons" style="font-size: 14px;">{{ dispatchFilterMode === 'all' ? 'check_circle' : 'radio_button_unchecked' }}</i>
                <span>All</span>
              </div>
              <div class="GroupingDropdownOption"
                   [class.selected]="dispatchFilterMode === 'dispatch'"
                   (click)="selectDispatchFilter('dispatch')">
                <i class="material-icons" style="font-size: 14px;">{{ dispatchFilterMode === 'dispatch' ? 'check_circle' : 'radio_button_unchecked' }}</i>
                <span>Dispatch Immediately</span>
              </div>
            </div>
          </div>

          <button class="GroupingButton ApplyFilterButton" (click)="applyFilter();">
            <i class="material-icons" style="font-size: 16px;">filter_alt</i>
            <span class="GroupingValue">{{ 'Filter' | translate }}</span>
          </button>

          <!-- Compact Search (next to Filter button) -->
          <div class="MainOrdersSearchContainer MainOrdersSearchCompact">
            <input type="text" class="MainOrdersSearch" placeholder="{{'Search' | translate}}" [(ngModel)]="this.Filter.SearchTerm" (ngModelChange)="this.searchMainOrders.next($event)">
            <i class="material-icons" *ngIf="!this.LoadingMainSearchTerm && !(this.Filter?.SearchTerm?.length > 0);" (click)="applyFilter(1);">search</i>
            <i class="material-icons" *ngIf="!this.LoadingMainSearchTerm && this.Filter?.SearchTerm?.length > 0;" (click)="ResetMainSearch();">close</i>
            <mat-spinner class="smallSpinner" [diameter]="16" *ngIf="this.LoadingMainSearchTerm == true;"></mat-spinner>
          </div>
        </div>

        <!-- Right side: Process Orders & Generate PO buttons -->
        <div style="display: flex; align-items: center; gap: 8px;">
          <button class="ProductsGridActionButton BulkBestPriceButton"
                  *ngIf="hasSelectedCartItems()"
                  (click)="openBulkBestPricePopup(); $event.stopPropagation();"
                  title="{{ 'BulkBestPriceTooltip' | translate }}"
                  [disabled]="bulkBestPriceLoading">
            <i class="material-icons" *ngIf="!bulkBestPriceLoading">sell</i>
            <mat-spinner *ngIf="bulkBestPriceLoading" diameter="18"></mat-spinner>
            <span>{{ 'BulkBestPrice' | translate }}</span>
          </button>


          <button class="GeneratePOButton" *ngIf="hasSelectedCartItems()" (click)="openGeneratePOPopup(); $event.stopPropagation();">
            <i class="material-icons">shopping_cart</i>
            <span>{{ 'GeneratePO' | translate }}</span>
          </button>

          <!-- ✅ NEW PO: create an EMPTY Purchase Order for a chosen supplier (hidden when items are selected) -->
          <button class="GeneratePOButton" style="background: #f60;" *ngIf="!hasSelectedCartItems()" (click)="openNewPOPartnerPopup(); $event.stopPropagation();">
            <i class="material-icons">add_shopping_cart</i>
            <span>{{ 'NewPO' | translate }}</span>
          </button>
        </div>
      </div>

      <!-- Products AG Grid -->
      <div class="ProductsAGGridContainer" (click)="onProductsGridCellButtonClick($event)">
        <!-- Backdrop for popups -->
        <div class="PopupBackdrop"
             *ngIf="ShowProductsETAAlternatives == true || ShowProductsSupplierAlternatives == true || ShowProductsBrandCollateral == true || showPurchaseCurrencyDropdown == true || showSupplierPopup == true || showBrandPopup == true || showPartnerPopup == true || showProgressStatusFilterPopup == true || showDeliveryPreferenceFilterPopup == true || showConsolidationTypeFilterPopup == true"
             (click)="closeProductsPopups(); showSupplierPopup = false; Suppliers = []; showBrandPopup = false; Brands = []; showPartnerPopup = false; Partners = []; showProgressStatusFilterPopup = false; showDeliveryPreferenceFilterPopup = false; showConsolidationTypeFilterPopup = false;">
        </div>

        <!-- Custom Header Overlays for Filter Buttons -->
        <ng-container *ngIf="gridHeaderWidths && gridHeaderWidths.length > 0">
          <ng-container *ngFor="let col of gridHeaderWidths">

            <!-- Brand Filter Overlay -->
            <div class="custom-header-overlay filter-cell"
                 *ngIf="col.field === 'brand'"
                 [style.width.px]="col.width"
                 [style.left.px]="col.left">
              <div class="filter-controls">
                <button *ngIf="Filter.Brand?.ID" class="filter-clear-btn"
                        (click)="clearBrandFilter(); $event.stopPropagation();">
                  <i class="material-icons">close</i>
                </button>
                <button class="filter-dropdown-btn" (click)="openBrandPopup()">
                  <i class="material-icons">expand_more</i>
                </button>
              </div>

              <!-- Brand Filter Popup -->
              <div class="SearchResultsAlternativesContainer grid-style-popup supplier-alternatives-popup"
                   *ngIf="showBrandPopup"
                   style="position: absolute; top: 100%; left: 0; min-width: 300px; z-index: 10000;">
                <div style="padding: 8px; border-bottom: 1px solid #e0e0e0;">
                  <input type="text" class="supplier-popup-search-input" placeholder="Search brand..."
                         [(ngModel)]="brandSearchTerm" (ngModelChange)="brandSearchTermUpdate.next($event)"
                         style="width: 100%; padding: 6px 10px; border: 1px solid #ddd; border-radius: 4px; font-size: 11px; outline: none; box-sizing: border-box;" />
                </div>
                <div *ngIf="loadingBrands" style="padding: 15px; text-align: center;">
                  <mat-spinner [diameter]="20"></mat-spinner>
                </div>
                <div *ngIf="!loadingBrands && Brands?.length > 0" style="max-height: 250px; overflow-y: auto;">
                  <div class="supplier-popup-item" *ngFor="let b of Brands" (click)="selectBrandFilter(b)">
                    <div class="supplier-popup-column" style="flex: 1; padding: 8px 12px;">
                      {{ b?.Name }}
                      <i class="material-icons" *ngIf="Filter.Brand?.ID === b.ID" style="color: #4caf50; font-size: 14px; margin-left: 8px;">check</i>
                    </div>
                  </div>
                </div>
                <div *ngIf="!loadingBrands && Brands?.length === 0 && brandSearchTerm"
                     style="padding: 12px; text-align: center; color: #999; font-size: 11px;">
                  No brands found
                </div>
                <div *ngIf="Filter.Brand?.ID" style="padding: 8px; border-top: 1px solid #e0e0e0;">
                  <button (click)="clearBrandFilter()"
                          style="width: 100%; padding: 6px; background: #f44336; color: white;
                                 border: none; border-radius: 4px; cursor: pointer; font-size: 11px;">
                    Clear Filter
                  </button>
                </div>
              </div>
            </div>

            <!-- Supplier Filter Overlay -->
            <div class="custom-header-overlay filter-cell"
                 *ngIf="col.field === 'supplier'"
                 [style.width.px]="col.width"
                 [style.left.px]="col.left">
              <div class="filter-controls">
                <button *ngIf="Filter.Supplier?.ID" class="filter-clear-btn"
                        (click)="clearSupplierFilter(); $event.stopPropagation();">
                  <i class="material-icons">close</i>
                </button>
                <button class="filter-dropdown-btn" (click)="openSupplierPopup()">
                  <i class="material-icons">expand_more</i>
                </button>
              </div>

              <!-- Supplier Filter Popup -->
              <div class="SearchResultsAlternativesContainer grid-style-popup supplier-alternatives-popup"
                   *ngIf="showSupplierPopup"
                   style="position: absolute; top: 100%; left: 0; min-width: 300px; z-index: 10000;">
                <div style="padding: 8px; border-bottom: 1px solid #e0e0e0;">
                  <input type="text" class="supplier-popup-search-input" placeholder="Search supplier..."
                         [(ngModel)]="supplierSearchTerm" (ngModelChange)="searchSupplierUpdate.next($event)"
                         style="width: 100%; padding: 6px 10px; border: 1px solid #ddd; border-radius: 4px; font-size: 11px; outline: none; box-sizing: border-box;" />
                </div>
                <div *ngIf="loadingSuppliers" style="padding: 15px; text-align: center;">
                  <mat-spinner [diameter]="20"></mat-spinner>
                </div>
                <div *ngIf="!loadingSuppliers && Suppliers?.length > 0" style="max-height: 250px; overflow-y: auto;">
                  <div class="supplier-popup-item" *ngFor="let s of Suppliers" (click)="selectSupplierFilter(s)">
                    <div class="supplier-popup-column" style="flex: 1; padding: 8px 12px;">
                      {{ s?.Name }}
                      <i class="material-icons" *ngIf="Filter.Supplier?.ID === s.ID" style="color: #4caf50; font-size: 14px; margin-left: 8px;">check</i>
                    </div>
                  </div>
                </div>
                <div *ngIf="!loadingSuppliers && Suppliers?.length === 0 && supplierSearchTerm"
                     style="padding: 12px; text-align: center; color: #999; font-size: 11px;">
                  No suppliers found
                </div>
                <div *ngIf="Filter.Supplier?.ID" style="padding: 8px; border-top: 1px solid #e0e0e0;">
                  <button (click)="clearSupplierFilter()"
                          style="width: 100%; padding: 6px; background: #f44336; color: white;
                                 border: none; border-radius: 4px; cursor: pointer; font-size: 11px;">
                    Clear Filter
                  </button>
                </div>
              </div>
            </div>

            <!-- Partner Filter Overlay -->
            <div class="custom-header-overlay filter-cell"
                 *ngIf="col.field === 'partnerName'"
                 [style.width.px]="col.width"
                 [style.left.px]="col.left">
              <div class="filter-controls">
                <button *ngIf="Filter.Partner?.ID" class="filter-clear-btn"
                        (click)="clearPartnerFilter(); $event.stopPropagation();">
                  <i class="material-icons">close</i>
                </button>
                <button class="filter-dropdown-btn" (click)="openPartnerPopup()">
                  <i class="material-icons">expand_more</i>
                </button>
              </div>

              <!-- Partner Filter Popup -->
              <div class="SearchResultsAlternativesContainer grid-style-popup supplier-alternatives-popup"
                   *ngIf="showPartnerPopup"
                   style="position: absolute; top: 100%; left: 0; min-width: 300px; z-index: 10000;">
                <div style="padding: 8px; border-bottom: 1px solid #e0e0e0;">
                  <input type="text" class="supplier-popup-search-input" placeholder="Search partner..."
                         [(ngModel)]="partnerSearchTerm" (ngModelChange)="partnerPopupSearchUpdate.next($event)"
                         style="width: 100%; padding: 6px 10px; border: 1px solid #ddd; border-radius: 4px; font-size: 11px; outline: none; box-sizing: border-box;" />
                </div>
                <div *ngIf="loadingPartners" style="padding: 15px; text-align: center;">
                  <mat-spinner [diameter]="20"></mat-spinner>
                </div>
                <div *ngIf="!loadingPartners && Partners?.length > 0" style="max-height: 250px; overflow-y: auto;">
                  <div class="supplier-popup-item" *ngFor="let p of Partners" (click)="selectPartnerFilter(p)">
                    <div class="supplier-popup-column" style="flex: 1; padding: 8px 12px;">
                      {{ p?.Name }}
                      <i class="material-icons" *ngIf="Filter.Partner?.ID === p.ID" style="color: #4caf50; font-size: 14px; margin-left: 8px;">check</i>
                    </div>
                  </div>
                </div>
                <div *ngIf="!loadingPartners && Partners?.length === 0 && partnerSearchTerm"
                     style="padding: 12px; text-align: center; color: #999; font-size: 11px;">
                  No partners found
                </div>
                <div *ngIf="Filter.Partner?.ID" style="padding: 8px; border-top: 1px solid #e0e0e0;">
                  <button (click)="clearPartnerFilter()"
                          style="width: 100%; padding: 6px; background: #f44336; color: white;
                                 border: none; border-radius: 4px; cursor: pointer; font-size: 11px;">
                    Clear Filter
                  </button>
                </div>
              </div>
            </div>

            <!-- Progress Status Filter Overlay -->
            <div class="custom-header-overlay filter-cell"
                 *ngIf="col.field === 'progressStatus'"
                 [style.width.px]="col.width"
                 [style.left.px]="col.left">
              <div class="filter-controls">
                <button *ngIf="Filter.CartItemProgressStatus?.ID != null" class="filter-clear-btn"
                        (click)="clearProgressStatusFilter(); $event.stopPropagation();">
                  <i class="material-icons">close</i>
                </button>

              </div>

              <!-- Progress Status Filter Popup -->
              <div class="SearchResultsAlternativesContainer grid-style-popup supplier-alternatives-popup"
                   *ngIf="showProgressStatusFilterPopup"
                   style="position: absolute; top: 100%; left: 0; min-width: 150px; z-index: 10000;">
                <div *ngIf="MasterData?.CartItemProgressStatuses?.length > 0" style="max-height: 250px; overflow-y: auto;">
                  <ng-container *ngFor="let s of MasterData?.CartItemProgressStatuses">
                    <div class="supplier-popup-item" *ngIf="s.ID !== -1000"
                         (click)="selectProgressStatusGridFilter(s)"
                         [style.backgroundColor]="getProgressStatusBgColor(s.ID)">
                      <div class="supplier-popup-column" style="flex: 1; padding: 6px 10px; font-size: 11px;"
                           [style.color]="getProgressStatusTextColor(s.ID)">
                        {{ s?.Name }}
                        <i class="material-icons" *ngIf="Filter.CartItemProgressStatus?.ID === s.ID"
                           style="color: #4caf50; font-size: 14px; margin-left: 6px;">check</i>
                      </div>
                    </div>
                  </ng-container>
                </div>
                <div *ngIf="Filter.CartItemProgressStatus?.ID != null" style="padding: 6px; border-top: 1px solid #e0e0e0;">
                  <button (click)="clearProgressStatusFilter()"
                          style="width: 100%; padding: 5px; background: #f44336; color: white;
                                 border: none; border-radius: 4px; cursor: pointer; font-size: 10px;">
                    Clear Filter
                  </button>
                </div>
              </div>
            </div>

            <!-- Delivery Preference Filter Overlay -->
            <div class="custom-header-overlay filter-cell"
                 *ngIf="col.field === 'deliveryPreference'"
                 [style.width.px]="col.width"
                 [style.left.px]="col.left">
              <div class="filter-controls">
                <button *ngIf="Filter.DeliveryPreference?.ID != null" class="filter-clear-btn"
                        (click)="clearDeliveryPreferenceFilter(); $event.stopPropagation();">
                  <i class="material-icons">close</i>
                </button>
                <button *ngIf="Filter.DeliveryPreference?.ID == null" class="filter-dropdown-btn" (click)="showDeliveryPreferenceFilterPopup = true">
                  <i class="material-icons">expand_more</i>
                </button>
              </div>
              <div class="SearchResultsAlternativesContainer grid-style-popup supplier-alternatives-popup"
                   *ngIf="showDeliveryPreferenceFilterPopup"
                   style="position: absolute; top: 100%; left: 0; min-width: 150px; z-index: 10000;">
                <div *ngIf="MasterData?.OrderDeliveryPreferences?.length > 0" style="max-height: 250px; overflow-y: auto;">
                  <div class="supplier-popup-item" *ngFor="let dp of MasterData?.OrderDeliveryPreferences"
                       (click)="selectDeliveryPreferenceGridFilter(dp)">
                    <div class="supplier-popup-column" style="flex: 1; padding: 6px 10px; font-size: 11px;">
                      {{ dp?.Name }}
                      <i class="material-icons" *ngIf="Filter.DeliveryPreference?.ID === dp.ID"
                         style="color: #4caf50; font-size: 14px; margin-left: 6px;">check</i>
                    </div>
                  </div>
                </div>
                <div *ngIf="Filter.DeliveryPreference?.ID != null" style="padding: 6px; border-top: 1px solid #e0e0e0;">
                  <button (click)="clearDeliveryPreferenceFilter()"
                          style="width: 100%; padding: 5px; background: #f44336; color: white;
                                 border: none; border-radius: 4px; cursor: pointer; font-size: 10px;">
                    Clear Filter
                  </button>
                </div>
              </div>
            </div>

            <!-- Consolidation Type Filter Overlay -->
            <div class="custom-header-overlay filter-cell"
                 *ngIf="col.field === 'consolidationType'"
                 [style.width.px]="col.width"
                 [style.left.px]="col.left">
              <div class="filter-controls">
                <button *ngIf="Filter.ConsolidationType?.ID != null" class="filter-clear-btn"
                        (click)="clearConsolidationTypeFilter(); $event.stopPropagation();">
                  <i class="material-icons">close</i>
                </button>
                <button *ngIf="Filter.ConsolidationType?.ID == null" class="filter-dropdown-btn" (click)="showConsolidationTypeFilterPopup = true">
                  <i class="material-icons">expand_more</i>
                </button>
              </div>
              <div class="SearchResultsAlternativesContainer grid-style-popup supplier-alternatives-popup"
                   *ngIf="showConsolidationTypeFilterPopup"
                   style="position: absolute; top: 100%; left: 0; min-width: 150px; z-index: 10000;">
                <div *ngIf="MasterData?.OrderConsolidationTypes?.length > 0" style="max-height: 250px; overflow-y: auto;">
                  <div class="supplier-popup-item" *ngFor="let ct of MasterData?.OrderConsolidationTypes"
                       (click)="selectConsolidationTypeGridFilter(ct)">
                    <div class="supplier-popup-column" style="flex: 1; padding: 6px 10px; font-size: 11px;">
                      {{ ct?.Name }}
                      <i class="material-icons" *ngIf="Filter.ConsolidationType?.ID === ct.ID"
                         style="color: #4caf50; font-size: 14px; margin-left: 6px;">check</i>
                    </div>
                  </div>
                </div>
                <div *ngIf="Filter.ConsolidationType?.ID != null" style="padding: 6px; border-top: 1px solid #e0e0e0;">
                  <button (click)="clearConsolidationTypeFilter()"
                          style="width: 100%; padding: 5px; background: #f44336; color: white;
                                 border: none; border-radius: 4px; cursor: pointer; font-size: 10px;">
                    Clear Filter
                  </button>
                </div>
              </div>
            </div>

          </ng-container>
        </ng-container>

        <ag-grid-angular
          class="ag-theme-alpine admin-grid"
          style="width: 100%; height: 600px;"
          [rowData]="ProductItems"
          [columnDefs]="productsColumnDefs"
          [defaultColDef]="productsDefaultColDef"
          [gridOptions]="productsGridOptions"
          (gridReady)="onProductsGridReady($event)"
          (contextmenu)="$event.preventDefault()">
        </ag-grid-angular>

        <!-- Brand Collateral Popup (matching original) -->
        <div class="BrandCollateralContainer" *ngIf="ShowProductsBrandCollateral == true" [ngStyle]="ProductsBrandPopupPosition">
          <div class="SearchResultsList" *ngIf="ProductsLoadingSideOffers === true" style="margin-top: 50px; margin-bottom: 50px; overflow: hidden;">
            <mat-spinner class="smallSpinner" [diameter]="30"></mat-spinner>
          </div>
          <div *ngIf="ProductsLoadingSideOffers != true;" class="SearchResultsList" style="overflow: hidden;">
            <div class="brand-collateral-item" *ngFor="let b of ProductsBrandCollateralList" (click)="selectProductsBrand(b);">
              <span>{{ b?.Name}}</span>
              <i class="material-icons" *ngIf="b.IsSelected == true;">check</i>
            </div>
          </div>
        </div>

        <!-- Name/Product Alternatives Popup (matching original with tabs) -->
        <div class="SearchResultsAlternativesContainer grid-style-popup animated fadeIn"
             *ngIf="ShowProductsETAAlternatives === true"
             [ngStyle]="ProductsSearchResultsPosition">

          <div class="SearchResultsHeader">
            <span>{{ 'OtherOffers' | translate }}</span>
            <div style="display:flex;align-items:center;gap:4px;">
              <button class="ChainHistoryBtn" (click)="loadChainHistory()" title="{{ 'ItemChainHistory' | translate }}">
                <i class="material-icons">link</i>
              </button>
              <button class="CloseBtn" (click)="ShowProductsETAAlternatives = false">×</button>
            </div>
          </div>

          <!-- Tabs -->
          <div class="GridModeTabsWrapper">
            <div class="GridModeTab" [ngClass]="{'SelectedGridModeTab': selectedProductsNamePopupTab === 0}" (click)="onProductsNamePopupTabChange(0)">
              <span>{{'PriceHistory' | translate}}</span>
            </div>
            <div class="GridModeTab" [ngClass]="{'SelectedGridModeTab': selectedProductsNamePopupTab === 1}" (click)="onProductsNamePopupTabChange(1)">
              <span>{{'OtherOffers' | translate}}</span>
            </div>
          </div>

          <div class="SearchResultsList" *ngIf="ProductsLoadingPriceHistory === true && selectedProductsNamePopupTab === 0" style="margin-top: 50px; margin-bottom: 50px;">
            <mat-spinner class="smallSpinner" [diameter]="30"></mat-spinner>
          </div>

          <!-- Tab 0: Price History -->
          <div class="SearchResultsList" *ngIf="ProductsLoadingPriceHistory !== true && selectedProductsNamePopupTab === 0">
            <div class="OfferRow header-row">
              <div class="GridCell indexx-column" style="font-style: italic;">#</div>
              <div class="GridCell" style="font-style: italic; flex: 0.8;">{{'Brand' | translate}}</div>
              <div class="GridCell" style="font-style: italic; flex: 1.6;">{{'Name' | translate}}</div>
              <div class="GridCell" style="font-style: italic; flex: 1;">{{'PartNumber' | translate}}</div>
              <div class="GridCell" style="font-style: italic; flex: 1.4;">{{'Date' | translate}}</div>
              <div class="GridCell" style="font-style: italic; flex: 1;">{{'SellPrice' | translate}}</div>
              <div class="GridCell" style="font-style: italic; flex: 1;">{{'PurchasePrice' | translate}}</div>
              <div class="GridCell" style="font-style: italic; flex: 1.6;">{{'Supplier' | translate}}</div>
              <div class="GridCell" style="font-style: italic; flex: 1.6;">{{'Customer' | translate}}</div>
            </div>
            <div class="OfferRow" *ngFor="let h of ProductsPriceHistory; index as i" (click)="selectProductsPriceHistory(h)">
              <div class="GridCell indexx-column">{{i + 1}}</div>
              <div class="GridCell" style="flex: 0.8;" [title]="h.BrandName">{{h.BrandName}}</div>
              <div class="GridCell" style="flex: 1.6;" [title]="h.ProductName">{{h.ProductName}}</div>
              <div class="GridCell" style="flex: 1;" [title]="h.ProductPartNumber">{{h.ProductPartNumber}}</div>
              <div class="GridCell" style="flex: 1.4;">{{h.WhenUI}}</div>
              <div class="GridCell" style="flex: 1;">{{h.SellPrice}} {{h.SellCurrencySymbol}}</div>
              <div class="GridCell" style="flex: 1; color: #32aa3a;">{{h.PurchasePrice}} {{h.PurchaseCurrencySymbol}}</div>
              <div class="GridCell" style="flex: 1.6;">{{h.SupplierName}}</div>
              <div class="GridCell" style="flex: 1.6;">{{h.SoldToPartnerName}}</div>
            </div>
            <div class="NoAlternatives" *ngIf="ProductsPriceHistory?.length === 0">
              {{'NoPriceHistory' | translate}}
            </div>
          </div>

          <div class="SearchResultsList" *ngIf="ProductsLoadingSideOffers === true" style="margin-top: 50px; margin-bottom: 50px;">
            <mat-spinner class="smallSpinner" [diameter]="30"></mat-spinner>
          </div>

          <!-- Tab 1: Other Offers -->
          <div class="SearchResultsList" *ngIf="ProductsLoadingSideOffers !== true && selectedProductsNamePopupTab === 1">
            <div class="OfferRow header-row">
              <div class="GridCell indexx-column" style="font-style: italic;">#</div>
              <div class="GridCell brand-column" style="font-style: italic;">{{'Brand' | translate}}</div>
              <div class="GridCell partnumber-column" style="font-style: italic;">{{'ProductCode' | translate}}</div>
              <div class="GridCell name-column" style="font-style: italic;">{{'ProductName' | translate}}</div>
              <div class="GridCell qty-column" style="font-style: italic;">min.{{'Quantity' | translate}}</div>
              <div class="GridCell price-column" style="font-style: italic;">{{'SellPrice' | translate}}</div>
              <div class="GridCell total-column" style="font-style: italic;">{{'Total' | translate}}</div>
              <div class="GridCell eta-column" style="font-style: italic;">{{'ETA' | translate}}</div>
              <div class="GridCell supplier-column" style="font-style: italic;">Supplier</div>
              <div class="GridCell purchase-column" style="font-style: italic;">Purchase</div>
              <div class="GridCell hscode-column" style="font-style: italic;">{{'HSCode' | translate}}</div>
              <div class="GridCell coo-column" style="font-style: italic;">{{'COO' | translate}}</div>
              <div class="GridCell weight-column" style="font-style: italic;">{{'Weight' | translate}}</div>
              <div class="GridCell x-column" style="font-style: italic;"></div>
            </div>
            <div class="OfferRow"
                *ngFor="let result of ProductsSideOffers; index as i"
                (click)="selectProductsSideOffer(result)"
                [ngClass]="{ 'SelectedRow': result.IsSelected, 'GridValid': result.SelectedOffer?.IsStockOffer == true && result.SelectedOffer?.IsManufacturerStockOffer != true }">
              <div class="GridCell indexx-column">{{i + 1}}</div>
              <div class="GridCell brand-column">{{result.Product?.Brand?.Name}}</div>
              <div class="GridCell partnumber-column">{{result.Product?.PartNumber}}</div>
              <div class="GridCell name-column">
                <i class="material-icons SelectedGridRowName" *ngIf="result.IsSelected == true;">check</i>
                <span>{{result.Product?.Name}}</span>
                <span class="GridCellSpecialPriceSignal" *ngIf="result.SelectedOffer?.Configuration?.SpecialPriceList == true;">({{'SpecialPriceOffer' | translate}})</span>
              </div>
              <div class="GridCell qty-column">{{result.Quantity}}</div>
              <div class="GridCell price-column">{{result.Price?.UIUnitPrice}} {{result.SelectedOffer?.Currency?.Symbol}}</div>
              <div class="GridCell total-column">{{result.Price?.UIQtyPrice}} {{result.SelectedOffer?.Currency?.Symbol}}</div>
              <div class="GridCell eta-column">
                <span *ngIf="result.SelectedOffer?.LeadTime?.Units > 0">{{result.SelectedOffer.LeadTime.Units}} {{result.SelectedOffer.LeadTime.Type?.Name}}</span>
                <span *ngIf="!result.SelectedOffer?.LeadTime?.Units || result.SelectedOffer?.LeadTime?.Units == 0">------</span>
              </div>
              <div class="GridCell supplier-column">{{result.SelectedOffer?.Partner?.Name}}</div>
              <div class="GridCell purchase-column">{{result.SelectedOffer?.ListPrice}}</div>
              <div class="GridCell hscode-column">{{result.Product?.Stats?.HSCode}}</div>
              <div class="GridCell coo-column">{{result.Product?.Stats?.COO?.ShortName}}</div>
              <div class="GridCell weight-column">{{result.Product?.Stats?.Weight}}</div>
              <div class="GridCell x-column"></div>
            </div>
            <div class="NoAlternatives" *ngIf="ProductsSideOffers?.length === 0">
              No alternatives available
            </div>
          </div>


        </div>

        <!-- ✅ Apple-style Chain History Centered Overlay -->
        <ng-container *ngIf="ShowChainHistory">
          <div class="AppleChainPanel-overlay" (click)="ShowChainHistory = false"></div>
          <div class="AppleChainPanel">
            <div class="AppleChainPanel-glass">
              <div class="AppleChainPanel-header">
                <div class="AppleChainPanel-headerLeft">
                  <i class="material-icons AppleChainPanel-headerIcon">link</i>
                  <span>{{ 'ChainHistoryTitle' | translate }}</span>
                </div>
                <button class="AppleChainPanel-closeBtn" (click)="ShowChainHistory = false">
                  <i class="material-icons">close</i>
                </button>
              </div>
              <div class="AppleChainPanel-body">
                <div *ngIf="ChainHistoryLoading" class="AppleChainPanel-loading">
                  <mat-spinner [diameter]="24"></mat-spinner>
                  <span>{{ 'LoadingChainHistory' | translate }}</span>
                </div>
                <div *ngIf="!ChainHistoryLoading && ChainHistoryOrderChain?.length === 0" class="AppleChainPanel-empty">
                  <i class="material-icons">link_off</i>
                  <span>{{ 'NoChainHistory' | translate }}</span>
                </div>
                <div *ngIf="!ChainHistoryLoading && ChainHistoryOrderChain?.length > 0" class="AppleChainTimeline">
                  <ng-container *ngFor="let step of ChainHistoryOrderChain; let i = index; let last = last">
                    <!-- Origin node -->
                    <div class="AppleChainStep" *ngIf="i === 0 && step.OldOrderType">
                      <div class="AppleChainStep-pill" [style.background]="getOrderTypeColor(step.OldOrderType.ID)">
                        <i class="material-icons">{{getOrderTypeIcon(step.OldOrderType.ID)}}</i>
                      </div>
                      <div class="AppleChainStep-card">
                        <span class="AppleChainStep-type" [style.color]="getOrderTypeColor(step.OldOrderType.ID)">{{getOrderTypeName(step.OldOrderType.ID)}}</span>
                        <div class="AppleChainStep-card-row">
                          <span class="AppleChainStep-id">#{{step.OldOrderDBID}}</span>
                          <span class="AppleChainStep-ref" *ngIf="step.OldOrderReferenceNumber">{{step.OldOrderReferenceNumber}}</span>
                        </div>
                        <div class="AppleChainStep-card-row" *ngIf="step.OldPartnerName">
                          <span class="AppleChainStep-detail"><i class="material-icons">business</i>{{ 'ChainPartner' | translate }}: {{step.OldPartnerName}}</span>
                        </div>
                        <div class="AppleChainStep-card-row" *ngIf="step.OldDebatorPO">
                          <span class="AppleChainStep-detail"><i class="material-icons">receipt</i>{{ 'ChainDebatorPO' | translate }}: {{step.OldDebatorPO}}</span>
                        </div>
                        <div class="AppleChainStep-card-row" *ngIf="step.OldEventRegister">
                          <span class="AppleChainStep-detail"><i class="material-icons">event</i>{{ 'ChainCreated' | translate }}: {{step.OldEventRegister | date:'dd MMM yyyy HH:mm'}}</span>
                        </div>
                        <div class="AppleChainStep-card-row" *ngIf="step.OldTotalNoVAT">
                          <span class="AppleChainStep-detail"><i class="material-icons">payments</i>{{ 'ChainTotal' | translate }}: {{step.OldTotalNoVAT | number:'1.2-4'}}</span>
                        </div>
                        <div class="AppleChainStep-product" *ngIf="getChainItemQuantities(step.DBID)?.OldBrandName || getChainItemQuantities(step.DBID)?.OldProductName">
                          <span class="AppleChainStep-brand" *ngIf="getChainItemQuantities(step.DBID)?.OldBrandName">{{getChainItemQuantities(step.DBID).OldBrandName}}</span>
                          <span class="AppleChainStep-productName" *ngIf="getChainItemQuantities(step.DBID)?.OldProductName">{{getChainItemQuantities(step.DBID).OldProductName}}</span>
                          <span class="AppleChainStep-partNumber" *ngIf="getChainItemQuantities(step.DBID)?.OldPartNumber">{{getChainItemQuantities(step.DBID).OldPartNumber}}</span>
                        </div>
                        <div class="AppleChainStep-card-row" *ngIf="getChainItemQuantities(step.DBID)?.OldOrderItemQuantity">
                          <span class="AppleChainStep-qty">{{ 'Quantity' | translate }}: {{getChainItemQuantities(step.DBID).OldOrderItemQuantity}}</span>
                        </div>
                        <div class="AppleChainStep-card-row" *ngIf="getChainItemQuantities(step.DBID)?.OldUnitPrice || getChainItemQuantities(step.DBID)?.OldSellPrice">
                          <span class="AppleChainStep-detail" *ngIf="getChainItemQuantities(step.DBID)?.OldUnitPrice"><i class="material-icons">sell</i>{{ 'ChainUnitPrice' | translate }}: {{getChainItemQuantities(step.DBID).OldUnitPrice | number:'1.2-4'}}</span>
                          <span class="AppleChainStep-detail" *ngIf="getChainItemQuantities(step.DBID)?.OldSellPrice" style="margin-left:8px"><i class="material-icons">price_check</i>{{ 'ChainSellPrice' | translate }}: {{getChainItemQuantities(step.DBID).OldSellPrice | number:'1.2-4'}}</span>
                        </div>
                      </div>
                    </div>
                    <div class="AppleChainStep-connector" *ngIf="i === 0 && step.OldOrderType">
                      <div class="AppleChainStep-line"></div>
                      <i class="material-icons">south</i>
                    </div>
                    <!-- Target node -->
                    <div class="AppleChainStep">
                      <div class="AppleChainStep-pill" [style.background]="getOrderTypeColor(step.NewOrderType.ID)">
                        <i class="material-icons">{{getOrderTypeIcon(step.NewOrderType.ID)}}</i>
                      </div>
                      <div class="AppleChainStep-card">
                        <span class="AppleChainStep-type" [style.color]="getOrderTypeColor(step.NewOrderType.ID)">{{getOrderTypeName(step.NewOrderType.ID)}}</span>
                        <div class="AppleChainStep-card-row">
                          <span class="AppleChainStep-id">#{{step.NewOrderDBID}}</span>
                          <span class="AppleChainStep-ref" *ngIf="step.NewOrderReferenceNumber">{{step.NewOrderReferenceNumber}}</span>
                        </div>
                        <div class="AppleChainStep-card-row" *ngIf="step.NewPartnerName">
                          <span class="AppleChainStep-detail"><i class="material-icons">business</i>{{ 'ChainPartner' | translate }}: {{step.NewPartnerName}}</span>
                        </div>
                        <div class="AppleChainStep-card-row" *ngIf="step.NewDebatorPO">
                          <span class="AppleChainStep-detail"><i class="material-icons">receipt</i>{{ 'ChainDebatorPO' | translate }}: {{step.NewDebatorPO}}</span>
                        </div>
                        <div class="AppleChainStep-card-row" *ngIf="step.NewEventRegister">
                          <span class="AppleChainStep-detail"><i class="material-icons">event</i>{{ 'ChainCreated' | translate }}: {{step.NewEventRegister | date:'dd MMM yyyy HH:mm'}}</span>
                        </div>
                        <div class="AppleChainStep-card-row" *ngIf="step.NewTotalNoVAT">
                          <span class="AppleChainStep-detail"><i class="material-icons">payments</i>{{ 'ChainTotal' | translate }}: {{step.NewTotalNoVAT | number:'1.2-4'}}</span>
                        </div>
                        <div class="AppleChainStep-product" *ngIf="getChainItemQuantities(step.DBID)?.NewBrandName || getChainItemQuantities(step.DBID)?.NewProductName">
                          <span class="AppleChainStep-brand" *ngIf="getChainItemQuantities(step.DBID)?.NewBrandName">{{getChainItemQuantities(step.DBID).NewBrandName}}</span>
                          <span class="AppleChainStep-productName" *ngIf="getChainItemQuantities(step.DBID)?.NewProductName">{{getChainItemQuantities(step.DBID).NewProductName}}</span>
                          <span class="AppleChainStep-partNumber" *ngIf="getChainItemQuantities(step.DBID)?.NewPartNumber">{{getChainItemQuantities(step.DBID).NewPartNumber}}</span>
                        </div>
                        <div class="AppleChainStep-card-row" *ngIf="getChainItemQuantities(step.DBID)?.NewOrderItemQuantity">
                          <span class="AppleChainStep-qty">{{ 'Quantity' | translate }}: {{getChainItemQuantities(step.DBID).NewOrderItemQuantity}}</span>
                        </div>
                        <div class="AppleChainStep-card-row" *ngIf="getChainItemQuantities(step.DBID)?.NewUnitPrice || getChainItemQuantities(step.DBID)?.NewSellPrice">
                          <span class="AppleChainStep-detail" *ngIf="getChainItemQuantities(step.DBID)?.NewUnitPrice"><i class="material-icons">sell</i>{{ 'ChainUnitPrice' | translate }}: {{getChainItemQuantities(step.DBID).NewUnitPrice | number:'1.2-4'}}</span>
                          <span class="AppleChainStep-detail" *ngIf="getChainItemQuantities(step.DBID)?.NewSellPrice" style="margin-left:8px"><i class="material-icons">price_check</i>{{ 'ChainSellPrice' | translate }}: {{getChainItemQuantities(step.DBID).NewSellPrice | number:'1.2-4'}}</span>
                        </div>
                        <span class="AppleChainStep-date">{{step.ConnectionEventRegister | date:'dd MMM yyyy HH:mm'}}</span>
                      </div>
                    </div>
                    <div class="AppleChainStep-connector" *ngIf="!last">
                      <div class="AppleChainStep-line"></div>
                      <i class="material-icons">south</i>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </ng-container>


        <!-- Supplier Alternatives Popup (matching original) -->
        <div class="SearchResultsAlternativesContainer grid-style-popup supplier-alternatives-popup animated fadeIn"
            *ngIf="ShowProductsSupplierAlternatives === true && ProductsLoadingSideOffers !== true && (ProductsSideOffers?.length > 0 || ProductsSupplierPopupSearchTerm?.length > 0)"
            [ngStyle]="ProductsSupplierPopupPosition">

          <!-- Search Textbox -->
          <div style="padding: 8px; border-bottom: 1px solid #e0e0e0;">
            <input
              type="text"
              class="supplier-popup-search-input"
              placeholder="Search supplier..."
              [(ngModel)]="ProductsSupplierPopupSearchTerm"
              (ngModelChange)="SearchProductsSupplierPopup()"
              style="width: 100%; padding: 6px 10px; border: 1px solid #ddd; border-radius: 4px; font-size: 11px; outline: none; box-sizing: border-box;"
            />
          </div>

          <!-- Show search results when searching -->
          <div *ngIf="ProductsSupplierPopupSearchTerm?.length > 0 && ProductsSupplierPopupSearchResults?.length > 0">
            <div class="supplier-popup-item" *ngFor="let partner of ProductsSupplierPopupSearchResults" (click)="SelectProductsPartnerFromSearch(partner)">
              <div class="supplier-popup-column" style="flex: 1; padding: 8px 12px;">
                {{ partner?.Name }}
              </div>
            </div>
          </div>

          <!-- Show original side offers when NOT searching -->
          <div *ngIf="!ProductsSupplierPopupSearchTerm || ProductsSupplierPopupSearchTerm?.length === 0">
            <div class="supplier-popup-item" *ngFor="let cartItem of ProductsSideOffers" (click)="selectProductsSideOffer(cartItem)">
              <div class="supplier-popup-column supplier-name-column">
                <span *ngIf="cartItem?.SelectedOffer?.MOQ > 0">[{{ cartItem?.SelectedOffer?.MOQ }}] </span>{{ cartItem?.SelectedOffer?.Partner?.Name || 'N/A' }}
              </div>
              <div class="supplier-popup-column purchase-info-column">
                {{ cartItem?.SelectedOffer?.ListPrice || 'N/A' }} {{ cartItem?.SelectedOffer?.Currency?.Symbol || 'N/A' }}
              </div>
              <div class="supplier-popup-column stock-column">
                <span *ngIf="cartItem?.SelectedOffer?.StockQuantity > 0">STOCK</span>
              </div>
              <div class="supplier-popup-column leadtime-column">
                <span *ngIf="cartItem?.SelectedOffer?.LeadTime?.Units > 0">
                  {{ cartItem.SelectedOffer.LeadTime.Units }} {{ cartItem.SelectedOffer.LeadTime.Type?.Name || '' }}
                </span>
                <span *ngIf="!cartItem?.SelectedOffer?.LeadTime?.Units || cartItem?.SelectedOffer?.LeadTime?.Units <= 0">
                  ------
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- Loading spinner for supplier popup -->
        <div class="SearchResultsAlternativesContainer grid-style-popup supplier-alternatives-popup animated fadeIn"
            *ngIf="ShowProductsSupplierAlternatives === true && ProductsLoadingSideOffers === true"
            [ngStyle]="ProductsSupplierPopupPosition"
            style="min-height: 100px; display: flex; align-items: center; justify-content: center;">
          <mat-spinner class="smallSpinner" [diameter]="30"></mat-spinner>
        </div>

        <!-- ✅ Purchase Currency Dropdown Popup -->
        <div class="BrandCollateralContainer" *ngIf="showPurchaseCurrencyDropdown" [ngStyle]="purchaseCurrencyDropdownPosition" style="max-height: 200px; overflow-y: auto;">
          <div class="SearchResultsList" style="overflow: hidden;">
            <div *ngIf="parent.masterData?.Currencies?.length > 0">
              <div class="brand-collateral-item"
                   *ngFor="let currency of parent.masterData.Currencies"
                   (click)="selectPurchaseCurrency(currency)">
                <div style="display: flex; align-items: center; gap: 8px;">
                  <span style="font-weight: 600; min-width: 30px;">{{ currency.Symbol }}</span>
                  <span style="color: #666; font-size: 12px;">{{ currency.Name }}</span>
                </div>
              </div>
            </div>
            <div *ngIf="!parent.masterData?.Currencies?.length" style="text-align: center; padding: 20px; color: #999;">
              No currencies available
            </div>
          </div>
        </div>
      </div>

      <!-- Empty State -->
      <div class="EmptyState" *ngIf="ProductItems?.length == 0">
        <i class="material-icons">inventory_2</i>
        <span>{{ 'NoProductsFound' | translate }}</span>
      </div>
    </div>
  </div>
</div>

<!-- Delete Cart Item Confirmation Popup -->
<div class="ConvertToOrderConfirmationOverlay" *ngIf="ShowDeleteCartItemConfirmation" (click)="ShowDeleteCartItemConfirmation = false; IsMultiDelete = false;"></div>
<div class="ConvertToOrderConfirmationPopup animated fadeInDown" *ngIf="ShowDeleteCartItemConfirmation">
  <div class="ConvertPopupHeader">
    <div class="ConvertPopupIconWrapper" style="background: #d32f2f;">
      <i class="material-icons">delete</i>
    </div>
    <div class="ConvertPopupHeaderText">
      <span class="ConvertPopupTitle" *ngIf="!IsMultiDelete">{{ 'DeleteCartItem' | translate }}</span>
      <span class="ConvertPopupTitle" *ngIf="IsMultiDelete">{{ 'DeleteCartItems' | translate }}</span>
    </div>
    <i class="material-icons ConvertPopupClose" (click)="ShowDeleteCartItemConfirmation = false; IsMultiDelete = false;">close</i>
  </div>
  <div class="ConvertPopupBody">
    <p class="ConvertPopupMessage" *ngIf="!IsMultiDelete">{{ 'DeleteCartItemConfirmation' | translate }}</p>
    <p class="ConvertPopupMessage" *ngIf="IsMultiDelete">{{ 'DeleteCartItemsConfirmation' | translate }}</p>
  </div>
  <div class="ConvertPopupFooter">
    <div class="GridCommandButton" [class.disabled]="this.parent.loading" (click)="ShowDeleteCartItemConfirmation = false; IsMultiDelete = false;">
      <i class="material-icons">close</i>
      <span>{{ 'No' | translate }}</span>
    </div>
    <div class="GridCommandButton GridCommandButtonRed" [class.disabled]="this.parent.loading" (click)="ConfirmDeleteCartItem();">
      <i class="material-icons" *ngIf="!this.parent.loading">check</i>
      <span *ngIf="!this.parent.loading">{{ 'Yes' | translate }}</span>
      <mat-spinner *ngIf="this.parent.loading" diameter="18"></mat-spinner>
    </div>
  </div>
</div>

<!-- Change Partner Confirmation Popup -->
<div class="ConvertToOrderConfirmationOverlay" *ngIf="ShowChangePartnerConfirmation" (click)="cancelChangePartner()"></div>
<div class="ConvertToOrderConfirmationPopup animated fadeInDown" *ngIf="ShowChangePartnerConfirmation">
  <div class="ConvertPopupHeader">
    <div class="ConvertPopupIconWrapper" style="background: #1976d2;">
      <i class="material-icons">swap_horiz</i>
    </div>
    <div class="ConvertPopupHeaderText">
      <span class="ConvertPopupTitle">{{ 'ChangePartner' | translate }}</span>
    </div>
    <i class="material-icons ConvertPopupClose" (click)="cancelChangePartner()">close</i>
  </div>
  <div class="ConvertPopupBody">
    <p class="ConvertPopupMessage">{{ 'ChangePartnerConfirmation' | translate }}</p>
    <p class="ConvertPopupMessage" *ngIf="PendingPartnerChange?.Name"><strong>{{ PendingPartnerChange.Name }}</strong></p>
  </div>
  <div class="ConvertPopupFooter">
    <div class="GridCommandButton" [class.disabled]="this.parent.loading" (click)="cancelChangePartner()">
      <i class="material-icons">close</i>
      <span>{{ 'No' | translate }}</span>
    </div>
    <div class="GridCommandButton GridCommandButtonGreen" [class.disabled]="this.parent.loading" (click)="confirmChangePartner()">
      <i class="material-icons" *ngIf="!this.parent.loading">check</i>
      <span *ngIf="!this.parent.loading">{{ 'Yes' | translate }}</span>
      <mat-spinner *ngIf="this.parent.loading" diameter="18"></mat-spinner>
    </div>
  </div>
</div>

<!-- Progress Status Right-Click Popup -->
<div class="progress-status-cell-popup" *ngIf="showProgressStatusCellPopup"
     [style.top]="progressStatusPopupPosition.top"
     [style.left]="progressStatusPopupPosition.left">
  <div class="progress-status-cell-popup-overlay" (click)="closeProgressStatusCellPopup()"></div>
  <div class="progress-status-cell-popup-content">
    <div class="progress-status-cell-popup-item"
         *ngFor="let status of MasterData?.CartItemProgressStatuses"
         (click)="selectProgressStatusForCartItem(status)"
         [class.selected]="progressStatusPopupCartItem?.ProgressStatus?.ID === status.ID">
      <span>{{ status.Name }}</span>
      <i class="material-icons" *ngIf="progressStatusPopupCartItem?.ProgressStatus?.ID === status.ID">check</i>
    </div>
  </div>
</div>

<!-- DeliveryPreference Right-Click Popup -->
<div class="progress-status-cell-popup" *ngIf="showDeliveryPreferencePopup"
     [style.top]="deliveryPreferencePopupPosition.top"
     [style.left]="deliveryPreferencePopupPosition.left">
  <div class="progress-status-cell-popup-overlay" (click)="closeDeliveryPreferencePopup()"></div>
  <div class="progress-status-cell-popup-content">
    <div class="progress-status-cell-popup-item"
         *ngFor="let dp of MasterData?.OrderDeliveryPreferences"
         (click)="selectDeliveryPreferenceForCartItem(dp)"
         [class.selected]="deliveryPreferencePopupCartItem?.DeliveryPreference?.ID === dp.ID">
      <span>{{ dp.Name }}</span>
      <i class="material-icons" *ngIf="deliveryPreferencePopupCartItem?.DeliveryPreference?.ID === dp.ID">check</i>
    </div>
  </div>
</div>

<!-- ConsolidationType Right-Click Popup -->
<div class="progress-status-cell-popup" *ngIf="showConsolidationTypePopup"
     [style.top]="consolidationTypePopupPosition.top"
     [style.left]="consolidationTypePopupPosition.left">
  <div class="progress-status-cell-popup-overlay" (click)="closeConsolidationTypePopup()"></div>
  <div class="progress-status-cell-popup-content">
    <div class="progress-status-cell-popup-item"
         *ngFor="let ct of MasterData?.OrderConsolidationTypes"
         (click)="selectConsolidationTypeForCartItem(ct)"
         [class.selected]="consolidationTypePopupCartItem?.ConsolidationType?.ID === ct.ID">
      <span>{{ ct.Name }}</span>
      <i class="material-icons" *ngIf="consolidationTypePopupCartItem?.ConsolidationType?.ID === ct.ID">check</i>
    </div>
  </div>
</div>

<!-- Full Delivery Conflict Popup -->
<div class="BatchAddrEditPopupOverlay" *ngIf="showFullDeliveryConflictPopup" (click)="showFullDeliveryConflictPopup = false"></div>
<div class="BatchAddrEditPopup" *ngIf="showFullDeliveryConflictPopup" style="width:580px;max-width:96vw;">
  <div class="BatchPopupHeader">
    <div class="BatchPopupIconWrapper" style="background:linear-gradient(135deg,#ff9800,#f57c00);">
      <i class="material-icons">warning</i>
    </div>
    <div class="BatchPopupHeaderText">
      <div class="BatchPopupTitle">{{ 'FullDeliveryConflict' | translate }}</div>
      <div class="BatchPopupSubtitle" style="background:#fff3e0;color:#e65100;">{{ fullDeliveryConflicts?.length }} {{ 'OrdersAffected' | translate }}</div>
    </div>
    <button class="BatchPopupCloseBtn" (click)="showFullDeliveryConflictPopup = false"><i class="material-icons">close</i></button>
  </div>
  <div class="BatchAddrEditPopupBody" style="max-height:55vh;overflow-y:auto;">
    <p style="font-size:11px;color:#86868b;margin:0 0 14px;line-height:1.5;">{{ 'FullDeliveryConflictDesc' | translate }}</p>
    <div *ngFor="let conflict of fullDeliveryConflicts" style="margin-bottom:16px;border:1px solid #e8ecf0;border-radius:8px;overflow:hidden;">
      <div style="padding:8px 12px;background:#f8f9fa;font-size:12px;font-weight:600;color:#1a3a5c;display:flex;align-items:center;gap:6px;border-bottom:1px solid #e8ecf0;">
        <i class="material-icons" style="font-size:16px;color:#f57c00;">assignment</i>
        {{ conflict.ReferenceNumber }} — {{ conflict.PartnerName }}
      </div>
      <div style="padding:10px 12px;">
        <!-- Selected Items (already in the user's selection) -->
        <div style="font-size:10px;font-weight:600;color:#43a047;text-transform:uppercase;letter-spacing:0.4px;margin-bottom:4px;">
          <i class="material-icons" style="font-size:12px;vertical-align:-2px;">check_circle</i>
          {{ 'SelectedItems' | translate }} ({{ conflict.ReadyItems?.length }})
        </div>
        <table style="width:100%;border-collapse:collapse;margin-bottom:10px;font-size:11px;">
          <tr *ngFor="let item of conflict.ReadyItems">
            <td style="padding:3px 6px 3px 0;color:#1d1d1f;">{{ item.ProductName }}</td>
            <td style="padding:3px 0;color:#86868b;text-align:right;white-space:nowrap;width:50px;">x{{ item.Quantity }}</td>
          </tr>
        </table>

        <!-- Unselected Ready Items (ready but user forgot to select them) -->
        <ng-container *ngIf="conflict.UnselectedReadyItems?.length > 0">
          <div style="font-size:10px;font-weight:600;color:#1565c0;text-transform:uppercase;letter-spacing:0.4px;margin-bottom:4px;">
            <i class="material-icons" style="font-size:12px;vertical-align:-2px;">playlist_add</i>
            {{ 'UnselectedReadyItems' | translate }} ({{ conflict.UnselectedReadyItems?.length }})
          </div>
          <p style="font-size:10px;color:#1565c0;margin:0 0 6px;line-height:1.4;font-style:italic;">{{ 'UnselectedReadyItemsDesc' | translate }}</p>
          <table style="width:100%;border-collapse:collapse;margin-bottom:10px;font-size:11px;">
            <tr *ngFor="let item of conflict.UnselectedReadyItems" style="background:#e3f2fd;">
              <td style="padding:3px 6px 3px 6px;color:#1565c0;font-weight:500;">{{ item.ProductName }}</td>
              <td style="padding:3px 4px;color:#1565c0;font-size:10px;white-space:nowrap;">{{ item.ProgressStatusName }}</td>
              <td style="padding:3px 6px 3px 0;color:#1565c0;text-align:right;white-space:nowrap;width:50px;">x{{ item.Quantity }}</td>
            </tr>
          </table>
        </ng-container>

        <!-- Not Ready Items (truly missing — not in warehouse yet) -->
        <ng-container *ngIf="conflict.NotReadyItems?.length > 0">
          <div style="font-size:10px;font-weight:600;color:#e53935;text-transform:uppercase;letter-spacing:0.4px;margin-bottom:4px;">
            <i class="material-icons" style="font-size:12px;vertical-align:-2px;">error_outline</i>
            {{ 'NotReadyItems' | translate }} ({{ conflict.NotReadyItems?.length }})
          </div>
          <p style="font-size:10px;color:#e53935;margin:0 0 6px;line-height:1.4;font-style:italic;">{{ 'NotReadyItemsDesc' | translate }}</p>
          <table style="width:100%;border-collapse:collapse;font-size:11px;">
            <tr *ngFor="let item of conflict.NotReadyItems">
              <td style="padding:3px 6px 3px 0;color:#1d1d1f;">{{ item.ProductName }}</td>
              <td style="padding:3px 4px;color:#e53935;font-size:10px;white-space:nowrap;">{{ item.ProgressStatusName }}</td>
              <td style="padding:3px 0;color:#86868b;text-align:right;white-space:nowrap;width:50px;">x{{ item.Quantity }}</td>
            </tr>
          </table>
        </ng-container>
      </div>
    </div>
  </div>
  <div class="BatchAddrEditPopupFooter" style="gap:10px;">
    <!-- Case 1: Only UnselectedReady items (no NotReady) → offer to include them -->
    <ng-container *ngIf="hasOnlyUnselectedReadyConflicts()">
      <button class="BatchAddrEditorCancel" (click)="fullDeliveryProcessOnlySelected()">
        <i class="material-icons" style="font-size:15px;">arrow_forward</i>
        <span>{{ 'ProcessOnlySelected' | translate }}</span>
      </button>
      <button class="BatchAddrEditorSave" style="background:#1565c0;" (click)="fullDeliveryIncludeReadyItems()">
        <i class="material-icons" style="font-size:15px;">playlist_add_check</i>
        <span>{{ 'IncludeAllReadyItems' | translate }}</span>
      </button>
    </ng-container>
    <!-- Case 2: Has NotReady items (with or without UnselectedReady) → warn + options -->
    <ng-container *ngIf="!hasOnlyUnselectedReadyConflicts()">
      <button class="BatchAddrEditorCancel" (click)="fullDeliveryRemoveConflicts()">
        <i class="material-icons" style="font-size:15px;color:#e53935;">remove_circle_outline</i>
        <span>{{ 'RemoveAndProcessRest' | translate }}</span>
      </button>
      <button class="BatchAddrEditorSave" style="background:#f57c00;" (click)="fullDeliveryIncludeAnyway()">
        <i class="material-icons" style="font-size:15px;">check_circle</i>
        <span>{{ 'IncludeAnyway' | translate }}</span>
      </button>
    </ng-container>
  </div>
</div>

<!-- Dispatch Immediately Popup -->
<div class="BatchAddrEditPopupOverlay" *ngIf="showDispatchImmediatelyPopup" (click)="dispatchImmediatelyNo()"></div>
<div class="BatchAddrEditPopup" *ngIf="showDispatchImmediatelyPopup" style="width:480px;">
  <div class="BatchPopupHeader">
    <div class="BatchPopupIconWrapper">
      <i class="material-icons">flash_on</i>
    </div>
    <div class="BatchPopupHeaderText">
      <div class="BatchPopupTitle">{{ 'DispatchImmediatelyTitle' | translate }}</div>
      <div class="BatchPopupSubtitle">{{ dispatchImmediatelyItems?.length }} {{ 'ItemsFound' | translate }}</div>
    </div>
    <button class="BatchPopupCloseBtn" (click)="dispatchImmediatelyNo()"><i class="material-icons">close</i></button>
  </div>
  <div class="BatchAddrEditPopupBody" style="max-height:50vh;overflow-y:auto;">
    <p style="font-size:11px;color:#86868b;margin:0 0 14px;line-height:1.5;">{{ 'DispatchImmediatelyDesc' | translate }}</p>
    <table style="width:100%;border-collapse:collapse;font-size:11px;">
      <tr style="border-bottom:1px solid #e0e0e0;">
        <th style="padding:6px 4px 6px 0;text-align:left;color:#86868b;font-weight:500;font-size:10px;text-transform:uppercase;letter-spacing:0.3px;" width="28">#</th>
        <th style="padding:6px 4px;text-align:left;color:#86868b;font-weight:500;font-size:10px;text-transform:uppercase;letter-spacing:0.3px;">{{ 'Product' | translate }}</th>
        <th style="padding:6px 4px;text-align:center;color:#86868b;font-weight:500;font-size:10px;text-transform:uppercase;letter-spacing:0.3px;" width="40">{{ 'Qty' | translate }}</th>
        <th style="padding:6px 0 6px 4px;text-align:left;color:#86868b;font-weight:500;font-size:10px;text-transform:uppercase;letter-spacing:0.3px;" width="100">{{ 'OurReference' | translate }}</th>
      </tr>
      <tr *ngFor="let ci of dispatchImmediatelyItems; let i = index" style="border-bottom:1px solid #f5f5f7;">
        <td style="padding:5px 4px 5px 0;color:#86868b;font-size:10px;">{{ i + 1 }}</td>
        <td style="padding:5px 4px;color:#1d1d1f;">{{ ci.Product?.Name || ci.Product?.PartNumber || '-' }}</td>
        <td style="padding:5px 4px;color:#1d1d1f;text-align:center;">{{ ci.Quantity }}</td>
        <td style="padding:5px 0 5px 4px;color:#86868b;font-size:10px;">{{ ci.CartItemOrderInfo?.ReferenceNumber || ci.CartItemOrderInfo?.OrderID || '-' }}</td>
      </tr>
    </table>
  </div>
  <div class="BatchAddrEditPopupFooter" style="gap:10px;">
    <button class="BatchAddrEditorCancel" (click)="dispatchImmediatelyNo()">
      <i class="material-icons" style="font-size:15px;">close</i>
      <span>{{ 'No' | translate }}</span>
    </button>
    <button class="BatchAddrEditorSave" (click)="dispatchImmediatelyYes()">
      <i class="material-icons" style="font-size:15px;">flash_on</i>
      <span>{{ 'YesSeparateExpress' | translate }}</span>
    </button>
  </div>
</div>

<!-- Edit Shipping Address Popup -->
<div class="BatchAddrEditPopupOverlay" *ngIf="showBatchAddressEditPopup" (click)="closeBatchAddressEditor()"></div>
<div class="BatchAddrEditPopup" *ngIf="showBatchAddressEditPopup">
  <div class="BatchPopupHeader">
    <div class="BatchPopupIconWrapper" style="background:#4a7bb8;">
      <i class="material-icons">edit_location</i>
    </div>
    <div class="BatchPopupHeaderText">
      <div class="BatchPopupTitle">{{ 'EditShippingAddress' | translate }}</div>
      <div class="BatchPopupSubtitle" *ngIf="batchAddressEditing?.ContactCompany">{{ batchAddressEditing.ContactCompany }}</div>
    </div>
    <button class="BatchPopupCloseBtn" (click)="closeBatchAddressEditor()"><i class="material-icons">close</i></button>
  </div>
  <div class="BatchAddrEditPopupBody">
    <div class="BatchAddrEditSection">
      <div class="BatchAddrEditSectionTitle"><i class="material-icons">business</i> {{ 'Company' | translate }}</div>
      <div class="BatchAddrEditorRow">
        <div class="BatchAddrEditorField">
          <label>{{ 'Company' | translate }}</label>
          <input type="text" [(ngModel)]="batchAddressEditing.ContactCompany">
        </div>
        <div class="BatchAddrEditorField">
          <label>{{ 'Partners.PartnerWindow.ContactInfo' | translate }}</label>
          <input type="text" [(ngModel)]="batchAddressEditing.ContactPerson">
        </div>
      </div>
    </div>
    <div class="BatchAddrEditSection">
      <div class="BatchAddrEditSectionTitle"><i class="material-icons">location_on</i> {{ 'Partners.PartnerWindow.AddressLine' | translate }}</div>
      <div class="BatchAddrEditorField" style="margin-bottom:8px;">
        <label>{{ 'Partners.PartnerWindow.AddressLine' | translate }}</label>
        <input type="text" [(ngModel)]="batchAddressEditing.AddressLine">
      </div>
      <div class="BatchAddrEditorRow">
        <div class="BatchAddrEditorField">
          <label>{{ 'Partners.PartnerWindow.City' | translate }}</label>
          <input type="text" [(ngModel)]="batchAddressEditing.City">
        </div>
        <div class="BatchAddrEditorField">
          <label>{{ 'ZipCode' | translate }}</label>
          <input type="text" [(ngModel)]="batchAddressEditing.ZipCode">
        </div>
      </div>
      <div class="BatchAddrEditorRow">
        <div class="BatchAddrEditorField">
          <label>{{ 'StateProvince' | translate }}</label>
          <input type="text" [(ngModel)]="batchAddressEditing.State">
        </div>
        <div class="BatchAddrEditorField">
          <label>{{ 'Country' | translate }}</label>
          <input type="text" disabled [value]="batchAddressEditing?.Country?.Name || '-'" style="background:#f5f5f7;color:#86868b;">
        </div>
      </div>
    </div>
    <div class="BatchAddrEditSection">
      <div class="BatchAddrEditSectionTitle"><i class="material-icons">person</i> {{ 'Partners.PartnerWindow.ContactInfo' | translate }}</div>
      <div class="BatchAddrEditorRow">
        <div class="BatchAddrEditorField">
          <label>{{ 'Phone' | translate }}</label>
          <input type="text" [(ngModel)]="batchAddressEditing.Phone">
        </div>
        <div class="BatchAddrEditorField">
          <label>{{ 'Email' | translate }}</label>
          <input type="text" [(ngModel)]="batchAddressEditing.Email">
        </div>
      </div>
    </div>
  </div>
  <div class="BatchAddrEditPopupFooter">
    <button class="BatchAddrEditorCancel" (click)="closeBatchAddressEditor()">
      <i class="material-icons">close</i>
      <span>{{ 'Cancel' | translate }}</span>
    </button>
    <button class="BatchAddrEditorSave" [disabled]="savingBatchAddress" (click)="saveBatchAddress()">
      <mat-spinner *ngIf="savingBatchAddress" diameter="14"></mat-spinner>
      <i class="material-icons" *ngIf="!savingBatchAddress">save</i>
      <span>{{ 'SaveButton' | translate }}</span>
    </button>
  </div>
</div>

<!-- Invoice Popup (double-click on INV status) -->
<div class="InvoicePopupOverlay" *ngIf="showInvoicePopup" (click)="showInvoicePopup = false"></div>
<div class="InvoicePopupContainer" *ngIf="showInvoicePopup">
  <div class="BatchPopupHeader">
    <div class="BatchPopupIconWrapper">
      <i class="material-icons">receipt</i>
    </div>
    <div class="BatchPopupHeaderText">
      <div class="BatchPopupTitle">{{ (invoicePopupInvoices?.length > 1 ? 'LinkedInvoices' : 'LinkedInvoice') | translate }}</div>
      <div class="BatchPopupSubtitle" *ngIf="invoicePopupInvoices?.length > 0">{{ invoicePopupInvoices.length }} {{ (invoicePopupInvoices.length > 1 ? 'Invoices' : 'Invoice') | translate }}</div>
    </div>
    <button class="BatchPopupCloseBtn" (click)="showInvoicePopup = false"><i class="material-icons">close</i></button>
  </div>

  <div class="BatchPopupBody" style="max-height: 400px; overflow-y: auto;">
    <!-- Loading -->
    <div *ngIf="invoicePopupLoading" style="display: flex; align-items: center; justify-content: center; padding: 40px;">
      <mat-spinner diameter="28"></mat-spinner>
    </div>

    <!-- Invoice List -->
    <div *ngIf="!invoicePopupLoading && invoicePopupInvoices?.length > 0">
      <div class="ResultBatchCard" *ngFor="let inv of invoicePopupInvoices; let i = index" [style.margin-bottom]="invoicePopupInvoices.length > 1 ? '10px' : '0'">
        <div class="ResultBatchHeader">
          <div class="ResultBatchHeaderLeft">
            <i class="material-icons" style="color: #4caf50;">check_circle</i>
            <span class="ResultBatchPartner">{{ inv.AccountingNumberDisplayValue }}</span>
            <span class="ResultBatchBadge badge-success">{{'Invoiced' | translate}}</span>
          </div>
        </div>

        <div class="ResultBatchSection">
          <div class="ResultStepRow">
            <i class="material-icons ResultStepIcon" style="color: #1565c0;">calendar_today</i>
            <span class="ResultStepName">{{'DocumentDate' | translate}}</span>
            <span class="ResultStepMessage" style="text-align: right;">{{ inv.DocumentDate | date:'dd MMM yyyy' }}</span>
          </div>
          <div class="ResultStepRow" *ngIf="inv.TotalQtyPriceVAT">
            <i class="material-icons ResultStepIcon" style="color: #00a79d;">payments</i>
            <span class="ResultStepName">{{'Total' | translate}}</span>
            <span class="ResultStepMessage" style="text-align: right; font-weight: 700; color: #1a3a5c;">{{ inv.TotalQtyPriceVAT | number:'1.2-4' }} {{ inv.CurrencySymbol || inv.CurrencyName }}</span>
          </div>
        </div>

        <!-- Actions -->
        <div class="InvoicePopupActions">
          <button class="InvoicePopupBtn InvoicePopupBtnPrint" (click)="printInvoicePopupItem(inv)" [disabled]="inv._loading">
            <i class="material-icons">print</i>
            <span>{{'PrintInvoice' | translate}}</span>
          </button>
          <button class="InvoicePopupBtn InvoicePopupBtnDownload" (click)="downloadInvoicePopupItem(inv)" [disabled]="inv._loading">
            <i class="material-icons">download</i>
            <span>{{'DownloadInvoice' | translate}}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Split Product Right-Click Popup (Context Menu) -->
<div class="progress-status-cell-popup" *ngIf="showSplitProductPopup"
     [style.top]="splitProductPopupPosition.top"
     [style.left]="splitProductPopupPosition.left">
  <div class="progress-status-cell-popup-overlay" (click)="closeSplitProductPopup()"></div>
  <div class="progress-status-cell-popup-content" style="min-width: 120px;">
    <div class="progress-status-cell-popup-item" (click)="openSplitProductDialog()">
      <i class="material-icons" style="font-size: 14px; margin-right: 6px;">call_split</i>
      <span>{{ 'SplitProduct' | translate }}</span>
    </div>
  </div>
</div>

<!-- Split Product Dialog Popup -->
<div class="ConvertToOrderConfirmationOverlay" *ngIf="showSplitProductDialog" (click)="closeSplitProductDialog()"></div>
<div class="ConvertToOrderConfirmationPopup animated fadeInDown" *ngIf="showSplitProductDialog" style="width: 380px; left: calc(50% - 190px); top: 25%;">
  <div class="ConvertPopupHeader">
    <div class="ConvertPopupIconWrapper" style="background: #9c27b0;">
      <i class="material-icons">call_split</i>
    </div>
    <div class="ConvertPopupHeaderText">
      <span class="ConvertPopupTitle">{{ 'SplitProduct' | translate }}</span>
      <span class="ConvertPopupRef">{{ splitProductCartItem?.Product?.PartNumber || splitProductCartItem?.Product?.Name }}</span>
    </div>
    <i class="material-icons ConvertPopupClose" (click)="closeSplitProductDialog()">close</i>
  </div>
  <div class="ConvertPopupBody" style="padding: 20px;">
    <div style="margin-bottom: 16px;">
      <label style="font-size: 12px; color: #666; display: block; margin-bottom: 4px;">{{ 'OriginalQuantity' | translate }} ({{ 'Total' | translate }}: {{ splitProductOriginalQty }})</label>
      <input type="number" [(ngModel)]="splitProductQty1" (ngModelChange)="onSplitQty1Change($event)"
             min="1" [max]="splitProductOriginalQty - 1" step="1"
             style="width: 100%; padding: 10px; border: 1px solid #ddd; border-radius: 4px; font-size: 14px; text-align: center;">
    </div>
    <div style="margin-bottom: 16px;">
      <label style="font-size: 12px; color: #666; display: block; margin-bottom: 4px;">{{ 'SplitQuantity' | translate }}</label>
      <input type="number" [(ngModel)]="splitProductQty2" (ngModelChange)="onSplitQty2Change($event)"
             min="0" [max]="splitProductOriginalQty - 1" step="1"
             style="width: 100%; padding: 10px; border: 1px solid #ddd; border-radius: 4px; font-size: 14px; text-align: center;">
    </div>
    <div style="font-size: 11px; color: #888; text-align: center; margin-bottom: 8px;">
      {{ splitProductQty1 }} + {{ splitProductQty2 }} = {{ splitProductOriginalQty }}
    </div>

    <!-- Loading associations spinner -->
    <div *ngIf="splitProductLoadingAssociations" style="text-align: center; padding: 8px 0;">
      <mat-spinner diameter="18" style="margin: 0 auto;"></mat-spinner>
    </div>

    <!-- Invoice & Shipping warnings -->
    <div *ngIf="!splitProductLoadingAssociations && (splitProductInvoices?.length > 0 || splitProductShippingData?.length > 0)"
         style="background: #fff8e1; border: 1px solid #ffe082; border-radius: 6px; padding: 12px; margin-bottom: 8px;">
      <div style="display: flex; align-items: center; gap: 6px; margin-bottom: 8px;">
        <i class="material-icons" style="font-size: 18px; color: #f57c00;">warning</i>
        <span style="font-size: 12px; font-weight: 600; color: #e65100;">{{ 'SplitProductWarning' | translate }}</span>
      </div>

      <!-- Invoice associations -->
      <div *ngIf="splitProductInvoices?.length > 0" style="margin-bottom: 6px;">
        <div style="font-size: 11px; font-weight: 600; color: #555; margin-bottom: 4px;">
          <i class="material-icons" style="font-size: 14px; vertical-align: middle; margin-right: 4px;">receipt</i>
          {{ 'SplitProductInvoiceLabel' | translate }}
        </div>
        <div *ngFor="let inv of splitProductInvoices"
             style="font-size: 11px; color: #333; padding: 3px 0 3px 22px; border-bottom: 1px solid #f0e6c8;">
          <span style="font-weight: 600;">{{ inv.AccountingNumberDisplayValue }}</span>
          <span style="margin-left: 6px; color: #888;">{{ inv.DocumentDate | date:'yyyy-MM-dd' }}</span>
        </div>
      </div>

      <!-- Shipping/Tracking associations -->
      <div *ngIf="splitProductShippingData?.length > 0" style="margin-bottom: 6px;">
        <div style="font-size: 11px; font-weight: 600; color: #555; margin-bottom: 4px;">
          <i class="material-icons" style="font-size: 14px; vertical-align: middle; margin-right: 4px;">local_shipping</i>
          {{ 'SplitProductTrackingLabel' | translate }}
        </div>
        <div *ngFor="let sd of splitProductShippingData"
             style="font-size: 11px; color: #333; padding: 3px 0 3px 22px; border-bottom: 1px solid #f0e6c8;">
          <span style="font-weight: 600;">{{ sd.TrackingNumber }}</span>
        </div>
      </div>

      <!-- Clarification: original keeps associations -->
      <div style="font-size: 10px; color: #795548; margin-top: 6px; line-height: 1.4;">
        <i class="material-icons" style="font-size: 12px; vertical-align: middle; margin-right: 2px;">info_outline</i>
        {{ 'SplitProductAssociationNote' | translate:{ qty: splitProductQty1 } }}
      </div>
    </div>

  </div>
  <div class="ConvertPopupFooter">
    <div class="GridCommandButton" [class.disabled]="this.parent.loading" (click)="closeSplitProductDialog()">
      <i class="material-icons">close</i>
      <span>{{ 'Cancel' | translate }}</span>
    </div>
    <div class="GridCommandButton GridCommandButtonGreen"
         [class.disabled]="this.parent.loading || splitProductQty2 <= 0 || splitProductQty1 <= 0"
         (click)="confirmSplitProduct()">
      <i class="material-icons" *ngIf="!this.parent.loading">check</i>
      <span *ngIf="!this.parent.loading">{{ 'SplitProduct' | translate }}</span>
      <mat-spinner *ngIf="this.parent.loading" diameter="18"></mat-spinner>
    </div>
  </div>
</div>

<!-- Export Products Popup -->
<div class="ConvertToOrderConfirmationOverlay" *ngIf="showExportDialog" (click)="closeExportDialog()"></div>
<div class="ConvertToOrderConfirmationPopup animated fadeInDown" *ngIf="showExportDialog" style="width: 400px; left: calc(50% - 200px); top: 20%;">
  <div class="ConvertPopupHeader">
    <div class="ConvertPopupIconWrapper" style="background: #00c9bd;">
      <i class="material-icons">file_download</i>
    </div>
    <div class="ConvertPopupHeaderText">
      <span class="ConvertPopupTitle">Export Products</span>
      <span class="ConvertPopupRef">Select columns to export</span>
    </div>
    <i class="material-icons ConvertPopupClose" (click)="closeExportDialog()">close</i>
  </div>
  <div class="ConvertPopupBody" style="padding: 20px; max-height: 400px; overflow-y: auto;">
    <div style="padding: 8px 0; border-bottom: 1px solid #eee; margin-bottom: 12px;">
      <label style="display: flex; align-items: center; cursor: pointer;">
        <input type="checkbox" [checked]="allExportProductColumnsSelected" (change)="toggleAllExportProductColumns($event)" style="width: 16px; height: 16px; cursor: pointer;">
        <span style="margin-left: 10px; font-weight: 600; color: #1a3a5c;">Select All</span>
      </label>
    </div>
    <div *ngFor="let col of exportableColumns" style="padding: 6px 0;">
      <label style="display: flex; align-items: center; cursor: pointer;">
        <input type="checkbox" [(ngModel)]="col.selected" style="width: 16px; height: 16px; cursor: pointer;">
        <span style="margin-left: 10px; color: #333;">{{ col.label }}</span>
      </label>
    </div>
  </div>
  <div class="ConvertPopupFooter">
    <div class="GridCommandButton" [class.disabled]="exporting" (click)="closeExportDialog()">
      <i class="material-icons">close</i>
      <span>{{ 'Cancel' | translate }}</span>
    </div>
    <div class="GridCommandButton GridCommandButtonGreen"
         [class.disabled]="exporting || !hasSelectedExportColumns()"
         (click)="exportProducts()">
      <i class="material-icons" *ngIf="!exporting">file_download</i>
      <span *ngIf="!exporting">Export</span>
      <mat-spinner *ngIf="exporting" diameter="18"></mat-spinner>
    </div>
  </div>
</div>

<!-- Package List Popup -->
<div class="ConvertToOrderConfirmationOverlay" *ngIf="showPackageListDialog" (click)="closePackageListDialog()"></div>
<div class="ConvertToOrderConfirmationPopup animated fadeInDown" *ngIf="showPackageListDialog" style="width: 400px; left: calc(50% - 200px); top: 20%;">
  <div class="ConvertPopupHeader">
    <div class="ConvertPopupIconWrapper" style="background: #254a91;">
      <i class="material-icons">inventory_2</i>
    </div>
    <div class="ConvertPopupHeaderText">
      <span class="ConvertPopupTitle">Package List</span>
      <span class="ConvertPopupRef">Select document variant</span>
    </div>
    <i class="material-icons ConvertPopupClose" (click)="closePackageListDialog()">close</i>
  </div>
  <div class="ConvertPopupBody" style="padding: 20px;">
    <div style="margin-bottom: 12px; font-weight: 500; color: #333;">Choose Variant:</div>
    <div style="padding: 8px 0;">
      <label style="display: flex; align-items: center; cursor: pointer; padding: 10px; border-radius: 4px; transition: background 0.2s;"
             [style.background]="packageListVariant === 'showSupplier' ? '#e3f2fd' : 'transparent'">
        <input type="radio" name="packageListVariant" value="showSupplier"
               [(ngModel)]="packageListVariant"
               style="width: 18px; height: 18px; cursor: pointer;">
        <span style="margin-left: 12px; color: #333;">Show Supplier</span>
      </label>
    </div>
    <div style="padding: 8px 0;">
      <label style="display: flex; align-items: center; cursor: pointer; padding: 10px; border-radius: 4px; transition: background 0.2s;"
             [style.background]="packageListVariant === 'confidential' ? '#e3f2fd' : 'transparent'">
        <input type="radio" name="packageListVariant" value="confidential"
               [(ngModel)]="packageListVariant"
               style="width: 18px; height: 18px; cursor: pointer;">
        <span style="margin-left: 12px; color: #333;">Confidential (DO NOT Show Supplier)</span>
      </label>
    </div>
  </div>
  <div class="ConvertPopupFooter">
    <div class="GridCommandButton" [class.disabled]="generatingPackageList" (click)="closePackageListDialog()">
      <i class="material-icons">close</i>
      <span>{{ 'Cancel' | translate }}</span>
    </div>
    <div class="GridCommandButton GridCommandButtonGreen"
         [class.disabled]="generatingPackageList"
         (click)="generatePackageList()">
      <i class="material-icons" *ngIf="!generatingPackageList">picture_as_pdf</i>
      <span *ngIf="!generatingPackageList">Generate</span>
      <mat-spinner *ngIf="generatingPackageList" diameter="18"></mat-spinner>
    </div>
  </div>
</div>

<!-- Agent Phases Popup (root level, above everything) -->
<div class="AgentPhasesPopupOverlay" *ngIf="showAgentPhasesPopup" (click)="closeAgentPhasesPopup()">
  <div class="AgentPhasesPopupCard animated fadeIn" (click)="$event.stopPropagation()">
    <div class="AgentPhasesPopupHeader">
      <div class="AgentPhasesPopupHeaderLeft">
        <i class="material-icons">tune</i>
        <span>{{'SelectNotificationPhases' | translate}} — {{selectedPhaseAgent?.Email}}</span>
      </div>
      <button class="AgentPhasesCloseBtn" (click)="closeAgentPhasesPopup()">
        <i class="material-icons">close</i>
      </button>
    </div>
    <div class="AgentPhasesPopupBody">
      <p class="AgentPhasesExplanation">
        <i class="material-icons">info_outline</i>
        {{ 'NotificationPhasesExplanation' | translate }}
      </p>
      <div class="AgentPhaseOption" *ngFor="let phase of agentOrderPhasesMasterData"
           [class.selected]="isAgentPhaseSelected(phase)"
           (click)="toggleAgentPhaseInPopup(phase)">
        <div class="AgentPhaseOptionRow">
          <i class="material-icons">{{ isAgentPhaseSelected(phase) ? 'check_circle' : 'radio_button_unchecked' }}</i>
          <span class="AgentPhaseOptionName">{{phase.Name}}</span>
        </div>
        <p class="AgentPhaseOptionDesc">{{phase.Description}}</p>
      </div>
    </div>
    <div class="AgentPhasesPopupFooter">
      <button class="AgentPhasesSaveBtn" (click)="saveAgentPhases()" [disabled]="savingAgentPhases">
        <i class="material-icons">save</i>
        <span>{{'Save' | translate}}</span>
      </button>
    </div>
  </div>
</div>